import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type AddCandidateProgramRequirementInput = {
  key: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Float'];
  paymentStripeProductId?: InputMaybe<Scalars['String']>;
  paymentStripeProductName?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<ProgramStageRequirementPaymentType>;
  questionType?: InputMaybe<ProgramStageRequirementQuestionType>;
  required: Scalars['Boolean'];
  type: ProgramStageRequirementType;
};

export type AddCandidateProgramStageInput = {
  name: Scalars['String'];
  order: Scalars['Float'];
};

export type AddressDto = {
  __typename?: 'AddressDto';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type AdvisorProfileDto = {
  __typename?: 'AdvisorProfileDto';
  about?: Maybe<Scalars['String']>;
  calendlyLink?: Maybe<Scalars['String']>;
  phone?: Maybe<PhoneNumberDto>;
  role?: Maybe<Scalars['String']>;
  skills: Array<ProfileSkillDto>;
  socialLinks?: Maybe<ProfileSocialLinksDto>;
};

export type AssignAdvisorToCandidateInput = {
  advisorId: Scalars['String'];
  candidateId: Scalars['String'];
};

export type AssignAdvisorToCandidatesInput = {
  advisorId: Scalars['String'];
  candidateIds: Array<Scalars['String']>;
  removeExistingAssignments?: InputMaybe<Scalars['Boolean']>;
};

export type AssignCandidateCohortInput = {
  candidateId: Scalars['String'];
  cohortId?: InputMaybe<Scalars['String']>;
};

export type AssignCandidateProgramInput = {
  candidateId: Scalars['String'];
  programId?: InputMaybe<Scalars['String']>;
};

export enum AuditCategory {
  Candidate = 'Candidate',
  Employee = 'Employee',
  Integration = 'Integration'
}

export type AuditLogAdditionalDataDto = {
  __typename?: 'AuditLogAdditionalDataDto';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type AuditLogDetailDto = {
  __typename?: 'AuditLogDetailDto';
  content: Scalars['String'];
  type: AuditLogDetailType;
};

export enum AuditLogDetailType {
  Note = 'Note'
}

export type AuditLogDto = {
  __typename?: 'AuditLogDto';
  _id: Scalars['String'];
  action: Scalars['String'];
  additionalData: Array<AuditLogAdditionalDataDto>;
  affected: AuditLogEntityDto;
  affectedName?: Maybe<Scalars['String']>;
  affectedUser?: Maybe<AuditLogUserDetailsDto>;
  category: Scalars['String'];
  detail?: Maybe<AuditLogDetailDto>;
  source: AuditLogEntityDto;
  sourceName?: Maybe<Scalars['String']>;
  sourceUser?: Maybe<AuditLogUserDetailsDto>;
  timestamp: Scalars['DateTime'];
};

export type AuditLogEntityDto = {
  __typename?: 'AuditLogEntityDto';
  _id: Scalars['String'];
  type: AuditLogEntityType;
};

export enum AuditLogEntityType {
  Cohort = 'Cohort',
  Course = 'Course',
  Label = 'Label',
  MailContent = 'MailContent',
  Program = 'Program',
  User = 'User'
}

export type AuditLogFilterInput = {
  action?: InputMaybe<Scalars['String']>;
  affectedUserId?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<AuditCategory>;
  sourceUserId?: InputMaybe<Scalars['String']>;
};

export type AuditLogListDto = {
  __typename?: 'AuditLogListDto';
  items: Array<AuditLogDto>;
  total: Scalars['Float'];
};

export type AuditLogListInput = {
  filter?: InputMaybe<AuditLogFilterInput>;
  paging: PagingInput;
  sort: AuditLogSortInput;
};

export enum AuditLogSort {
  Timestamp = 'Timestamp'
}

export type AuditLogSortInput = {
  direction: SortDirection;
  field: AuditLogSort;
};

export type AuditLogUserDetailsDto = {
  __typename?: 'AuditLogUserDetailsDto';
  _id: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  profilePictureUrl?: Maybe<Scalars['String']>;
};

export type BuildCustomTemplateForUserInput = {
  emailType: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type BuildMailContentPreviewInput = {
  content: Scalars['String'];
  contentType: Scalars['String'];
  emailType: Scalars['String'];
};

export type CandidateCohortDto = {
  __typename?: 'CandidateCohortDto';
  _id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type CandidateCohortFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type CandidateCohortListDto = {
  __typename?: 'CandidateCohortListDto';
  items: Array<CandidateCohortDto>;
  total: Scalars['Float'];
};

export type CandidateCohortListInput = {
  filter?: InputMaybe<CandidateCohortFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: CandidateCohortSortInput;
};

export enum CandidateCohortSort {
  Name = 'Name'
}

export type CandidateCohortSortInput = {
  direction: SortDirection;
  field: CandidateCohortSort;
};

export type CandidateCountsDto = {
  __typename?: 'CandidateCountsDto';
  admitted: Scalars['Float'];
  enrolled: Scalars['Float'];
  prospect: Scalars['Float'];
  waitlist: Scalars['Float'];
};

export type CandidateCourseDto = {
  __typename?: 'CandidateCourseDto';
  _id: Scalars['String'];
  candidateId: Scalars['String'];
  course: CourseDto;
  courseId: Scalars['String'];
  deadline?: Maybe<Scalars['DateTime']>;
  invoice?: Maybe<CandidateInvoiceDto>;
  invoiceId: Scalars['String'];
  progress: CandidateCourseProgress;
  stripeProduct?: Maybe<ProductDto>;
};

export enum CandidateCourseProgress {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Removed = 'Removed',
  TransferCreditApproved = 'TransferCreditApproved',
  TransferCreditUnderReview = 'TransferCreditUnderReview'
}

export type CandidateDocumentDto = {
  __typename?: 'CandidateDocumentDto';
  _id: Scalars['String'];
  contentLength: Scalars['Float'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  mimeType: MimeType;
  name: Scalars['String'];
  requirementKey?: Maybe<Scalars['String']>;
  type: FileType;
  uploadedAt: Scalars['DateTime'];
  uploadedBy?: Maybe<Scalars['String']>;
  uploadedByUserId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type CandidateDocumentListDto = {
  __typename?: 'CandidateDocumentListDto';
  items: Array<CandidateDocumentDto>;
  total: Scalars['Float'];
};

export type CandidateDocumentListFilterInput = {
  paging?: InputMaybe<PagingInput>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<CandidateDocumentSortInput>;
};

export enum CandidateDocumentSort {
  Name = 'Name',
  UploadedAt = 'UploadedAt'
}

export type CandidateDocumentSortInput = {
  direction: SortDirection;
  field: CandidateDocumentSort;
};

export type CandidateDto = {
  __typename?: 'CandidateDto';
  _id: Scalars['String'];
  candidateProfile?: Maybe<CandidateProfileDto>;
  creationDate: Scalars['DateTime'];
  email: Scalars['String'];
  enrolmentApplication?: Maybe<CandidateEnrolmentApplicationDto>;
  firstName: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone?: Maybe<PhoneNumberDto>;
  picture?: Maybe<UserDocumentDto>;
  pictureUrl?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  programStage?: Maybe<Scalars['String']>;
  progress?: Maybe<CandidateProgramProgressDto>;
  pronouns?: Maybe<Scalars['String']>;
  roles: RolesDto;
};

export type CandidateEnrolmentApplicationDto = {
  __typename?: 'CandidateEnrolmentApplicationDto';
  communityContactStatus?: Maybe<CandidateEnrolmentCommunityContactStatus>;
  documents?: Maybe<CandidateEnrolmentDocumentsDto>;
  education?: Maybe<CandidateEnrolmentEducationDto>;
  interview?: Maybe<CandidateEnrolmentInterviewDto>;
  invitedForInterview: Scalars['Boolean'];
  questionnaireAnswers?: Maybe<Array<QuestionnaireAnswerDto>>;
  status: CandidateEnrolmentApplicationStatus;
  submitted: Scalars['Boolean'];
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum CandidateEnrolmentApplicationStatus {
  Accepted = 'Accepted',
  Draft = 'Draft',
  Enrolled = 'Enrolled',
  InterviewScheduled = 'InterviewScheduled',
  Interviewed = 'Interviewed',
  InvitedForInterview = 'InvitedForInterview',
  Submitted = 'Submitted',
  Waitlist = 'Waitlist'
}

export enum CandidateEnrolmentCommunityContactStatus {
  ConsentGiven = 'ConsentGiven',
  ConsentWaitlist = 'ConsentWaitlist'
}

export type CandidateEnrolmentDocumentsDto = {
  __typename?: 'CandidateEnrolmentDocumentsDto';
  coverLetter?: Maybe<UserDocumentDto>;
  i20?: Maybe<UserDocumentDto>;
  resume?: Maybe<UserDocumentDto>;
  transcript?: Maybe<UserDocumentDto>;
};

export type CandidateEnrolmentDocumentsInput = {
  coverLetter?: InputMaybe<UserDocumentInput>;
  i20?: InputMaybe<UserDocumentInput>;
  resume: UserDocumentInput;
  transcript: UserDocumentInput;
};

export type CandidateEnrolmentEducationDto = {
  __typename?: 'CandidateEnrolmentEducationDto';
  eligibleForOpt?: Maybe<Scalars['Boolean']>;
  fieldOfStudy?: Maybe<Scalars['String']>;
  gpa?: Maybe<Scalars['Float']>;
  graduationDate?: Maybe<Scalars['DateTime']>;
  isFinalYearOfStudy?: Maybe<Scalars['Boolean']>;
  studyLevel?: Maybe<Scalars['String']>;
  university?: Maybe<Scalars['String']>;
};

export type CandidateEnrolmentEducationInput = {
  eligibleForOpt: Scalars['Boolean'];
  fieldOfStudy?: InputMaybe<Scalars['String']>;
  gpa?: InputMaybe<Scalars['Float']>;
  graduationDate: Scalars['DateTime'];
  isFinalYearOfStudy: Scalars['Boolean'];
  studyLevel: Scalars['String'];
  university: Scalars['String'];
};

export type CandidateEnrolmentInterviewDto = {
  __typename?: 'CandidateEnrolmentInterviewDto';
  calendlyEventUri: Scalars['String'];
  calendlyInviteeUri: Scalars['String'];
  completed: Scalars['Boolean'];
  completedAt: Scalars['DateTime'];
  completedBy?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  joinUrl?: Maybe<Scalars['String']>;
  rescheduleUrl?: Maybe<Scalars['String']>;
  scheduledAt: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type CandidateFilterInput = {
  advisorId?: InputMaybe<Scalars['String']>;
  applicationStatus?: InputMaybe<CandidateEnrolmentApplicationStatus>;
  bookmarked?: InputMaybe<Scalars['Boolean']>;
  cohortId?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
  labels?: InputMaybe<Array<Scalars['String']>>;
  paid?: InputMaybe<CandidatePaidFilter>;
  programId?: InputMaybe<Scalars['String']>;
  programStage?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  university?: InputMaybe<Scalars['String']>;
};

export type CandidateInvoiceDto = {
  __typename?: 'CandidateInvoiceDto';
  _id: Scalars['String'];
  candidateId: Scalars['String'];
  couponDiscountAmount: Scalars['Float'];
  coupons?: Maybe<Array<CouponDto>>;
  creationDate: Scalars['DateTime'];
  description: Scalars['String'];
  hostedInvoiceUrl?: Maybe<Scalars['String']>;
  productTotalAmount: Scalars['Float'];
  status: CandidateInvoiceStatus;
  stripeCharge?: Maybe<CandidateInvoiceStripeChargeDto>;
  stripeChargeId?: Maybe<Scalars['String']>;
  stripeCouponIds?: Maybe<Array<Scalars['String']>>;
  stripeCustomerId: Scalars['String'];
  stripeInvoiceId: Scalars['String'];
  stripeProductIds: Array<Scalars['String']>;
  totalAmount: Scalars['Float'];
  type: CandidateInvoiceType;
  updatedAt: Scalars['DateTime'];
};

export enum CandidateInvoiceStatus {
  Created = 'Created',
  Paid = 'Paid',
  Voided = 'Voided'
}

export type CandidateInvoiceStripeChargeDto = {
  __typename?: 'CandidateInvoiceStripeChargeDto';
  _id: Scalars['String'];
  amount: Scalars['Float'];
  createdDate: Scalars['DateTime'];
  currency: Scalars['String'];
  receiptUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  stripeCustomerId: Scalars['String'];
  updatedDate: Scalars['DateTime'];
};

export enum CandidateInvoiceType {
  Courses = 'Courses',
  Deposit = 'Deposit'
}

export type CandidateJobDto = {
  __typename?: 'CandidateJobDto';
  _id: Scalars['String'];
  createdAt: Scalars['DateTime'];
  job: JobDto;
  jobId: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type CandidateJobListDto = {
  __typename?: 'CandidateJobListDto';
  items: Array<CandidateJobDto>;
  total: Scalars['Float'];
};

export enum CandidateJobSort {
  Created = 'Created',
  Updated = 'Updated'
}

export type CandidateJobSortInput = {
  direction: SortDirection;
  field: CandidateJobSort;
};

export type CandidateJobsListInput = {
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: CandidateJobSortInput;
};

export type CandidateLabelDto = {
  __typename?: 'CandidateLabelDto';
  _id: Scalars['String'];
  candidateCount?: Maybe<Scalars['Float']>;
  color: Scalars['String'];
  label: Scalars['String'];
};

export type CandidateListDto = {
  __typename?: 'CandidateListDto';
  items: Array<CandidateDto>;
  total: Scalars['Float'];
};

export type CandidateListInput = {
  filter?: InputMaybe<CandidateFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: CandidateSortInput;
};

export enum CandidatePaidFilter {
  AllPaid = 'AllPaid',
  AnyUnpaid = 'AnyUnpaid',
  CoursesNotPaid = 'CoursesNotPaid',
  CoursesPaid = 'CoursesPaid',
  DepositNotPaid = 'DepositNotPaid',
  DepositPaid = 'DepositPaid'
}

export type CandidateProfileAdvisorDto = {
  __typename?: 'CandidateProfileAdvisorDto';
  _id: Scalars['String'];
  advisorProfile?: Maybe<AdvisorProfileDto>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<PhoneNumberDto>;
  pictureUrl?: Maybe<Scalars['String']>;
};

export type CandidateProfileDto = {
  __typename?: 'CandidateProfileDto';
  about?: Maybe<Scalars['String']>;
  address?: Maybe<AddressDto>;
  advisorIds?: Maybe<Array<Scalars['String']>>;
  advisors?: Maybe<Array<CandidateProfileAdvisorDto>>;
  bookmarked?: Maybe<Scalars['Boolean']>;
  candidateId?: Maybe<Scalars['String']>;
  cohort?: Maybe<CandidateCohortDto>;
  cohortId?: Maybe<Scalars['String']>;
  courseCount?: Maybe<Scalars['Float']>;
  courseIds?: Maybe<Array<Scalars['String']>>;
  courseTitle?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<CourseDto>>;
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  desiredCareer?: Maybe<Scalars['String']>;
  interests?: Maybe<Array<Scalars['String']>>;
  jobTitle?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Scalars['String']>>;
  latestResume?: Maybe<UserDocumentDto>;
  phone?: Maybe<PhoneNumberDto>;
  program?: Maybe<CandidateProgramDto>;
  programId?: Maybe<Scalars['String']>;
  skills: Array<ProfileSkillDto>;
};

export type CandidateProgramDto = {
  __typename?: 'CandidateProgramDto';
  _id: Scalars['String'];
  applicationRequirements: Array<ProgramStageRequirementDto>;
  candidateAgreement?: Maybe<UserDocumentDto>;
  candidateAgreementUrl?: Maybe<Scalars['String']>;
  invitationEmailType?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  stages: Array<ProgramStageDto>;
  welcomeEmailType?: Maybe<Scalars['String']>;
};

export type CandidateProgramFilterInput = {
  advisorId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  programId?: InputMaybe<Scalars['String']>;
};

export type CandidateProgramListDto = {
  __typename?: 'CandidateProgramListDto';
  items: Array<CandidateProgramDto>;
  total: Scalars['Float'];
};

export type CandidateProgramListInput = {
  filter?: InputMaybe<CandidateProgramFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: CandidateProgramSortInput;
};

export type CandidateProgramProgressDto = {
  __typename?: 'CandidateProgramProgressDto';
  acceptedAgreement: Scalars['Boolean'];
  candidateId: Scalars['String'];
  creationDate: Scalars['DateTime'];
  currentStage: Scalars['String'];
  program: CandidateProgramDto;
  programId: Scalars['String'];
  stages: Array<CandidateProgramStageProgressDto>;
  updatedDate: Scalars['DateTime'];
};

export enum CandidateProgramSort {
  Name = 'Name',
  Order = 'Order'
}

export type CandidateProgramSortInput = {
  direction: SortDirection;
  field: CandidateProgramSort;
};

export type CandidateProgramStageProgressDto = {
  __typename?: 'CandidateProgramStageProgressDto';
  completedRequirements: Array<CandidateProgramStageRequirementCompletionDto>;
  depositInvoice?: Maybe<CandidateInvoiceDto>;
  depositInvoiceId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  requirementsCompleted: Scalars['Boolean'];
  stageKey: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type CandidateProgramStageRequirementCompletionDto = {
  __typename?: 'CandidateProgramStageRequirementCompletionDto';
  completed: Scalars['Boolean'];
  completedBy: Scalars['String'];
  completionDate: Scalars['DateTime'];
  linkedDocumentId?: Maybe<Scalars['String']>;
  linkedDocumentName?: Maybe<Scalars['String']>;
  requirementKey: Scalars['String'];
};

export type CandidateResumeDto = {
  __typename?: 'CandidateResumeDto';
  _id: Scalars['String'];
  file: CandidateResumeFileDto;
  fileId: Scalars['String'];
  uploadedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type CandidateResumeFileDto = {
  __typename?: 'CandidateResumeFileDto';
  _id: Scalars['String'];
  contentLength: Scalars['Float'];
  key: Scalars['String'];
  mimeType: MimeType;
  name: Scalars['String'];
  uploadedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type CandidateSignupDto = {
  __typename?: 'CandidateSignupDto';
  token: Scalars['String'];
  user: UserDto;
};

export type CandidateSignupInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  invitationId: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  phone?: InputMaybe<UpdatePhoneNumberInput>;
};

export enum CandidateSort {
  ApplicationSubmitted = 'ApplicationSubmitted',
  CandidateId = 'CandidateId',
  CreationDate = 'CreationDate',
  Email = 'Email',
  FirstName = 'FirstName',
  LastName = 'LastName',
  University = 'University'
}

export type CandidateSortInput = {
  direction: SortDirection;
  field: CandidateSort;
};

export type ChangePasswordInput = {
  existingPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
};

export type CompleteCandidateProgramStageRequirementInput = {
  candidateId: Scalars['String'];
  completed: Scalars['Boolean'];
  completionDate?: InputMaybe<Scalars['DateTime']>;
  linkedDocumentId?: InputMaybe<Scalars['String']>;
  programId: Scalars['String'];
  requirementKey: Scalars['String'];
  stageKey: Scalars['String'];
};

export type CouponDto = {
  __typename?: 'CouponDto';
  appliesToProductIds?: Maybe<Array<Scalars['String']>>;
  discount: Scalars['Float'];
  id: Scalars['String'];
  maxRedemptions: Scalars['Float'];
  name: Scalars['String'];
  timesRedeemed: Scalars['Float'];
  valid: Scalars['Boolean'];
};

export type CourseAdminDto = {
  __typename?: 'CourseAdminDto';
  _id: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<CourseLinkDto>>;
  name: Scalars['String'];
  stats?: Maybe<CourseStatsDto>;
  stripeProduct?: Maybe<ProductDto>;
  stripeProductId?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type CourseDto = {
  __typename?: 'CourseDto';
  _id: Scalars['String'];
  candidateCount?: Maybe<Scalars['Float']>;
  creationDate: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  links?: Maybe<Array<CourseLinkDto>>;
  name: Scalars['String'];
  stripeProductId?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type CourseLinkDto = {
  __typename?: 'CourseLinkDto';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CourseLinkInput = {
  name: Scalars['String'];
  url: Scalars['String'];
};

export type CourseListDto = {
  __typename?: 'CourseListDto';
  items: Array<CourseAdminDto>;
  total: Scalars['Float'];
};

export type CourseListFilterInput = {
  excludeIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CourseListInput = {
  filter?: InputMaybe<CourseListFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: CourseSortInput;
};

export enum CourseSort {
  CreationDate = 'CreationDate',
  Name = 'Name',
  Subject = 'Subject'
}

export type CourseSortInput = {
  direction: SortDirection;
  field: CourseSort;
};

export type CourseStatsDto = {
  __typename?: 'CourseStatsDto';
  completed: Scalars['Float'];
  failed: Scalars['Float'];
  inProgress: Scalars['Float'];
  notStarted: Scalars['Float'];
  removed: Scalars['Float'];
  total: Scalars['Float'];
  transferCreditApproved: Scalars['Float'];
  transferCreditUnderReview: Scalars['Float'];
};

export type CreateCandidateCohortInput = {
  name: Scalars['String'];
};

export type CreateCandidateProgramInput = {
  _id?: InputMaybe<Scalars['String']>;
  candidateAgreement?: InputMaybe<UserDocumentInput>;
  invitationEmailType?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  welcomeEmailType?: InputMaybe<Scalars['String']>;
};

export type CreateCourseInput = {
  description?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<CourseLinkInput>>;
  name: Scalars['String'];
  stripeProductId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type CreateCustomMailContentInput = {
  description: Scalars['String'];
  fromTemplate?: InputMaybe<Scalars['String']>;
  locale: Scalars['String'];
  title: Scalars['String'];
};

export type CreateEmployeeInput = {
  duplicateEmailOverride?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  roles: EmployeeRolesInput;
};

export type CreateInvitationInput = {
  advisorId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Array<InvitationApplicationDataInput>>;
  email: Scalars['String'];
  programId: Scalars['String'];
};

export type CreateInvoiceForCoursesInput = {
  candidateId: Scalars['String'];
  couponIds?: InputMaybe<Array<Scalars['String']>>;
  courseIds: Array<Scalars['String']>;
};

export type CreateNoteInput = {
  candidateId: Scalars['String'];
  content: Scalars['String'];
};

export type CreateUpdateCandidateLabelInput = {
  color?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
};

export type DynamicDataDto = {
  __typename?: 'DynamicDataDto';
  ejs: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  type: Scalars['String'];
};

export type EditCandidateProgramStageEmailsInput = {
  endEmailType?: InputMaybe<Scalars['String']>;
  programId: Scalars['String'];
  stageId: Scalars['String'];
  startEmailType?: InputMaybe<Scalars['String']>;
};

export type EditCandidateProgramStageInput = {
  name: Scalars['String'];
  programId: Scalars['String'];
  stageId: Scalars['String'];
};

export type EditInvitationInput = {
  advisorId?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<Array<InvitationApplicationDataInput>>;
  documents?: InputMaybe<Array<InvitationApplicationDocumentInput>>;
  programId: Scalars['String'];
};

export type EmailPreferenceDto = {
  __typename?: 'EmailPreferenceDto';
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
};

export type EmailPreferencesDto = {
  __typename?: 'EmailPreferencesDto';
  preferences: Array<EmailPreferenceDto>;
};

export type EmployeeDto = {
  __typename?: 'EmployeeDto';
  _id: Scalars['String'];
  advisorProfile?: Maybe<AdvisorProfileDto>;
  creationDate: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isActive: Scalars['Boolean'];
  lastName: Scalars['String'];
  pictureUrl?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  roles: RolesDto;
};

export type EmployeeFilterInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<Scalars['String']>;
};

export type EmployeeListDto = {
  __typename?: 'EmployeeListDto';
  items: Array<EmployeeDto>;
  total: Scalars['Float'];
};

export type EmployeeListInput = {
  filter?: InputMaybe<EmployeeFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: EmployeeSortInput;
};

export type EmployeeRolesInput = {
  admin?: Scalars['Boolean'];
  advisor?: Scalars['Boolean'];
};

export enum EmployeeSort {
  CreationDate = 'CreationDate',
  Email = 'Email',
  FirstName = 'FirstName',
  IsActive = 'IsActive',
  LastName = 'LastName'
}

export type EmployeeSortInput = {
  direction: SortDirection;
  field: EmployeeSort;
};

export type FileDto = {
  __typename?: 'FileDto';
  _id: Scalars['String'];
  contentLength: Scalars['Float'];
  employerId?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  mimeType: MimeType;
  name: Scalars['String'];
  processedAt?: Maybe<Scalars['DateTime']>;
  processingResults?: Maybe<Array<FileProcessorResultDto>>;
  status: FileStatus;
  statusMessage?: Maybe<Scalars['String']>;
  type: FileType;
  uploadedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type FileProcessorResultDto = {
  __typename?: 'FileProcessorResultDto';
  message?: Maybe<Scalars['String']>;
  processor: Scalars['String'];
  result: Scalars['String'];
};

/** The status of the file */
export enum FileStatus {
  Processed = 'Processed',
  ProcessingFailed = 'ProcessingFailed',
  Removed = 'Removed',
  Uploaded = 'Uploaded'
}

/** The type of the file */
export enum FileType {
  Attachment = 'Attachment',
  Branding = 'Branding',
  Csv = 'Csv',
  ProfilePicture = 'ProfilePicture',
  Quarantine = 'Quarantine',
  Resume = 'Resume',
  UserDocument = 'UserDocument'
}

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ForgotPasswordResetInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type GetInvitationInput = {
  id: Scalars['String'];
  notConverted?: InputMaybe<Scalars['Boolean']>;
};

export type InvitationApplicationDataDto = {
  __typename?: 'InvitationApplicationDataDto';
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type: InvitationApplicationDataType;
  value: Scalars['String'];
};

export type InvitationApplicationDataInput = {
  key: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  type: InvitationApplicationDataType;
  value: Scalars['String'];
};

export enum InvitationApplicationDataType {
  EducationInfo = 'EDUCATION_INFO',
  Question = 'QUESTION',
  UserInfo = 'USER_INFO'
}

export type InvitationApplicationDocumentDto = {
  __typename?: 'InvitationApplicationDocumentDto';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
};

export type InvitationApplicationDocumentInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type InvitationDto = {
  __typename?: 'InvitationDto';
  _id: Scalars['String'];
  advisor?: Maybe<Scalars['String']>;
  advisorId?: Maybe<Scalars['String']>;
  converted: Scalars['Boolean'];
  convertedDate?: Maybe<Scalars['DateTime']>;
  convertedToUserId?: Maybe<Scalars['String']>;
  creationDate: Scalars['DateTime'];
  data?: Maybe<Array<InvitationApplicationDataDto>>;
  documents?: Maybe<Array<InvitationApplicationDocumentDto>>;
  email: Scalars['String'];
  invited: Scalars['Boolean'];
  invitedDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  program: CandidateProgramDto;
  programId: Scalars['String'];
  programName: Scalars['String'];
  valid: Scalars['Boolean'];
  validationError?: Maybe<Scalars['String']>;
};

export type InvitationEmailPreviewDto = {
  __typename?: 'InvitationEmailPreviewDto';
  totalAlreadyInvited: Scalars['Float'];
  totalToSend: Scalars['Float'];
};

export type InvitationListDto = {
  __typename?: 'InvitationListDto';
  items: Array<InvitationDto>;
  total: Scalars['Float'];
};

export type InvitationListInput = {
  filter?: InputMaybe<InvitationListInputFilter>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: InvitationSortInput;
};

export type InvitationListInputFilter = {
  advisorId?: InputMaybe<Scalars['String']>;
  converted?: InputMaybe<Scalars['Boolean']>;
  invited?: InputMaybe<Scalars['Boolean']>;
  programId?: InputMaybe<Scalars['String']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

export enum InvitationSort {
  Converted = 'Converted',
  ConvertedDate = 'ConvertedDate',
  CreationDate = 'CreationDate',
  Email = 'Email',
  FirstName = 'FirstName',
  Invited = 'Invited',
  LastName = 'LastName',
  University = 'University'
}

export type InvitationSortInput = {
  direction: SortDirection;
  field: InvitationSort;
};

export type JobDto = {
  __typename?: 'JobDto';
  description: Scalars['String'];
  employer: Scalars['String'];
  employerLogo?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  jobFunction?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  remote?: Maybe<Scalars['Boolean']>;
  reqId: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type ListProductsDto = {
  __typename?: 'ListProductsDto';
  items: Array<ProductDto>;
  total: Scalars['Float'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type MailContentDto = {
  __typename?: 'MailContentDto';
  _id: Scalars['String'];
  custom?: Maybe<Scalars['Boolean']>;
  customDescription?: Maybe<Scalars['String']>;
  customTitle?: Maybe<Scalars['String']>;
  templates: Array<MailContentTemplateDto>;
  type: Scalars['String'];
};

export type MailContentFilterInput = {
  custom?: InputMaybe<Scalars['Boolean']>;
};

export type MailContentListDto = {
  __typename?: 'MailContentListDto';
  items: Array<MailContentDto>;
  total: Scalars['Float'];
};

export type MailContentListInput = {
  filter?: InputMaybe<MailContentFilterInput>;
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
  sort: MailContentSortInput;
};

export enum MailContentSort {
  CustomTitle = 'CustomTitle',
  Type = 'Type'
}

export type MailContentSortInput = {
  direction: Scalars['String'];
  field: MailContentSort;
};

export type MailContentTemplateDto = {
  __typename?: 'MailContentTemplateDto';
  body: Scalars['String'];
  locale: Scalars['String'];
  subject: Scalars['String'];
};

export type MessageAttachmentDto = {
  __typename?: 'MessageAttachmentDto';
  contentId?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  convertedToFileId?: Maybe<Scalars['String']>;
  fileId: Scalars['String'];
  name: Scalars['String'];
  url: Scalars['String'];
};

export type MessageDto = {
  __typename?: 'MessageDto';
  _id: Scalars['String'];
  attachments?: Maybe<Array<MessageAttachmentDto>>;
  body: Scalars['String'];
  bodyHtml?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  fromName?: Maybe<Scalars['String']>;
  fromUser?: Maybe<UserDto>;
  fromUserId?: Maybe<Scalars['String']>;
  status?: Maybe<MessageStatus>;
  statusDate?: Maybe<Scalars['DateTime']>;
  subject?: Maybe<Scalars['String']>;
  timestamp: Scalars['DateTime'];
  to?: Maybe<Scalars['String']>;
  toName?: Maybe<Scalars['String']>;
  toUserId?: Maybe<Scalars['String']>;
  type: MessageType;
};

export enum MessageStatus {
  Accepted = 'accepted',
  Canceled = 'canceled',
  Delivered = 'delivered',
  Failed = 'failed',
  PartiallyDelivered = 'partially_delivered',
  Queued = 'queued',
  Read = 'read',
  Received = 'received',
  Receiving = 'receiving',
  Scheduled = 'scheduled',
  Sending = 'sending',
  Sent = 'sent',
  Undelivered = 'undelivered',
  WaitingApproval = 'waiting_approval'
}

export enum MessageType {
  Email = 'email',
  Platform = 'platform',
  Sms = 'sms',
  Whatsapp = 'whatsapp'
}

/** The mime type of the file */
export enum MimeType {
  Csv = 'CSV',
  Doc = 'DOC',
  Docx = 'DOCX',
  Gif = 'GIF',
  Ico = 'ICO',
  Icon = 'ICON',
  Jpg = 'JPG',
  Pdf = 'PDF',
  Png = 'PNG',
  Ppt = 'PPT',
  Pptx = 'PPTX',
  Svg = 'SVG',
  Webp = 'WEBP',
  Xls = 'XLS',
  Xlsx = 'XLSX'
}

export type Mutation = {
  __typename?: 'Mutation';
  acceptCandidateAgreement: Scalars['Boolean'];
  acceptCandidateEnrolmentApplication: Scalars['Boolean'];
  addStageToProgram: CandidateProgramDto;
  assignAdvisorToCandidate: Scalars['Boolean'];
  assignAdvisorToCandidates: Scalars['Boolean'];
  assignCandidateToCohort: Scalars['Boolean'];
  assignCandidateToCourse: Scalars['Boolean'];
  assignCandidateToProgram: Scalars['Boolean'];
  bookmarkCandidate: Scalars['Boolean'];
  buildCustomTemplateForUser: MailContentTemplateDto;
  buildMailContentPreview: Scalars['String'];
  candidateSignup: CandidateSignupDto;
  changePassword: Scalars['Boolean'];
  convertToUserDocument: Scalars['Boolean'];
  createCandidateCohort: CandidateCohortDto;
  createCandidateLabel: CandidateLabelDto;
  createCandidateProgram: CandidateProgramDto;
  createCourse: CourseAdminDto;
  createEmployee: EmployeeDto;
  createInvitation: InvitationDto;
  createInvoiceForCourses: CandidateInvoiceDto;
  createMailContent: MailContentDto;
  createNote: NoteDto;
  deleteCandidate: Scalars['Boolean'];
  deleteCandidateDocument: Scalars['Boolean'];
  deleteCandidateLabel: Scalars['Boolean'];
  deleteMailContent: Scalars['Boolean'];
  deleteNote: Scalars['Boolean'];
  deleteResume: Scalars['Boolean'];
  deleteSavedQuery: Scalars['Boolean'];
  disableEmployee: Scalars['Boolean'];
  editInvitation: InvitationDto;
  editProgramStage: CandidateProgramDto;
  editProgramStageEmails: CandidateProgramDto;
  enrol: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  forgotPasswordReset: UserDto;
  login: UserDto;
  logout: Scalars['Boolean'];
  markAllNotificationsAsRead: Scalars['Boolean'];
  markInvoiceAsPaid: Scalars['Boolean'];
  markNotificationAsRead: Scalars['Boolean'];
  moveCandidateToNextProgramStage: Scalars['Boolean'];
  processInvitationCsv: ProcessInvitationCsvResultDto;
  removeAdvisorFromCandidate: Scalars['Boolean'];
  removeCandidateFromCourse: Scalars['Boolean'];
  removeInvitation: Scalars['Boolean'];
  removeStageFromProgram: CandidateProgramDto;
  resetEmployeePassword: Scalars['Boolean'];
  scheduleCandidateEnrolmentInterview: Scalars['Boolean'];
  sendCandidateEmail: Scalars['Boolean'];
  sendCandidateMessage: MessageDto;
  sendInvitationEmail: Scalars['Boolean'];
  submitCandidateEnrolmentApplication: Scalars['Boolean'];
  updateAdvisorProfile: AdvisorProfileDto;
  updateCandidateCohort: CandidateCohortDto;
  updateCandidateCourseProgress: Scalars['Boolean'];
  updateCandidateDocumentMetadata: CandidateDocumentDto;
  updateCandidateEnrolmentApplication: CandidateEnrolmentApplicationDto;
  updateCandidateLabel: CandidateLabelDto;
  updateCandidateLabels: Scalars['Boolean'];
  updateCandidateProfile: CandidateProfileDto;
  updateCandidateProgram: CandidateProgramDto;
  updateCourse: CourseAdminDto;
  updateEmailPreference: EmailPreferencesDto;
  updateEmployee: EmployeeDto;
  updateMailContent: MailContentDto;
  updateMe: UserDto;
  updateProgramApplicationRequirements: CandidateProgramDto;
  updateProgramStageRequirementCompletion: Scalars['Boolean'];
  updateProgramStageRequirements: CandidateProgramDto;
  updateUser: UserDto;
  upsertSavedQuery: SavedQueryDto;
  verifyCandidate: VerifyCandidateDto;
  voidInvoice: Scalars['Boolean'];
  waitlistCandidateEnrolmentApplication: Scalars['Boolean'];
};


export type MutationAcceptCandidateEnrolmentApplicationArgs = {
  id: Scalars['String'];
};


export type MutationAddStageToProgramArgs = {
  input: AddCandidateProgramStageInput;
  programId: Scalars['String'];
};


export type MutationAssignAdvisorToCandidateArgs = {
  input: AssignAdvisorToCandidateInput;
};


export type MutationAssignAdvisorToCandidatesArgs = {
  input: AssignAdvisorToCandidatesInput;
};


export type MutationAssignCandidateToCohortArgs = {
  input: AssignCandidateCohortInput;
};


export type MutationAssignCandidateToCourseArgs = {
  candidateId: Scalars['String'];
  courseId: Scalars['String'];
};


export type MutationAssignCandidateToProgramArgs = {
  input: AssignCandidateProgramInput;
};


export type MutationBookmarkCandidateArgs = {
  bookmarked: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationBuildCustomTemplateForUserArgs = {
  input: BuildCustomTemplateForUserInput;
};


export type MutationBuildMailContentPreviewArgs = {
  input: BuildMailContentPreviewInput;
};


export type MutationCandidateSignupArgs = {
  input: CandidateSignupInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationConvertToUserDocumentArgs = {
  fileId: Scalars['String'];
  messageId: Scalars['String'];
};


export type MutationCreateCandidateCohortArgs = {
  input: CreateCandidateCohortInput;
};


export type MutationCreateCandidateLabelArgs = {
  input: CreateUpdateCandidateLabelInput;
};


export type MutationCreateCandidateProgramArgs = {
  input: CreateCandidateProgramInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateInvitationArgs = {
  input: CreateInvitationInput;
};


export type MutationCreateInvoiceForCoursesArgs = {
  input: CreateInvoiceForCoursesInput;
};


export type MutationCreateMailContentArgs = {
  input: CreateCustomMailContentInput;
};


export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


export type MutationDeleteCandidateArgs = {
  candidateId: Scalars['String'];
};


export type MutationDeleteCandidateDocumentArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCandidateLabelArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMailContentArgs = {
  type: Scalars['String'];
};


export type MutationDeleteNoteArgs = {
  noteId: Scalars['String'];
};


export type MutationDeleteResumeArgs = {
  resumeId: Scalars['String'];
};


export type MutationDeleteSavedQueryArgs = {
  key: SavedQueryKey;
  label: Scalars['String'];
};


export type MutationDisableEmployeeArgs = {
  disabled: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationEditInvitationArgs = {
  id: Scalars['String'];
  input: EditInvitationInput;
};


export type MutationEditProgramStageArgs = {
  input: EditCandidateProgramStageInput;
};


export type MutationEditProgramStageEmailsArgs = {
  input: EditCandidateProgramStageEmailsInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationForgotPasswordResetArgs = {
  input: ForgotPasswordResetInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMarkInvoiceAsPaidArgs = {
  invoiceId: Scalars['String'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['String'];
};


export type MutationMoveCandidateToNextProgramStageArgs = {
  candidateId: Scalars['String'];
};


export type MutationProcessInvitationCsvArgs = {
  input: ProcessInvitationCsvInput;
};


export type MutationRemoveAdvisorFromCandidateArgs = {
  input: AssignAdvisorToCandidateInput;
};


export type MutationRemoveCandidateFromCourseArgs = {
  candidateId: Scalars['String'];
  courseId: Scalars['String'];
};


export type MutationRemoveInvitationArgs = {
  id: Scalars['String'];
};


export type MutationRemoveStageFromProgramArgs = {
  input: RemoveCandidateProgramStageInput;
};


export type MutationResetEmployeePasswordArgs = {
  id: Scalars['String'];
};


export type MutationScheduleCandidateEnrolmentInterviewArgs = {
  input: ScheduleCandidateEnrolmentInterviewInput;
};


export type MutationSendCandidateEmailArgs = {
  input: SendEmailInput;
};


export type MutationSendCandidateMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendInvitationEmailArgs = {
  input: SendInvitationEmailInput;
};


export type MutationUpdateAdvisorProfileArgs = {
  input: UpdateAdvisorProfileInput;
};


export type MutationUpdateCandidateCohortArgs = {
  id: Scalars['String'];
  input: UpdateCandidateCohortInput;
};


export type MutationUpdateCandidateCourseProgressArgs = {
  input: UpdateCandidateCourseProgressInput;
};


export type MutationUpdateCandidateDocumentMetadataArgs = {
  input: UpdateCandidateDocumentMetadataInput;
};


export type MutationUpdateCandidateEnrolmentApplicationArgs = {
  input: UpdateCandidateEnrolmentApplicationInput;
};


export type MutationUpdateCandidateLabelArgs = {
  id: Scalars['String'];
  input: CreateUpdateCandidateLabelInput;
};


export type MutationUpdateCandidateLabelsArgs = {
  input: UpdateCandidateLabelsInput;
};


export type MutationUpdateCandidateProfileArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: UpdateCandidateProfileInput;
};


export type MutationUpdateCandidateProgramArgs = {
  id: Scalars['String'];
  input: UpdateCandidateProgramInput;
};


export type MutationUpdateCourseArgs = {
  id: Scalars['String'];
  input: UpdateCourseInput;
};


export type MutationUpdateEmailPreferenceArgs = {
  input: UpdateEmailPreferenceInput;
};


export type MutationUpdateEmployeeArgs = {
  id: Scalars['String'];
  input: UpdateEmployeeInput;
};


export type MutationUpdateMailContentArgs = {
  input: UpdateMailContentInput;
};


export type MutationUpdateMeArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateProgramApplicationRequirementsArgs = {
  programId: Scalars['String'];
  requirements: Array<AddCandidateProgramRequirementInput>;
};


export type MutationUpdateProgramStageRequirementCompletionArgs = {
  input: CompleteCandidateProgramStageRequirementInput;
};


export type MutationUpdateProgramStageRequirementsArgs = {
  programId: Scalars['String'];
  requirements: Array<AddCandidateProgramRequirementInput>;
  stageKey: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  id: Scalars['String'];
  input: UpdateUserInput;
};


export type MutationUpsertSavedQueryArgs = {
  input: SavedQueryInput;
};


export type MutationVerifyCandidateArgs = {
  token: Scalars['String'];
};


export type MutationVoidInvoiceArgs = {
  invoiceId: Scalars['String'];
};


export type MutationWaitlistCandidateEnrolmentApplicationArgs = {
  id: Scalars['String'];
};

export type NoteDto = {
  __typename?: 'NoteDto';
  _id: Scalars['String'];
  authorId: Scalars['String'];
  candidateId: Scalars['String'];
  content: Scalars['String'];
  creationDate: Scalars['DateTime'];
  mentionedUsers?: Maybe<Array<NoteMentionDto>>;
};

export type NoteMentionDto = {
  __typename?: 'NoteMentionDto';
  name: Scalars['String'];
  userId: Scalars['String'];
};

export type NotificationDto = {
  __typename?: 'NotificationDto';
  _id?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  link?: Maybe<Scalars['String']>;
  message: Scalars['String'];
  read: Scalars['Boolean'];
  title: Scalars['String'];
  userId: Scalars['String'];
};

export type PagingInput = {
  limit: Scalars['Float'];
  offset: Scalars['Float'];
};

export type PhoneNumberDto = {
  __typename?: 'PhoneNumberDto';
  countryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ProcessInvitationCsvInput = {
  advisorId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['String'];
  programId: Scalars['String'];
};

export type ProcessInvitationCsvResultDto = {
  __typename?: 'ProcessInvitationCsvResultDto';
  taskId: Scalars['String'];
};

export type ProductDto = {
  __typename?: 'ProductDto';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  price: Scalars['Float'];
  stripeId: Scalars['String'];
};

export type ProfileSkillDto = {
  __typename?: 'ProfileSkillDto';
  fromResume: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProfileSkillInput = {
  fromResume?: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ProfileSocialLinksDto = {
  __typename?: 'ProfileSocialLinksDto';
  facebook?: Maybe<Scalars['String']>;
  github?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  linkedin?: Maybe<Scalars['String']>;
  twitter?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  youtube?: Maybe<Scalars['String']>;
};

export type ProgramStageDto = {
  __typename?: 'ProgramStageDto';
  endEmailType?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  requirements: Array<ProgramStageRequirementDto>;
  startEmailType?: Maybe<Scalars['String']>;
};

export type ProgramStageRequirementDto = {
  __typename?: 'ProgramStageRequirementDto';
  key: Scalars['String'];
  label: Scalars['String'];
  order: Scalars['Float'];
  paymentStripeProductId?: Maybe<Scalars['String']>;
  paymentStripeProductName?: Maybe<Scalars['String']>;
  paymentType?: Maybe<ProgramStageRequirementPaymentType>;
  questionType?: Maybe<ProgramStageRequirementQuestionType>;
  required: Scalars['Boolean'];
  type: ProgramStageRequirementType;
};

export enum ProgramStageRequirementPaymentType {
  Courses = 'courses',
  StripeProduct = 'stripe_product'
}

export enum ProgramStageRequirementQuestionType {
  Text = 'text',
  Textarea = 'textarea',
  YesNo = 'yes_no'
}

export enum ProgramStageRequirementType {
  Check = 'check',
  Document = 'document',
  EducationInfo = 'education_info',
  Payment = 'payment',
  Question = 'question',
  UserInfo = 'user_info'
}

export type Query = {
  __typename?: 'Query';
  advisorSuggestions: SuggestionsResponse;
  auditLogs: AuditLogListDto;
  candidate: CandidateDto;
  candidateCohort: CandidateCohortDto;
  candidateCohortSuggestions: SuggestionsResponse;
  candidateCohorts: CandidateCohortListDto;
  candidateCounts: CandidateCountsDto;
  candidateDocumentLabelSuggestions: SuggestionsResponse;
  candidateJobs: CandidateJobListDto;
  candidateLabel: CandidateLabelDto;
  candidateLabels: Array<CandidateLabelDto>;
  candidateProgram: CandidateProgramDto;
  candidateProgramProgress: CandidateProgramProgressDto;
  candidateProgramSuggestions: SuggestionsResponse;
  candidatePrograms: CandidateProgramListDto;
  candidates: CandidateListDto;
  course: CourseAdminDto;
  courseSuggestions: SuggestionsResponse;
  courses: CourseListDto;
  employee: EmployeeDto;
  employees: EmployeeListDto;
  getAdvisorProfile?: Maybe<AdvisorProfileDto>;
  getCandidateCourses?: Maybe<Array<CandidateCourseDto>>;
  getCandidateDocuments: CandidateDocumentListDto;
  getCandidateEnrolmentApplication?: Maybe<CandidateEnrolmentApplicationDto>;
  getCandidateInvoice: CandidateInvoiceDto;
  getCandidateInvoices: Array<CandidateInvoiceDto>;
  getCandidateMessages: Array<MessageDto>;
  getCandidateNoteMentions: Array<NoteMentionDto>;
  getCandidateProfile?: Maybe<CandidateProfileDto>;
  getCandidateResumes: Array<CandidateResumeDto>;
  getCoupons: Array<CouponDto>;
  getEmailPreferences: EmailPreferencesDto;
  getFile: FileDto;
  getMyCourses?: Maybe<Array<CandidateCourseDto>>;
  getMyDocuments: CandidateDocumentListDto;
  getMyInvoices: Array<CandidateInvoiceDto>;
  getMyResumes: Array<CandidateResumeDto>;
  getSavedQueries: Array<SavedQueryDto>;
  hasOutstandingInvoice: Scalars['Boolean'];
  invitation?: Maybe<InvitationDto>;
  invitations: InvitationListDto;
  listProducts: ListProductsDto;
  mailContent: MailContentDto;
  mailContentDynamicData: Array<DynamicDataDto>;
  mailContents: MailContentListDto;
  me: UserDto;
  myProgram: CandidateProgramDto;
  myProgramProgress: CandidateProgramProgressDto;
  notifications: Array<NotificationDto>;
  previewInvitationEmail: InvitationEmailPreviewDto;
  searchLocations: Array<AddressDto>;
  universitySuggestions: SuggestionsResponse;
  unreadNotificationsCount: Scalars['Float'];
};


export type QueryAdvisorSuggestionsArgs = {
  input: SuggestionsInput;
};


export type QueryAuditLogsArgs = {
  input: AuditLogListInput;
};


export type QueryCandidateArgs = {
  id: Scalars['String'];
};


export type QueryCandidateCohortArgs = {
  id: Scalars['String'];
};


export type QueryCandidateCohortSuggestionsArgs = {
  input: SuggestionsInput;
};


export type QueryCandidateCohortsArgs = {
  input: CandidateCohortListInput;
};


export type QueryCandidateDocumentLabelSuggestionsArgs = {
  input: SuggestionsInput;
};


export type QueryCandidateJobsArgs = {
  input: CandidateJobsListInput;
};


export type QueryCandidateLabelArgs = {
  id: Scalars['String'];
};


export type QueryCandidateProgramArgs = {
  id: Scalars['String'];
};


export type QueryCandidateProgramProgressArgs = {
  candidateId: Scalars['String'];
};


export type QueryCandidateProgramSuggestionsArgs = {
  input: SuggestionsInput;
  isActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCandidateProgramsArgs = {
  input: CandidateProgramListInput;
};


export type QueryCandidatesArgs = {
  input: CandidateListInput;
};


export type QueryCourseArgs = {
  id: Scalars['String'];
};


export type QueryCourseSuggestionsArgs = {
  filter?: InputMaybe<CourseListFilterInput>;
  input: SuggestionsInput;
};


export type QueryCoursesArgs = {
  input: CourseListInput;
};


export type QueryEmployeeArgs = {
  id: Scalars['String'];
};


export type QueryEmployeesArgs = {
  input: EmployeeListInput;
};


export type QueryGetCandidateCoursesArgs = {
  candidateId: Scalars['String'];
};


export type QueryGetCandidateDocumentsArgs = {
  candidateId: Scalars['String'];
  input: CandidateDocumentListFilterInput;
};


export type QueryGetCandidateInvoiceArgs = {
  invoiceId: Scalars['String'];
};


export type QueryGetCandidateInvoicesArgs = {
  candidateId: Scalars['String'];
};


export type QueryGetCandidateMessagesArgs = {
  afterTimestamp?: InputMaybe<Scalars['String']>;
  candidateId: Scalars['String'];
};


export type QueryGetCandidateNoteMentionsArgs = {
  candidateId: Scalars['String'];
};


export type QueryGetCandidateProfileArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetCandidateResumesArgs = {
  id: Scalars['String'];
};


export type QueryGetFileArgs = {
  id: Scalars['String'];
};


export type QueryGetSavedQueriesArgs = {
  key: SavedQueryKey;
};


export type QueryInvitationArgs = {
  input: GetInvitationInput;
};


export type QueryInvitationsArgs = {
  input: InvitationListInput;
};


export type QueryListProductsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMailContentArgs = {
  type: Scalars['String'];
};


export type QueryMailContentDynamicDataArgs = {
  emailType: Scalars['String'];
};


export type QueryMailContentsArgs = {
  input: MailContentListInput;
};


export type QueryPreviewInvitationEmailArgs = {
  input: SendInvitationEmailInput;
};


export type QuerySearchLocationsArgs = {
  query: Scalars['String'];
};


export type QueryUniversitySuggestionsArgs = {
  input: SuggestionsInput;
};

export type QuestionnaireAnswerDto = {
  __typename?: 'QuestionnaireAnswerDto';
  answer: Scalars['String'];
  key: Scalars['String'];
  question: Scalars['String'];
};

export type QuestionnaireAnswerInput = {
  answer: Scalars['String'];
  key: Scalars['String'];
  question: Scalars['String'];
};

export type RemoveCandidateProgramStageInput = {
  programId: Scalars['String'];
  stageId: Scalars['String'];
};

export type RolesDto = {
  __typename?: 'RolesDto';
  admin: Scalars['Boolean'];
  advisor: Scalars['Boolean'];
  enrolled: Scalars['Boolean'];
  prospect: Scalars['Boolean'];
  waitlist: Scalars['Boolean'];
};

export type SavedQueryDto = {
  __typename?: 'SavedQueryDto';
  _id: Scalars['String'];
  createdByUserId?: Maybe<Scalars['String']>;
  key: SavedQueryKey;
  label: Scalars['String'];
  querystring: Scalars['String'];
  shared: Scalars['Boolean'];
};

export type SavedQueryInput = {
  key: SavedQueryKey;
  label: Scalars['String'];
  querystring: Scalars['String'];
  shared?: InputMaybe<Scalars['Boolean']>;
};

/** The key for the saved query */
export enum SavedQueryKey {
  AdminCandidateList = 'AdminCandidateList'
}

export type ScheduleCandidateEnrolmentInterviewInput = {
  calendlyEventInviteeUri: Scalars['String'];
  calendlyEventUri: Scalars['String'];
};

export type SendEmailInput = {
  body: Scalars['String'];
  candidateIds: Array<Scalars['String']>;
  subject: Scalars['String'];
};

export type SendInvitationEmailInput = {
  selectedIds?: InputMaybe<Array<Scalars['String']>>;
  sendToAll: Scalars['Boolean'];
};

export type SendMessageInput = {
  candidateId: Scalars['String'];
  message: Scalars['String'];
  type: MessageType;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SuggestionResponseOption = {
  __typename?: 'SuggestionResponseOption';
  _id: Scalars['String'];
  label: Scalars['String'];
};

export type SuggestionsInput = {
  paging: PagingInput;
  search?: InputMaybe<Scalars['String']>;
};

export type SuggestionsResponse = {
  __typename?: 'SuggestionsResponse';
  options: Array<SuggestionResponseOption>;
  total: Scalars['Float'];
};

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type UpdateAdvisorProfileInput = {
  about?: InputMaybe<Scalars['String']>;
  calendlyLink?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<UpdatePhoneNumberInput>;
  role?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<ProfileSkillInput>>;
};

export type UpdateCandidateCohortInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type UpdateCandidateCourseProgressInput = {
  candidateId: Scalars['String'];
  courseId: Scalars['String'];
  deadline?: InputMaybe<Scalars['DateTime']>;
  progress: CandidateCourseProgress;
};

export type UpdateCandidateDocumentMetadataInput = {
  fileId: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateCandidateEnrolmentApplicationInput = {
  communityContactStatus?: InputMaybe<CandidateEnrolmentCommunityContactStatus>;
  documents?: InputMaybe<CandidateEnrolmentDocumentsInput>;
  education?: InputMaybe<CandidateEnrolmentEducationInput>;
  questionnaireAnswers?: InputMaybe<Array<QuestionnaireAnswerInput>>;
};

export type UpdateCandidateLabelsInput = {
  candidateIds: Array<Scalars['String']>;
  labels: Array<Scalars['String']>;
};

export type UpdateCandidateProfileInput = {
  about?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<UpdateAddressInput>;
  courseTitle?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['DateTime']>;
  desiredCareer?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<Array<Scalars['String']>>;
  jobTitle?: InputMaybe<Scalars['String']>;
  latestResume?: InputMaybe<UserDocumentInput>;
  phone?: InputMaybe<UpdatePhoneNumberInput>;
  programId?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<ProfileSkillInput>>;
};

export type UpdateCandidateProgramInput = {
  candidateAgreement?: InputMaybe<UserDocumentInput>;
  invitationEmailType?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Float']>;
  welcomeEmailType?: InputMaybe<Scalars['String']>;
};

export type UpdateCourseInput = {
  description?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<CourseLinkInput>>;
  name: Scalars['String'];
  stripeProductId?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type UpdateEmailPreferenceInput = {
  enabled: Scalars['Boolean'];
  key: Scalars['String'];
};

export type UpdateEmployeeInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  roles: EmployeeRolesInput;
};

export type UpdateMailContentInput = {
  body: Scalars['String'];
  locale: Scalars['String'];
  subject: Scalars['String'];
  type: Scalars['String'];
};

export type UpdatePhoneNumberInput = {
  countryCode: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<UpdatePhoneNumberInput>;
  picture?: InputMaybe<UserDocumentInput>;
  pronouns?: InputMaybe<Scalars['String']>;
};

export type UserDocumentDto = {
  __typename?: 'UserDocumentDto';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type UserDocumentInput = {
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type UserDto = {
  __typename?: 'UserDto';
  _id: Scalars['String'];
  email: Scalars['String'];
  enrolmentApplicationSubmitted: Scalars['Boolean'];
  firstName: Scalars['String'];
  hasPassword?: Maybe<Scalars['Boolean']>;
  isVerified: Scalars['Boolean'];
  lastName: Scalars['String'];
  phone?: Maybe<PhoneNumberDto>;
  picture?: Maybe<UserDocumentDto>;
  pictureUrl?: Maybe<Scalars['String']>;
  profileCompleted?: Maybe<Scalars['Boolean']>;
  pronouns?: Maybe<Scalars['String']>;
  roles: RolesDto;
  unreadNotifications?: Maybe<Scalars['Float']>;
};

export type VerifyCandidateDto = {
  __typename?: 'VerifyCandidateDto';
  token: Scalars['String'];
  user: UserDto;
};

export type AdvisorProfileFragment = { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, socialLinks?: { __typename?: 'ProfileSocialLinksDto', facebook?: string | null, github?: string | null, instagram?: string | null, linkedin?: string | null, twitter?: string | null, website?: string | null, youtube?: string | null } | null };

export type UpdateAdvisorProfileMutationVariables = Exact<{
  input: UpdateAdvisorProfileInput;
}>;


export type UpdateAdvisorProfileMutation = { __typename?: 'Mutation', updateAdvisorProfile: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, socialLinks?: { __typename?: 'ProfileSocialLinksDto', facebook?: string | null, github?: string | null, instagram?: string | null, linkedin?: string | null, twitter?: string | null, website?: string | null, youtube?: string | null } | null } };

export type GetAdvisorProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdvisorProfileQuery = { __typename?: 'Query', getAdvisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, socialLinks?: { __typename?: 'ProfileSocialLinksDto', facebook?: string | null, github?: string | null, instagram?: string | null, linkedin?: string | null, twitter?: string | null, website?: string | null, youtube?: string | null } | null } | null };

export type AuditLogUserDetailsFragment = { __typename?: 'AuditLogUserDetailsDto', _id: string, firstName: string, lastName: string, profilePictureUrl?: string | null };

export type AuditLogFragment = { __typename?: 'AuditLogDto', _id: string, sourceName?: string | null, affectedName?: string | null, action: string, category: string, timestamp: any, sourceUser?: { __typename?: 'AuditLogUserDetailsDto', _id: string, firstName: string, lastName: string, profilePictureUrl?: string | null } | null, affected: { __typename?: 'AuditLogEntityDto', _id: string, type: AuditLogEntityType }, additionalData: Array<{ __typename?: 'AuditLogAdditionalDataDto', key: string, value: string }>, detail?: { __typename?: 'AuditLogDetailDto', type: AuditLogDetailType, content: string } | null };

export type GetAuditLogsQueryVariables = Exact<{
  input: AuditLogListInput;
}>;


export type GetAuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'AuditLogListDto', total: number, items: Array<{ __typename?: 'AuditLogDto', _id: string, sourceName?: string | null, affectedName?: string | null, action: string, category: string, timestamp: any, sourceUser?: { __typename?: 'AuditLogUserDetailsDto', _id: string, firstName: string, lastName: string, profilePictureUrl?: string | null } | null, affected: { __typename?: 'AuditLogEntityDto', _id: string, type: AuditLogEntityType }, additionalData: Array<{ __typename?: 'AuditLogAdditionalDataDto', key: string, value: string }>, detail?: { __typename?: 'AuditLogDetailDto', type: AuditLogDetailType, content: string } | null }> } };

export type RolesFragment = { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean };

export type UserDocumentFragment = { __typename?: 'UserDocumentDto', fileId: string, fileName: string };

export type UserFragment = { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me: { __typename?: 'UserDto', unreadNotifications?: number | null, _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ForgotPasswordResetMutationVariables = Exact<{
  input: ForgotPasswordResetInput;
}>;


export type ForgotPasswordResetMutation = { __typename?: 'Mutation', forgotPasswordReset: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  id: Scalars['String'];
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } };

export type CandidateJobFragment = { __typename?: 'CandidateJobDto', _id: string, userId: string, jobId: string, status: string, createdAt: any, updatedAt: any, job: { __typename?: 'JobDto', title: string, description: string, location: string, employer: string, employerLogo?: string | null, reqId: string, industry?: string | null, jobFunction?: string | null, type?: string | null, remote?: boolean | null, website?: string | null } };

export type CandidateJobsQueryVariables = Exact<{
  input: CandidateJobsListInput;
}>;


export type CandidateJobsQuery = { __typename?: 'Query', candidateJobs: { __typename?: 'CandidateJobListDto', total: number, items: Array<{ __typename?: 'CandidateJobDto', _id: string, userId: string, jobId: string, status: string, createdAt: any, updatedAt: any, job: { __typename?: 'JobDto', title: string, description: string, location: string, employer: string, employerLogo?: string | null, reqId: string, industry?: string | null, jobFunction?: string | null, type?: string | null, remote?: boolean | null, website?: string | null } }> } };

export type CandidateLabelFragment = { __typename?: 'CandidateLabelDto', _id: string, label: string, color: string };

export type CandidateLabelWithCountFragment = { __typename?: 'CandidateLabelDto', candidateCount?: number | null, _id: string, label: string, color: string };

export type CandidateLabelsQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateLabelsQuery = { __typename?: 'Query', candidateLabels: Array<{ __typename?: 'CandidateLabelDto', _id: string, label: string, color: string }> };

export type CandidateLabelQueryVariables = Exact<{
  labelId: Scalars['String'];
}>;


export type CandidateLabelQuery = { __typename?: 'Query', candidateLabel: { __typename?: 'CandidateLabelDto', candidateCount?: number | null, _id: string, label: string, color: string } };

export type CandidateLabelsWithCountQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateLabelsWithCountQuery = { __typename?: 'Query', candidateLabels: Array<{ __typename?: 'CandidateLabelDto', candidateCount?: number | null, _id: string, label: string, color: string }> };

export type UpdateCandidateLabelsMutationVariables = Exact<{
  input: UpdateCandidateLabelsInput;
}>;


export type UpdateCandidateLabelsMutation = { __typename?: 'Mutation', updateCandidateLabels: boolean };

export type CreateCandidateLabelMutationVariables = Exact<{
  input: CreateUpdateCandidateLabelInput;
}>;


export type CreateCandidateLabelMutation = { __typename?: 'Mutation', createCandidateLabel: { __typename?: 'CandidateLabelDto', _id: string, label: string, color: string } };

export type UpdateCandidateLabelMutationVariables = Exact<{
  input: CreateUpdateCandidateLabelInput;
  labelId: Scalars['String'];
}>;


export type UpdateCandidateLabelMutation = { __typename?: 'Mutation', updateCandidateLabel: { __typename?: 'CandidateLabelDto', _id: string, label: string, color: string } };

export type DeleteCandidateLabelMutationVariables = Exact<{
  labelId: Scalars['String'];
}>;


export type DeleteCandidateLabelMutation = { __typename?: 'Mutation', deleteCandidateLabel: boolean };

export type ProgramSummaryFragment = { __typename?: 'CandidateProgramDto', _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean };

export type ProgramStageRequirementFragment = { __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number };

export type ProgramStageFragment = { __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> };

export type ProgramDetailFragment = { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> };

export type MyProgramFragment = { __typename?: 'CandidateProgramDto', _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> };

export type ListProgramsQueryVariables = Exact<{
  input: CandidateProgramListInput;
}>;


export type ListProgramsQuery = { __typename?: 'Query', candidatePrograms: { __typename?: 'CandidateProgramListDto', total: number, items: Array<{ __typename?: 'CandidateProgramDto', _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean }> } };

export type GetProgramQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProgramQuery = { __typename?: 'Query', candidateProgram: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type GetMyProgramQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProgramQuery = { __typename?: 'Query', myProgram: { __typename?: 'CandidateProgramDto', _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> } };

export type CreateProgramMutationVariables = Exact<{
  input: CreateCandidateProgramInput;
}>;


export type CreateProgramMutation = { __typename?: 'Mutation', createCandidateProgram: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type UpdateProgramMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateCandidateProgramInput;
}>;


export type UpdateProgramMutation = { __typename?: 'Mutation', updateCandidateProgram: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type CandidateProgramSuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type CandidateProgramSuggestionsQuery = { __typename?: 'Query', candidateProgramSuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type AssignCandidateToProgramMutationVariables = Exact<{
  input: AssignCandidateProgramInput;
}>;


export type AssignCandidateToProgramMutation = { __typename?: 'Mutation', assignCandidateToProgram: boolean };

export type AddStageToProgramMutationVariables = Exact<{
  programId: Scalars['String'];
  input: AddCandidateProgramStageInput;
}>;


export type AddStageToProgramMutation = { __typename?: 'Mutation', addStageToProgram: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type EditProgramStageMutationVariables = Exact<{
  input: EditCandidateProgramStageInput;
}>;


export type EditProgramStageMutation = { __typename?: 'Mutation', editProgramStage: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type EditProgramStageEmailsMutationVariables = Exact<{
  input: EditCandidateProgramStageEmailsInput;
}>;


export type EditProgramStageEmailsMutation = { __typename?: 'Mutation', editProgramStageEmails: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type RemoveStageFromProgramMutationVariables = Exact<{
  input: RemoveCandidateProgramStageInput;
}>;


export type RemoveStageFromProgramMutation = { __typename?: 'Mutation', removeStageFromProgram: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type UpdateProgramStageRequirementsMutationVariables = Exact<{
  programId: Scalars['String'];
  stageKey: Scalars['String'];
  requirements: Array<AddCandidateProgramRequirementInput> | AddCandidateProgramRequirementInput;
}>;


export type UpdateProgramStageRequirementsMutation = { __typename?: 'Mutation', updateProgramStageRequirements: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type UpdateProgramApplicationRequirementsMutationVariables = Exact<{
  programId: Scalars['String'];
  requirements: Array<AddCandidateProgramRequirementInput> | AddCandidateProgramRequirementInput;
}>;


export type UpdateProgramApplicationRequirementsMutation = { __typename?: 'Mutation', updateProgramApplicationRequirements: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> } };

export type ProgramStageRequirementCompletionFragment = { __typename?: 'CandidateProgramStageRequirementCompletionDto', requirementKey: string, completed: boolean, completionDate: any, completedBy: string, linkedDocumentId?: string | null, linkedDocumentName?: string | null };

export type ProgramStageProgressFragment = { __typename?: 'CandidateProgramStageProgressDto', stageKey: string, requirementsCompleted: boolean, startDate: any, endDate?: any | null, completedRequirements: Array<{ __typename?: 'CandidateProgramStageRequirementCompletionDto', requirementKey: string, completed: boolean, completionDate: any, completedBy: string, linkedDocumentId?: string | null, linkedDocumentName?: string | null }> };

export type ProgramProgressFragment = { __typename?: 'CandidateProgramProgressDto', candidateId: string, programId: string, acceptedAgreement: boolean, currentStage: string, creationDate: any, updatedDate: any, program: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> }, stages: Array<{ __typename?: 'CandidateProgramStageProgressDto', stageKey: string, requirementsCompleted: boolean, startDate: any, endDate?: any | null, completedRequirements: Array<{ __typename?: 'CandidateProgramStageRequirementCompletionDto', requirementKey: string, completed: boolean, completionDate: any, completedBy: string, linkedDocumentId?: string | null, linkedDocumentName?: string | null }> }> };

export type GetCandidateProgramProgressQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetCandidateProgramProgressQuery = { __typename?: 'Query', candidateProgramProgress: { __typename?: 'CandidateProgramProgressDto', candidateId: string, programId: string, acceptedAgreement: boolean, currentStage: string, creationDate: any, updatedDate: any, program: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> }, stages: Array<{ __typename?: 'CandidateProgramStageProgressDto', stageKey: string, requirementsCompleted: boolean, startDate: any, endDate?: any | null, completedRequirements: Array<{ __typename?: 'CandidateProgramStageRequirementCompletionDto', requirementKey: string, completed: boolean, completionDate: any, completedBy: string, linkedDocumentId?: string | null, linkedDocumentName?: string | null }> }> } };

export type GetMyProgramProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProgramProgressQuery = { __typename?: 'Query', myProgramProgress: { __typename?: 'CandidateProgramProgressDto', candidateId: string, programId: string, acceptedAgreement: boolean, currentStage: string, creationDate: any, updatedDate: any, program: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> }, stages: Array<{ __typename?: 'CandidateProgramStageProgressDto', stageKey: string, requirementsCompleted: boolean, startDate: any, endDate?: any | null, completedRequirements: Array<{ __typename?: 'CandidateProgramStageRequirementCompletionDto', requirementKey: string, completed: boolean, completionDate: any, completedBy: string, linkedDocumentId?: string | null, linkedDocumentName?: string | null }> }> } };

export type UpdateProgramStageRequirementCompletionMutationVariables = Exact<{
  input: CompleteCandidateProgramStageRequirementInput;
}>;


export type UpdateProgramStageRequirementCompletionMutation = { __typename?: 'Mutation', updateProgramStageRequirementCompletion: boolean };

export type MoveCandidateToNextProgramStageMutationVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type MoveCandidateToNextProgramStageMutation = { __typename?: 'Mutation', moveCandidateToNextProgramStage: boolean };

export type AcceptCandidateAgreementMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptCandidateAgreementMutation = { __typename?: 'Mutation', acceptCandidateAgreement: boolean };

export type CandidateAdvisorFragment = { __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null };

export type CandidateProfileFragment = { __typename?: 'CandidateProfileDto', advisorIds?: Array<string> | null, candidateId?: string | null, cohortId?: string | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null };

export type EnrolmentDocumentFragment = { __typename?: 'UserDocumentDto', fileId: string, fileName: string };

export type CandidateEnrolmentInterviewFragment = { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean };

export type CandidateEnrolmentApplicationFragment = { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, invitedForInterview: boolean, communityContactStatus?: CandidateEnrolmentCommunityContactStatus | null, submitted: boolean, updatedAt?: any | null, documents?: { __typename?: 'CandidateEnrolmentDocumentsDto', i20?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, resume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, coverLetter?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, transcript?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null } | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', studyLevel?: string | null, university?: string | null, fieldOfStudy?: string | null, isFinalYearOfStudy?: boolean | null, gpa?: number | null, eligibleForOpt?: boolean | null, graduationDate?: any | null } | null, questionnaireAnswers?: Array<{ __typename?: 'QuestionnaireAnswerDto', question: string, answer: string, key: string }> | null, interview?: { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean } | null };

export type CandidateResumeFragment = { __typename?: 'CandidateResumeDto', _id: string, userId: string, uploadedAt: any, file: { __typename?: 'CandidateResumeFileDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string } };

export type CandidateCourseFragment = { __typename?: 'CandidateCourseDto', _id: string, candidateId: string, courseId: string, progress: CandidateCourseProgress, deadline?: any | null, course: { __typename?: 'CourseDto', _id: string, name: string, subject: string, description?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }, invoice?: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } | null };

export type CandidateCourseWithProductFragment = { __typename?: 'CandidateCourseDto', _id: string, candidateId: string, courseId: string, progress: CandidateCourseProgress, deadline?: any | null, stripeProduct?: { __typename?: 'ProductDto', stripeId: string, name: string, price: number } | null, course: { __typename?: 'CourseDto', _id: string, name: string, subject: string, description?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }, invoice?: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } | null };

export type CandidateDocumentFragment = { __typename?: 'CandidateDocumentDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string, userId: string, uploadedAt: any, uploadedBy?: string | null, uploadedByUserId?: string | null, label?: string | null, requirementKey?: string | null };

export type CandidateSignupMutationVariables = Exact<{
  input: CandidateSignupInput;
}>;


export type CandidateSignupMutation = { __typename?: 'Mutation', candidateSignup: { __typename?: 'CandidateSignupDto', user: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } } };

export type UpdateCandidateProfileMutationVariables = Exact<{
  input: UpdateCandidateProfileInput;
  id?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCandidateProfileMutation = { __typename?: 'Mutation', updateCandidateProfile: { __typename?: 'CandidateProfileDto', advisorIds?: Array<string> | null, candidateId?: string | null, cohortId?: string | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null } };

export type GetCandidateProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCandidateProfileQuery = { __typename?: 'Query', getCandidateProfile?: { __typename?: 'CandidateProfileDto', advisorIds?: Array<string> | null, candidateId?: string | null, cohortId?: string | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null } | null };

export type UpdateCandidateEnrolmentApplicationMutationVariables = Exact<{
  input: UpdateCandidateEnrolmentApplicationInput;
}>;


export type UpdateCandidateEnrolmentApplicationMutation = { __typename?: 'Mutation', updateCandidateEnrolmentApplication: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, invitedForInterview: boolean, communityContactStatus?: CandidateEnrolmentCommunityContactStatus | null, submitted: boolean, updatedAt?: any | null, documents?: { __typename?: 'CandidateEnrolmentDocumentsDto', i20?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, resume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, coverLetter?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, transcript?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null } | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', studyLevel?: string | null, university?: string | null, fieldOfStudy?: string | null, isFinalYearOfStudy?: boolean | null, gpa?: number | null, eligibleForOpt?: boolean | null, graduationDate?: any | null } | null, questionnaireAnswers?: Array<{ __typename?: 'QuestionnaireAnswerDto', question: string, answer: string, key: string }> | null, interview?: { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean } | null } };

export type GetCandidateEnrolmentApplicationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCandidateEnrolmentApplicationQuery = { __typename?: 'Query', getCandidateEnrolmentApplication?: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, invitedForInterview: boolean, communityContactStatus?: CandidateEnrolmentCommunityContactStatus | null, submitted: boolean, updatedAt?: any | null, documents?: { __typename?: 'CandidateEnrolmentDocumentsDto', i20?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, resume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, coverLetter?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, transcript?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null } | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', studyLevel?: string | null, university?: string | null, fieldOfStudy?: string | null, isFinalYearOfStudy?: boolean | null, gpa?: number | null, eligibleForOpt?: boolean | null, graduationDate?: any | null } | null, questionnaireAnswers?: Array<{ __typename?: 'QuestionnaireAnswerDto', question: string, answer: string, key: string }> | null, interview?: { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean } | null } | null };

export type CandidateSummaryFragment = { __typename?: 'CandidateDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, programName?: string | null, programStage?: string | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean }, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, candidateProfile?: { __typename?: 'CandidateProfileDto', candidateId?: string | null, cohortId?: string | null, bookmarked?: boolean | null, advisorIds?: Array<string> | null, labels?: Array<string> | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string }> | null, courses?: Array<{ __typename?: 'CourseDto', _id: string, name: string }> | null } | null, enrolmentApplication?: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, submittedAt?: any | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', university?: string | null } | null } | null, progress?: { __typename?: 'CandidateProgramProgressDto', currentStage: string } | null };

export type CandidateProfileDetailedFragment = { __typename?: 'CandidateProfileDto', advisorIds?: Array<string> | null, candidateId?: string | null, cohortId?: string | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null };

export type CandidateDetailedFragment = { __typename?: 'CandidateDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, programName?: string | null, programStage?: string | null, candidateProfile?: { __typename?: 'CandidateProfileDto', candidateId?: string | null, cohortId?: string | null, bookmarked?: boolean | null, advisorIds?: Array<string> | null, labels?: Array<string> | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, courses?: Array<{ __typename?: 'CourseDto', _id: string, name: string }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null } | null, enrolmentApplication?: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, submittedAt?: any | null, invitedForInterview: boolean, communityContactStatus?: CandidateEnrolmentCommunityContactStatus | null, submitted: boolean, updatedAt?: any | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', university?: string | null, studyLevel?: string | null, fieldOfStudy?: string | null, isFinalYearOfStudy?: boolean | null, gpa?: number | null, eligibleForOpt?: boolean | null, graduationDate?: any | null } | null, documents?: { __typename?: 'CandidateEnrolmentDocumentsDto', i20?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, resume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, coverLetter?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, transcript?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null } | null, questionnaireAnswers?: Array<{ __typename?: 'QuestionnaireAnswerDto', question: string, answer: string, key: string }> | null, interview?: { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean } | null } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean }, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, progress?: { __typename?: 'CandidateProgramProgressDto', currentStage: string } | null };

export type ListCandidatesQueryVariables = Exact<{
  input: CandidateListInput;
}>;


export type ListCandidatesQuery = { __typename?: 'Query', candidates: { __typename?: 'CandidateListDto', total: number, items: Array<{ __typename?: 'CandidateDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, programName?: string | null, programStage?: string | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean }, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, candidateProfile?: { __typename?: 'CandidateProfileDto', candidateId?: string | null, cohortId?: string | null, bookmarked?: boolean | null, advisorIds?: Array<string> | null, labels?: Array<string> | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string }> | null, courses?: Array<{ __typename?: 'CourseDto', _id: string, name: string }> | null } | null, enrolmentApplication?: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, submittedAt?: any | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', university?: string | null } | null } | null, progress?: { __typename?: 'CandidateProgramProgressDto', currentStage: string } | null }> } };

export type GetCandidateQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCandidateQuery = { __typename?: 'Query', candidate: { __typename?: 'CandidateDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, programName?: string | null, programStage?: string | null, candidateProfile?: { __typename?: 'CandidateProfileDto', candidateId?: string | null, cohortId?: string | null, bookmarked?: boolean | null, advisorIds?: Array<string> | null, labels?: Array<string> | null, dateOfBirth?: any | null, courseTitle?: string | null, jobTitle?: string | null, desiredCareer?: string | null, about?: string | null, interests?: Array<string> | null, programId?: string | null, advisors?: Array<{ __typename?: 'CandidateProfileAdvisorDto', _id: string, firstName: string, lastName: string, email: string, pictureUrl?: string | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, advisorProfile?: { __typename?: 'AdvisorProfileDto', about?: string | null, role?: string | null, calendlyLink?: string | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string }> } | null }> | null, courses?: Array<{ __typename?: 'CourseDto', _id: string, name: string }> | null, cohort?: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } | null, address?: { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null } | null, latestResume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, skills: Array<{ __typename?: 'ProfileSkillDto', name: string, fromResume: boolean }>, program?: { __typename?: 'CandidateProgramDto', _id: string, name: string } | null } | null, enrolmentApplication?: { __typename?: 'CandidateEnrolmentApplicationDto', status: CandidateEnrolmentApplicationStatus, submittedAt?: any | null, invitedForInterview: boolean, communityContactStatus?: CandidateEnrolmentCommunityContactStatus | null, submitted: boolean, updatedAt?: any | null, education?: { __typename?: 'CandidateEnrolmentEducationDto', university?: string | null, studyLevel?: string | null, fieldOfStudy?: string | null, isFinalYearOfStudy?: boolean | null, gpa?: number | null, eligibleForOpt?: boolean | null, graduationDate?: any | null } | null, documents?: { __typename?: 'CandidateEnrolmentDocumentsDto', i20?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, resume?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, coverLetter?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, transcript?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null } | null, questionnaireAnswers?: Array<{ __typename?: 'QuestionnaireAnswerDto', question: string, answer: string, key: string }> | null, interview?: { __typename?: 'CandidateEnrolmentInterviewDto', joinUrl?: string | null, rescheduleUrl?: string | null, start: any, end: any, scheduledAt: any, calendlyEventUri: string, calendlyInviteeUri: string, completed: boolean } | null } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean }, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, progress?: { __typename?: 'CandidateProgramProgressDto', currentStage: string } | null } };

export type SubmitCandidateEnrolmentApplicationMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitCandidateEnrolmentApplicationMutation = { __typename?: 'Mutation', submitCandidateEnrolmentApplication: boolean };

export type AcceptCandidateEnrolmentApplicationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type AcceptCandidateEnrolmentApplicationMutation = { __typename?: 'Mutation', acceptCandidateEnrolmentApplication: boolean };

export type WaitlistCandidateEnrolmentApplicationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type WaitlistCandidateEnrolmentApplicationMutation = { __typename?: 'Mutation', waitlistCandidateEnrolmentApplication: boolean };

export type GetCandidateCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCandidateCountsQuery = { __typename?: 'Query', candidateCounts: { __typename?: 'CandidateCountsDto', prospect: number, enrolled: number, waitlist: number, admitted: number } };

export type VerifyCandidateMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyCandidateMutation = { __typename?: 'Mutation', verifyCandidate: { __typename?: 'VerifyCandidateDto', token: string, user: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pronouns?: string | null, email: string, pictureUrl?: string | null, isVerified: boolean, enrolmentApplicationSubmitted: boolean, hasPassword?: boolean | null, profileCompleted?: boolean | null, phone?: { __typename?: 'PhoneNumberDto', countryCode: string, phoneNumber: string } | null, roles: { __typename?: 'RolesDto', admin: boolean, waitlist: boolean, enrolled: boolean, prospect: boolean, advisor: boolean } } } };

export type ScheduleCandidateEnrolmentInterviewMutationVariables = Exact<{
  input: ScheduleCandidateEnrolmentInterviewInput;
}>;


export type ScheduleCandidateEnrolmentInterviewMutation = { __typename?: 'Mutation', scheduleCandidateEnrolmentInterview: boolean };

export type EnrolMutationVariables = Exact<{ [key: string]: never; }>;


export type EnrolMutation = { __typename?: 'Mutation', enrol: boolean };

export type CouponFragment = { __typename?: 'CouponDto', id: string, name: string, appliesToProductIds?: Array<string> | null, discount: number, timesRedeemed: number, maxRedemptions: number, valid: boolean };

export type CouponSummaryFragment = { __typename?: 'CouponDto', id: string, name: string, discount: number };

export type InvoiceFragment = { __typename?: 'CandidateInvoiceDto', _id: string, description: string, status: CandidateInvoiceStatus, stripeCouponIds?: Array<string> | null, productTotalAmount: number, couponDiscountAmount: number, totalAmount: number, creationDate: any, updatedAt: any, stripeCharge?: { __typename?: 'CandidateInvoiceStripeChargeDto', amount: number, currency: string, receiptUrl?: string | null } | null };

export type MyInvoiceFragment = { __typename?: 'CandidateInvoiceDto', hostedInvoiceUrl?: string | null, _id: string, description: string, status: CandidateInvoiceStatus, stripeCouponIds?: Array<string> | null, productTotalAmount: number, couponDiscountAmount: number, totalAmount: number, creationDate: any, updatedAt: any, coupons?: Array<{ __typename?: 'CouponDto', id: string, name: string, discount: number }> | null, stripeCharge?: { __typename?: 'CandidateInvoiceStripeChargeDto', amount: number, currency: string, receiptUrl?: string | null } | null };

export type AdminInvoiceFragment = { __typename?: 'CandidateInvoiceDto', _id: string, description: string, status: CandidateInvoiceStatus, stripeCouponIds?: Array<string> | null, productTotalAmount: number, couponDiscountAmount: number, totalAmount: number, creationDate: any, updatedAt: any, coupons?: Array<{ __typename?: 'CouponDto', id: string, name: string, appliesToProductIds?: Array<string> | null, discount: number, timesRedeemed: number, maxRedemptions: number, valid: boolean }> | null, stripeCharge?: { __typename?: 'CandidateInvoiceStripeChargeDto', amount: number, currency: string, receiptUrl?: string | null } | null };

export type GetMyInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyInvoicesQuery = { __typename?: 'Query', getMyInvoices: Array<{ __typename?: 'CandidateInvoiceDto', hostedInvoiceUrl?: string | null, _id: string, description: string, status: CandidateInvoiceStatus, stripeCouponIds?: Array<string> | null, productTotalAmount: number, couponDiscountAmount: number, totalAmount: number, creationDate: any, updatedAt: any, coupons?: Array<{ __typename?: 'CouponDto', id: string, name: string, discount: number }> | null, stripeCharge?: { __typename?: 'CandidateInvoiceStripeChargeDto', amount: number, currency: string, receiptUrl?: string | null } | null }> };

export type GetCandidateInvoicesQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetCandidateInvoicesQuery = { __typename?: 'Query', getCandidateInvoices: Array<{ __typename?: 'CandidateInvoiceDto', _id: string, description: string, status: CandidateInvoiceStatus, stripeCouponIds?: Array<string> | null, productTotalAmount: number, couponDiscountAmount: number, totalAmount: number, creationDate: any, updatedAt: any, coupons?: Array<{ __typename?: 'CouponDto', id: string, name: string, appliesToProductIds?: Array<string> | null, discount: number, timesRedeemed: number, maxRedemptions: number, valid: boolean }> | null, stripeCharge?: { __typename?: 'CandidateInvoiceStripeChargeDto', amount: number, currency: string, receiptUrl?: string | null } | null }> };

export type GetCouponsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCouponsQuery = { __typename?: 'Query', getCoupons: Array<{ __typename?: 'CouponDto', id: string, name: string, appliesToProductIds?: Array<string> | null, discount: number, timesRedeemed: number, maxRedemptions: number, valid: boolean }> };

export type HasOutstandingInvoiceQueryVariables = Exact<{ [key: string]: never; }>;


export type HasOutstandingInvoiceQuery = { __typename?: 'Query', hasOutstandingInvoice: boolean };

export type GetCandidateCoursesQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetCandidateCoursesQuery = { __typename?: 'Query', getCandidateCourses?: Array<{ __typename?: 'CandidateCourseDto', _id: string, candidateId: string, courseId: string, progress: CandidateCourseProgress, deadline?: any | null, course: { __typename?: 'CourseDto', _id: string, name: string, subject: string, description?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }, invoice?: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } | null }> | null };

export type GetCandidateCoursesWithProductQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetCandidateCoursesWithProductQuery = { __typename?: 'Query', getCandidateCourses?: Array<{ __typename?: 'CandidateCourseDto', _id: string, candidateId: string, courseId: string, progress: CandidateCourseProgress, deadline?: any | null, stripeProduct?: { __typename?: 'ProductDto', stripeId: string, name: string, price: number } | null, course: { __typename?: 'CourseDto', _id: string, name: string, subject: string, description?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }, invoice?: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } | null }> | null };

export type GetMyCoursesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCoursesQuery = { __typename?: 'Query', getMyCourses?: Array<{ __typename?: 'CandidateCourseDto', _id: string, candidateId: string, courseId: string, progress: CandidateCourseProgress, deadline?: any | null, course: { __typename?: 'CourseDto', _id: string, name: string, subject: string, description?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }, invoice?: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } | null }> | null };

export type GetCandidateDocumentsQueryVariables = Exact<{
  candidateId: Scalars['String'];
  input: CandidateDocumentListFilterInput;
}>;


export type GetCandidateDocumentsQuery = { __typename?: 'Query', getCandidateDocuments: { __typename?: 'CandidateDocumentListDto', total: number, items: Array<{ __typename?: 'CandidateDocumentDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string, userId: string, uploadedAt: any, uploadedBy?: string | null, uploadedByUserId?: string | null, label?: string | null, requirementKey?: string | null }> } };

export type GetMyDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyDocumentsQuery = { __typename?: 'Query', getMyDocuments: { __typename?: 'CandidateDocumentListDto', total: number, items: Array<{ __typename?: 'CandidateDocumentDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string, userId: string, uploadedAt: any, uploadedBy?: string | null, uploadedByUserId?: string | null, label?: string | null, requirementKey?: string | null }> } };

export type DeleteCandidateDocumentMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCandidateDocumentMutation = { __typename?: 'Mutation', deleteCandidateDocument: boolean };

export type UpdateCandidateDocumentMetadataMutationVariables = Exact<{
  input: UpdateCandidateDocumentMetadataInput;
}>;


export type UpdateCandidateDocumentMetadataMutation = { __typename?: 'Mutation', updateCandidateDocumentMetadata: { __typename?: 'CandidateDocumentDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string, userId: string, uploadedAt: any, uploadedBy?: string | null, uploadedByUserId?: string | null, label?: string | null, requirementKey?: string | null } };

export type GetMyResumesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyResumesQuery = { __typename?: 'Query', getMyResumes: Array<{ __typename?: 'CandidateResumeDto', _id: string, userId: string, uploadedAt: any, file: { __typename?: 'CandidateResumeFileDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string } }> };

export type GetCandidateResumesQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCandidateResumesQuery = { __typename?: 'Query', getCandidateResumes: Array<{ __typename?: 'CandidateResumeDto', _id: string, userId: string, uploadedAt: any, file: { __typename?: 'CandidateResumeFileDto', _id: string, name: string, mimeType: MimeType, contentLength: number, key: string } }> };

export type DeleteResumeMutationVariables = Exact<{
  resumeId: Scalars['String'];
}>;


export type DeleteResumeMutation = { __typename?: 'Mutation', deleteResume: boolean };

export type BookmarkCandidateMutationVariables = Exact<{
  id: Scalars['String'];
  bookmarked: Scalars['Boolean'];
}>;


export type BookmarkCandidateMutation = { __typename?: 'Mutation', bookmarkCandidate: boolean };

export type UniversitySuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
}>;


export type UniversitySuggestionsQuery = { __typename?: 'Query', universitySuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type CandidateDocumentLabelSuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
}>;


export type CandidateDocumentLabelSuggestionsQuery = { __typename?: 'Query', candidateDocumentLabelSuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type AssignAdvisorToCandidateMutationVariables = Exact<{
  candidateId: Scalars['String'];
  advisorId: Scalars['String'];
}>;


export type AssignAdvisorToCandidateMutation = { __typename?: 'Mutation', assignAdvisorToCandidate: boolean };

export type RemoveAdvisorFromCandidateMutationVariables = Exact<{
  candidateId: Scalars['String'];
  advisorId: Scalars['String'];
}>;


export type RemoveAdvisorFromCandidateMutation = { __typename?: 'Mutation', removeAdvisorFromCandidate: boolean };

export type AssignAdvisorToCandidatesMutationVariables = Exact<{
  input: AssignAdvisorToCandidatesInput;
}>;


export type AssignAdvisorToCandidatesMutation = { __typename?: 'Mutation', assignAdvisorToCandidates: boolean };

export type NoteMentionFragment = { __typename?: 'NoteMentionDto', userId: string, name: string };

export type NoteFragment = { __typename?: 'NoteDto', _id: string, candidateId: string, authorId: string, content: string, creationDate: any };

export type CreateNoteMutationVariables = Exact<{
  input: CreateNoteInput;
}>;


export type CreateNoteMutation = { __typename?: 'Mutation', createNote: { __typename?: 'NoteDto', _id: string, candidateId: string, authorId: string, content: string, creationDate: any } };

export type DeleteNoteMutationVariables = Exact<{
  noteId: Scalars['String'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: boolean };

export type GetCandidateNoteMentionsQueryVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type GetCandidateNoteMentionsQuery = { __typename?: 'Query', getCandidateNoteMentions: Array<{ __typename?: 'NoteMentionDto', userId: string, name: string }> };

export type CreateInvoiceForCoursesMutationVariables = Exact<{
  input: CreateInvoiceForCoursesInput;
}>;


export type CreateInvoiceForCoursesMutation = { __typename?: 'Mutation', createInvoiceForCourses: { __typename?: 'CandidateInvoiceDto', _id: string, status: CandidateInvoiceStatus } };

export type VoidInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type VoidInvoiceMutation = { __typename?: 'Mutation', voidInvoice: boolean };

export type MarkInvoiceAsPaidMutationVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type MarkInvoiceAsPaidMutation = { __typename?: 'Mutation', markInvoiceAsPaid: boolean };

export type DeleteCandidateMutationVariables = Exact<{
  candidateId: Scalars['String'];
}>;


export type DeleteCandidateMutation = { __typename?: 'Mutation', deleteCandidate: boolean };

export type CandidateCohortFragment = { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean };

export type CandidateCohortSuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
}>;


export type CandidateCohortSuggestionsQuery = { __typename?: 'Query', candidateCohortSuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type CreateCandidateCohortMutationVariables = Exact<{
  input: CreateCandidateCohortInput;
}>;


export type CreateCandidateCohortMutation = { __typename?: 'Mutation', createCandidateCohort: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } };

export type AssignCandidateToCohortMutationVariables = Exact<{
  input: AssignCandidateCohortInput;
}>;


export type AssignCandidateToCohortMutation = { __typename?: 'Mutation', assignCandidateToCohort: boolean };

export type ListCohortsQueryVariables = Exact<{
  input: CandidateCohortListInput;
}>;


export type ListCohortsQuery = { __typename?: 'Query', candidateCohorts: { __typename?: 'CandidateCohortListDto', total: number, items: Array<{ __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean }> } };

export type GetCohortQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCohortQuery = { __typename?: 'Query', candidateCohort: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } };

export type CreateCohortMutationVariables = Exact<{
  input: CreateCandidateCohortInput;
}>;


export type CreateCohortMutation = { __typename?: 'Mutation', createCandidateCohort: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } };

export type UpdateCohortMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateCandidateCohortInput;
}>;


export type UpdateCohortMutation = { __typename?: 'Mutation', updateCandidateCohort: { __typename?: 'CandidateCohortDto', _id: string, name: string, isActive: boolean } };

export type MessageFragment = { __typename?: 'MessageDto', _id: string, fromUserId?: string | null, toUserId?: string | null, type: MessageType, body: string, bodyHtml?: string | null, subject?: string | null, status?: MessageStatus | null, statusDate?: any | null, timestamp: any, fromUser?: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pictureUrl?: string | null } | null, attachments?: Array<{ __typename?: 'MessageAttachmentDto', fileId: string, name: string, url: string, contentId?: string | null, convertedToFileId?: string | null }> | null };

export type GetCandidateMessagesQueryVariables = Exact<{
  candidateId: Scalars['String'];
  afterTimestamp?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidateMessagesQuery = { __typename?: 'Query', getCandidateMessages: Array<{ __typename?: 'MessageDto', _id: string, fromUserId?: string | null, toUserId?: string | null, type: MessageType, body: string, bodyHtml?: string | null, subject?: string | null, status?: MessageStatus | null, statusDate?: any | null, timestamp: any, fromUser?: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pictureUrl?: string | null } | null, attachments?: Array<{ __typename?: 'MessageAttachmentDto', fileId: string, name: string, url: string, contentId?: string | null, convertedToFileId?: string | null }> | null }> };

export type SendCandidateMessageMutationVariables = Exact<{
  input: SendMessageInput;
}>;


export type SendCandidateMessageMutation = { __typename?: 'Mutation', sendCandidateMessage: { __typename?: 'MessageDto', _id: string, fromUserId?: string | null, toUserId?: string | null, type: MessageType, body: string, bodyHtml?: string | null, subject?: string | null, status?: MessageStatus | null, statusDate?: any | null, timestamp: any, fromUser?: { __typename?: 'UserDto', _id: string, firstName: string, lastName: string, pictureUrl?: string | null } | null, attachments?: Array<{ __typename?: 'MessageAttachmentDto', fileId: string, name: string, url: string, contentId?: string | null, convertedToFileId?: string | null }> | null } };

export type SendCandidateEmailMutationVariables = Exact<{
  input: SendEmailInput;
}>;


export type SendCandidateEmailMutation = { __typename?: 'Mutation', sendCandidateEmail: boolean };

export type ConvertToUserDocumentMutationVariables = Exact<{
  messageId: Scalars['String'];
  fileId: Scalars['String'];
}>;


export type ConvertToUserDocumentMutation = { __typename?: 'Mutation', convertToUserDocument: boolean };

export type CourseFragment = { __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null };

export type CourseWithProductFragment = { __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, stripeProduct?: { __typename?: 'ProductDto', stripeId: string, description?: string | null, name: string, price: number } | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null };

export type ListCoursesQueryVariables = Exact<{
  input: CourseListInput;
}>;


export type ListCoursesQuery = { __typename?: 'Query', courses: { __typename?: 'CourseListDto', total: number, items: Array<{ __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, stripeProduct?: { __typename?: 'ProductDto', stripeId: string, description?: string | null, name: string, price: number } | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null }> } };

export type GetCourseQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCourseQuery = { __typename?: 'Query', course: { __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null } };

export type CreateCourseMutationVariables = Exact<{
  input: CreateCourseInput;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null } };

export type UpdateCourseMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'CourseAdminDto', _id: string, name: string, subject: string, description?: string | null, stripeProductId?: string | null, links?: Array<{ __typename?: 'CourseLinkDto', name: string, url: string }> | null } };

export type CourseSuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
  filter?: InputMaybe<CourseListFilterInput>;
}>;


export type CourseSuggestionsQuery = { __typename?: 'Query', courseSuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type AssignCandidateToCourseMutationVariables = Exact<{
  courseId: Scalars['String'];
  candidateId: Scalars['String'];
}>;


export type AssignCandidateToCourseMutation = { __typename?: 'Mutation', assignCandidateToCourse: boolean };

export type RemoveCandidateFromCourseMutationVariables = Exact<{
  courseId: Scalars['String'];
  candidateId: Scalars['String'];
}>;


export type RemoveCandidateFromCourseMutation = { __typename?: 'Mutation', removeCandidateFromCourse: boolean };

export type UpdateCandidateCourseProgressMutationVariables = Exact<{
  input: UpdateCandidateCourseProgressInput;
}>;


export type UpdateCandidateCourseProgressMutation = { __typename?: 'Mutation', updateCandidateCourseProgress: boolean };

export type EmployeeFragment = { __typename?: 'EmployeeDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, roles: { __typename?: 'RolesDto', advisor: boolean, admin: boolean } };

export type ListEmployeesQueryVariables = Exact<{
  input: EmployeeListInput;
}>;


export type ListEmployeesQuery = { __typename?: 'Query', employees: { __typename?: 'EmployeeListDto', total: number, items: Array<{ __typename?: 'EmployeeDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, roles: { __typename?: 'RolesDto', advisor: boolean, admin: boolean } }> } };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'EmployeeDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, roles: { __typename?: 'RolesDto', advisor: boolean, admin: boolean } } };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'EmployeeDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, roles: { __typename?: 'RolesDto', advisor: boolean, admin: boolean } } };

export type UpdateEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'EmployeeDto', _id: string, email: string, firstName: string, lastName: string, pronouns?: string | null, creationDate: any, isActive: boolean, pictureUrl?: string | null, roles: { __typename?: 'RolesDto', advisor: boolean, admin: boolean } } };

export type DisableEmployeeMutationVariables = Exact<{
  id: Scalars['String'];
  disabled: Scalars['Boolean'];
}>;


export type DisableEmployeeMutation = { __typename?: 'Mutation', disableEmployee: boolean };

export type ResetEmployeePasswordMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResetEmployeePasswordMutation = { __typename?: 'Mutation', resetEmployeePassword: boolean };

export type AdvisorSuggestionsQueryVariables = Exact<{
  input: SuggestionsInput;
}>;


export type AdvisorSuggestionsQuery = { __typename?: 'Query', advisorSuggestions: { __typename?: 'SuggestionsResponse', total: number, options: Array<{ __typename?: 'SuggestionResponseOption', _id: string, label: string }> } };

export type FileFragment = { __typename?: 'FileDto', _id: string, userId?: string | null, employerId?: string | null, type: FileType, key: string, name: string, mimeType: MimeType, contentLength: number, status: FileStatus, statusMessage?: string | null, uploadedAt: any, processedAt?: any | null, processingResults?: Array<{ __typename?: 'FileProcessorResultDto', processor: string, message?: string | null, result: string }> | null };

export type GetFileQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFileQuery = { __typename?: 'Query', getFile: { __typename?: 'FileDto', _id: string, userId?: string | null, employerId?: string | null, type: FileType, key: string, name: string, mimeType: MimeType, contentLength: number, status: FileStatus, statusMessage?: string | null, uploadedAt: any, processedAt?: any | null, processingResults?: Array<{ __typename?: 'FileProcessorResultDto', processor: string, message?: string | null, result: string }> | null } };

export type GooglePlaceResultFragment = { __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null };

export type GooglePlaceSuggestionsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GooglePlaceSuggestionsQuery = { __typename?: 'Query', searchLocations: Array<{ __typename?: 'AddressDto', line1?: string | null, line2?: string | null, city?: string | null, country?: string | null, state?: string | null, zipCode?: string | null, placeId?: string | null }> };

export type InvitationFragment = { __typename?: 'InvitationDto', _id: string, email: string, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, convertedDate?: any | null, convertedToUserId?: string | null, advisorId?: string | null, advisor?: string | null, programId: string, creationDate: any, data?: Array<{ __typename?: 'InvitationApplicationDataDto', key: string, label?: string | null, type: InvitationApplicationDataType, value: string }> | null, documents?: Array<{ __typename?: 'InvitationApplicationDocumentDto', key: string, label?: string | null, fileId: string, fileName: string }> | null };

export type GetInvitationQueryVariables = Exact<{
  input: GetInvitationInput;
}>;


export type GetInvitationQuery = { __typename?: 'Query', invitation?: { __typename?: 'InvitationDto', _id: string, email: string, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, convertedDate?: any | null, convertedToUserId?: string | null, advisorId?: string | null, advisor?: string | null, programId: string, creationDate: any, program: { __typename?: 'CandidateProgramDto', welcomeEmailType?: string | null, invitationEmailType?: string | null, _id: string, name: string, order?: number | null, candidateAgreementUrl?: string | null, isActive: boolean, candidateAgreement?: { __typename?: 'UserDocumentDto', fileId: string, fileName: string } | null, applicationRequirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }>, stages: Array<{ __typename?: 'ProgramStageDto', key: string, name: string, order: number, startEmailType?: string | null, endEmailType?: string | null, requirements: Array<{ __typename?: 'ProgramStageRequirementDto', key: string, label: string, type: ProgramStageRequirementType, questionType?: ProgramStageRequirementQuestionType | null, paymentType?: ProgramStageRequirementPaymentType | null, paymentStripeProductId?: string | null, paymentStripeProductName?: string | null, required: boolean, order: number }> }> }, data?: Array<{ __typename?: 'InvitationApplicationDataDto', key: string, label?: string | null, type: InvitationApplicationDataType, value: string }> | null, documents?: Array<{ __typename?: 'InvitationApplicationDocumentDto', key: string, label?: string | null, fileId: string, fileName: string }> | null } | null };

export type InvitationSummaryFragment = { __typename?: 'InvitationDto', _id: string, email: string, name?: string | null, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, advisor?: string | null, programId: string, programName: string, creationDate: any };

export type ListInvitationsQueryVariables = Exact<{
  input: InvitationListInput;
}>;


export type ListInvitationsQuery = { __typename?: 'Query', invitations: { __typename?: 'InvitationListDto', total: number, items: Array<{ __typename?: 'InvitationDto', _id: string, email: string, name?: string | null, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, advisor?: string | null, programId: string, programName: string, creationDate: any }> } };

export type CreateInvitationMutationVariables = Exact<{
  input: CreateInvitationInput;
}>;


export type CreateInvitationMutation = { __typename?: 'Mutation', createInvitation: { __typename?: 'InvitationDto', _id: string, email: string, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, convertedDate?: any | null, convertedToUserId?: string | null, advisorId?: string | null, advisor?: string | null, programId: string, creationDate: any, data?: Array<{ __typename?: 'InvitationApplicationDataDto', key: string, label?: string | null, type: InvitationApplicationDataType, value: string }> | null, documents?: Array<{ __typename?: 'InvitationApplicationDocumentDto', key: string, label?: string | null, fileId: string, fileName: string }> | null } };

export type EditInvitationMutationVariables = Exact<{
  id: Scalars['String'];
  input: EditInvitationInput;
}>;


export type EditInvitationMutation = { __typename?: 'Mutation', editInvitation: { __typename?: 'InvitationDto', _id: string, email: string, valid: boolean, validationError?: string | null, invited: boolean, invitedDate?: any | null, converted: boolean, convertedDate?: any | null, convertedToUserId?: string | null, advisorId?: string | null, advisor?: string | null, programId: string, creationDate: any, data?: Array<{ __typename?: 'InvitationApplicationDataDto', key: string, label?: string | null, type: InvitationApplicationDataType, value: string }> | null, documents?: Array<{ __typename?: 'InvitationApplicationDocumentDto', key: string, label?: string | null, fileId: string, fileName: string }> | null } };

export type RemoveInvitationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveInvitationMutation = { __typename?: 'Mutation', removeInvitation: boolean };

export type PreviewInvitationEmailQueryVariables = Exact<{
  input: SendInvitationEmailInput;
}>;


export type PreviewInvitationEmailQuery = { __typename?: 'Query', previewInvitationEmail: { __typename?: 'InvitationEmailPreviewDto', totalAlreadyInvited: number, totalToSend: number } };

export type SendInvitationEmailMutationVariables = Exact<{
  input: SendInvitationEmailInput;
}>;


export type SendInvitationEmailMutation = { __typename?: 'Mutation', sendInvitationEmail: boolean };

export type ProcessInvitationCsvMutationVariables = Exact<{
  input: ProcessInvitationCsvInput;
}>;


export type ProcessInvitationCsvMutation = { __typename?: 'Mutation', processInvitationCsv: { __typename?: 'ProcessInvitationCsvResultDto', taskId: string } };

export type MailContentFragment = { __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> };

export type ListMailContentsQueryVariables = Exact<{
  input: MailContentListInput;
}>;


export type ListMailContentsQuery = { __typename?: 'Query', mailContents: { __typename?: 'MailContentListDto', total: number, items: Array<{ __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> }> } };

export type ListCustomMailContentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCustomMailContentsQuery = { __typename?: 'Query', mailContents: { __typename?: 'MailContentListDto', total: number, items: Array<{ __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> }> } };

export type GetMailContentQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetMailContentQuery = { __typename?: 'Query', mailContent: { __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> } };

export type UpdateMailContentMutationVariables = Exact<{
  input: UpdateMailContentInput;
}>;


export type UpdateMailContentMutation = { __typename?: 'Mutation', updateMailContent: { __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> } };

export type DeleteMailContentMutationVariables = Exact<{
  type: Scalars['String'];
}>;


export type DeleteMailContentMutation = { __typename?: 'Mutation', deleteMailContent: boolean };

export type CreateMailContentMutationVariables = Exact<{
  input: CreateCustomMailContentInput;
}>;


export type CreateMailContentMutation = { __typename?: 'Mutation', createMailContent: { __typename?: 'MailContentDto', _id: string, type: string, custom?: boolean | null, customTitle?: string | null, customDescription?: string | null, templates: Array<{ __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string }> } };

export type BuildCustomTemplateForUserMutationVariables = Exact<{
  input: BuildCustomTemplateForUserInput;
}>;


export type BuildCustomTemplateForUserMutation = { __typename?: 'Mutation', buildCustomTemplateForUser: { __typename?: 'MailContentTemplateDto', locale: string, subject: string, body: string } };

export type BuildMailContentPreviewMutationVariables = Exact<{
  input: BuildMailContentPreviewInput;
}>;


export type BuildMailContentPreviewMutation = { __typename?: 'Mutation', buildMailContentPreview: string };

export type MailContentDynamicDataQueryVariables = Exact<{
  emailType: Scalars['String'];
}>;


export type MailContentDynamicDataQuery = { __typename?: 'Query', mailContentDynamicData: Array<{ __typename?: 'DynamicDataDto', key: string, label: string, ejs: string, type: string }> };

export type GetEmailPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailPreferencesQuery = { __typename?: 'Query', getEmailPreferences: { __typename?: 'EmailPreferencesDto', preferences: Array<{ __typename?: 'EmailPreferenceDto', key: string, enabled: boolean }> } };

export type UpdateEmailPreferenceMutationVariables = Exact<{
  input: UpdateEmailPreferenceInput;
}>;


export type UpdateEmailPreferenceMutation = { __typename?: 'Mutation', updateEmailPreference: { __typename?: 'EmailPreferencesDto', preferences: Array<{ __typename?: 'EmailPreferenceDto', key: string, enabled: boolean }> } };

export type NotificationFragment = { __typename?: 'NotificationDto', _id?: string | null, title: string, message: string, link?: string | null, read: boolean, createdAt: any };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'NotificationDto', _id?: string | null, title: string, message: string, link?: string | null, read: boolean, createdAt: any }> };

export type GetNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationCountQuery = { __typename?: 'Query', unreadNotificationsCount: number };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead: boolean };

export type ListProductsQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type ListProductsQuery = { __typename?: 'Query', listProducts: { __typename?: 'ListProductsDto', total: number, items: Array<{ __typename?: 'ProductDto', stripeId: string, name: string, description?: string | null, price: number }> } };

export type GetSavedQueriesQueryVariables = Exact<{
  key: SavedQueryKey;
}>;


export type GetSavedQueriesQuery = { __typename?: 'Query', getSavedQueries: Array<{ __typename?: 'SavedQueryDto', label: string, shared: boolean, querystring: string, createdByUserId?: string | null }> };

export type UpsertSavedQueryMutationVariables = Exact<{
  input: SavedQueryInput;
}>;


export type UpsertSavedQueryMutation = { __typename?: 'Mutation', upsertSavedQuery: { __typename?: 'SavedQueryDto', label: string, shared: boolean, querystring: string } };

export type DeleteSavedQueryMutationVariables = Exact<{
  key: SavedQueryKey;
  label: Scalars['String'];
}>;


export type DeleteSavedQueryMutation = { __typename?: 'Mutation', deleteSavedQuery: boolean };

export const AdvisorProfileFragmentDoc = gql`
    fragment AdvisorProfile on AdvisorProfileDto {
  about
  role
  phone {
    countryCode
    phoneNumber
  }
  skills {
    name
    fromResume
  }
  socialLinks {
    facebook
    github
    instagram
    linkedin
    twitter
    website
    youtube
  }
  calendlyLink
}
    `;
export const AuditLogUserDetailsFragmentDoc = gql`
    fragment AuditLogUserDetails on AuditLogUserDetailsDto {
  _id
  firstName
  lastName
  profilePictureUrl
}
    `;
export const AuditLogFragmentDoc = gql`
    fragment AuditLog on AuditLogDto {
  _id
  sourceName
  sourceUser {
    ...AuditLogUserDetails
  }
  affectedName
  affected {
    _id
    type
  }
  action
  additionalData {
    key
    value
  }
  category
  detail {
    type
    content
  }
  timestamp
}
    ${AuditLogUserDetailsFragmentDoc}`;
export const UserDocumentFragmentDoc = gql`
    fragment UserDocument on UserDocumentDto {
  fileId
  fileName
}
    `;
export const RolesFragmentDoc = gql`
    fragment Roles on RolesDto {
  admin
  waitlist
  enrolled
  prospect
  advisor
}
    `;
export const UserFragmentDoc = gql`
    fragment User on UserDto {
  _id
  firstName
  lastName
  pronouns
  phone {
    countryCode
    phoneNumber
  }
  email
  roles {
    ...Roles
  }
  pictureUrl
  isVerified
  enrolmentApplicationSubmitted
  hasPassword
  profileCompleted
}
    ${RolesFragmentDoc}`;
export const CandidateJobFragmentDoc = gql`
    fragment CandidateJob on CandidateJobDto {
  _id
  userId
  jobId
  status
  createdAt
  updatedAt
  job {
    title
    description
    location
    employer
    employerLogo
    reqId
    industry
    jobFunction
    type
    remote
    website
  }
}
    `;
export const CandidateLabelFragmentDoc = gql`
    fragment CandidateLabel on CandidateLabelDto {
  _id
  label
  color
}
    `;
export const CandidateLabelWithCountFragmentDoc = gql`
    fragment CandidateLabelWithCount on CandidateLabelDto {
  ...CandidateLabel
  candidateCount
}
    ${CandidateLabelFragmentDoc}`;
export const ProgramSummaryFragmentDoc = gql`
    fragment ProgramSummary on CandidateProgramDto {
  _id
  name
  order
  candidateAgreementUrl
  isActive
}
    `;
export const ProgramStageRequirementFragmentDoc = gql`
    fragment ProgramStageRequirement on ProgramStageRequirementDto {
  key
  label
  type
  questionType
  paymentType
  paymentStripeProductId
  paymentStripeProductName
  required
  order
}
    `;
export const MyProgramFragmentDoc = gql`
    fragment MyProgram on CandidateProgramDto {
  ...ProgramSummary
  applicationRequirements {
    ...ProgramStageRequirement
  }
}
    ${ProgramSummaryFragmentDoc}
${ProgramStageRequirementFragmentDoc}`;
export const ProgramStageFragmentDoc = gql`
    fragment ProgramStage on ProgramStageDto {
  key
  name
  order
  startEmailType
  endEmailType
  requirements {
    ...ProgramStageRequirement
  }
}
    ${ProgramStageRequirementFragmentDoc}`;
export const ProgramDetailFragmentDoc = gql`
    fragment ProgramDetail on CandidateProgramDto {
  ...ProgramSummary
  candidateAgreement {
    fileId
    fileName
  }
  welcomeEmailType
  invitationEmailType
  applicationRequirements {
    ...ProgramStageRequirement
  }
  stages {
    ...ProgramStage
  }
}
    ${ProgramSummaryFragmentDoc}
${ProgramStageRequirementFragmentDoc}
${ProgramStageFragmentDoc}`;
export const ProgramStageRequirementCompletionFragmentDoc = gql`
    fragment ProgramStageRequirementCompletion on CandidateProgramStageRequirementCompletionDto {
  requirementKey
  completed
  completionDate
  completedBy
  linkedDocumentId
  linkedDocumentName
}
    `;
export const ProgramStageProgressFragmentDoc = gql`
    fragment ProgramStageProgress on CandidateProgramStageProgressDto {
  stageKey
  requirementsCompleted
  completedRequirements {
    ...ProgramStageRequirementCompletion
  }
  startDate
  endDate
}
    ${ProgramStageRequirementCompletionFragmentDoc}`;
export const ProgramProgressFragmentDoc = gql`
    fragment ProgramProgress on CandidateProgramProgressDto {
  candidateId
  programId
  acceptedAgreement
  program {
    ...ProgramDetail
  }
  currentStage
  stages {
    ...ProgramStageProgress
  }
  creationDate
  updatedDate
}
    ${ProgramDetailFragmentDoc}
${ProgramStageProgressFragmentDoc}`;
export const CandidateResumeFragmentDoc = gql`
    fragment CandidateResume on CandidateResumeDto {
  _id
  userId
  uploadedAt
  file {
    _id
    name
    mimeType
    contentLength
    key
  }
}
    `;
export const CandidateCourseFragmentDoc = gql`
    fragment CandidateCourse on CandidateCourseDto {
  _id
  course {
    _id
    name
    subject
    description
    links {
      name
      url
    }
  }
  candidateId
  courseId
  progress
  deadline
  invoice {
    _id
    status
  }
}
    `;
export const CandidateCourseWithProductFragmentDoc = gql`
    fragment CandidateCourseWithProduct on CandidateCourseDto {
  ...CandidateCourse
  stripeProduct {
    stripeId
    name
    price
  }
}
    ${CandidateCourseFragmentDoc}`;
export const CandidateDocumentFragmentDoc = gql`
    fragment CandidateDocument on CandidateDocumentDto {
  _id
  name
  mimeType
  contentLength
  key
  userId
  uploadedAt
  uploadedBy
  uploadedByUserId
  label
  requirementKey
}
    `;
export const CandidateSummaryFragmentDoc = gql`
    fragment CandidateSummary on CandidateDto {
  _id
  email
  firstName
  lastName
  pronouns
  creationDate
  isActive
  roles {
    ...Roles
  }
  phone {
    countryCode
    phoneNumber
  }
  candidateProfile {
    candidateId
    cohortId
    bookmarked
    advisorIds
    labels
    advisors {
      _id
      firstName
      lastName
    }
    courses {
      _id
      name
    }
  }
  enrolmentApplication {
    status
    education {
      university
    }
    submittedAt
  }
  pictureUrl
  programName
  programStage
  progress {
    currentStage
  }
}
    ${RolesFragmentDoc}`;
export const CandidateAdvisorFragmentDoc = gql`
    fragment CandidateAdvisor on CandidateProfileAdvisorDto {
  _id
  firstName
  lastName
  email
  pictureUrl
  phone {
    countryCode
    phoneNumber
  }
  advisorProfile {
    about
    role
    calendlyLink
    skills {
      name
    }
  }
}
    `;
export const CandidateProfileFragmentDoc = gql`
    fragment CandidateProfile on CandidateProfileDto {
  advisorIds
  advisors {
    ...CandidateAdvisor
  }
  candidateId
  cohortId
  cohort {
    _id
    name
    isActive
  }
  dateOfBirth
  address {
    line1
    line2
    city
    country
    state
    zipCode
    placeId
  }
  latestResume {
    fileId
    fileName
  }
  courseTitle
  jobTitle
  desiredCareer
  about
  interests
  skills {
    name
    fromResume
  }
  programId
  program {
    _id
    name
  }
}
    ${CandidateAdvisorFragmentDoc}`;
export const CandidateProfileDetailedFragmentDoc = gql`
    fragment CandidateProfileDetailed on CandidateProfileDto {
  ...CandidateProfile
}
    ${CandidateProfileFragmentDoc}`;
export const EnrolmentDocumentFragmentDoc = gql`
    fragment EnrolmentDocument on UserDocumentDto {
  fileId
  fileName
}
    `;
export const CandidateEnrolmentInterviewFragmentDoc = gql`
    fragment CandidateEnrolmentInterview on CandidateEnrolmentInterviewDto {
  joinUrl
  rescheduleUrl
  start
  end
  scheduledAt
  calendlyEventUri
  calendlyInviteeUri
  completed
}
    `;
export const CandidateEnrolmentApplicationFragmentDoc = gql`
    fragment CandidateEnrolmentApplication on CandidateEnrolmentApplicationDto {
  status
  documents {
    i20 {
      ...EnrolmentDocument
    }
    resume {
      ...EnrolmentDocument
    }
    coverLetter {
      ...EnrolmentDocument
    }
    transcript {
      ...EnrolmentDocument
    }
  }
  education {
    studyLevel
    university
    fieldOfStudy
    isFinalYearOfStudy
    fieldOfStudy
    gpa
    eligibleForOpt
    graduationDate
  }
  questionnaireAnswers {
    question
    answer
    key
  }
  invitedForInterview
  interview {
    ...CandidateEnrolmentInterview
  }
  communityContactStatus
  submitted
  updatedAt
}
    ${EnrolmentDocumentFragmentDoc}
${CandidateEnrolmentInterviewFragmentDoc}`;
export const CandidateDetailedFragmentDoc = gql`
    fragment CandidateDetailed on CandidateDto {
  ...CandidateSummary
  candidateProfile {
    ...CandidateProfileDetailed
  }
  enrolmentApplication {
    ...CandidateEnrolmentApplication
  }
}
    ${CandidateSummaryFragmentDoc}
${CandidateProfileDetailedFragmentDoc}
${CandidateEnrolmentApplicationFragmentDoc}`;
export const InvoiceFragmentDoc = gql`
    fragment Invoice on CandidateInvoiceDto {
  _id
  description
  status
  stripeCouponIds
  productTotalAmount
  couponDiscountAmount
  totalAmount
  creationDate
  updatedAt
  stripeCharge {
    amount
    currency
    receiptUrl
  }
}
    `;
export const CouponSummaryFragmentDoc = gql`
    fragment CouponSummary on CouponDto {
  id
  name
  discount
}
    `;
export const MyInvoiceFragmentDoc = gql`
    fragment MyInvoice on CandidateInvoiceDto {
  ...Invoice
  coupons {
    ...CouponSummary
  }
  hostedInvoiceUrl
}
    ${InvoiceFragmentDoc}
${CouponSummaryFragmentDoc}`;
export const CouponFragmentDoc = gql`
    fragment Coupon on CouponDto {
  id
  name
  appliesToProductIds
  discount
  timesRedeemed
  maxRedemptions
  valid
}
    `;
export const AdminInvoiceFragmentDoc = gql`
    fragment AdminInvoice on CandidateInvoiceDto {
  ...Invoice
  coupons {
    ...Coupon
  }
}
    ${InvoiceFragmentDoc}
${CouponFragmentDoc}`;
export const NoteMentionFragmentDoc = gql`
    fragment NoteMention on NoteMentionDto {
  userId
  name
}
    `;
export const NoteFragmentDoc = gql`
    fragment Note on NoteDto {
  _id
  candidateId
  authorId
  content
  creationDate
}
    `;
export const CandidateCohortFragmentDoc = gql`
    fragment CandidateCohort on CandidateCohortDto {
  _id
  name
  isActive
}
    `;
export const MessageFragmentDoc = gql`
    fragment Message on MessageDto {
  _id
  fromUserId
  fromUser {
    _id
    firstName
    lastName
    pictureUrl
  }
  toUserId
  type
  body
  bodyHtml
  subject
  status
  statusDate
  timestamp
  attachments {
    fileId
    name
    url
    contentId
    convertedToFileId
  }
}
    `;
export const CourseFragmentDoc = gql`
    fragment Course on CourseAdminDto {
  _id
  name
  subject
  description
  stripeProductId
  links {
    name
    url
  }
}
    `;
export const CourseWithProductFragmentDoc = gql`
    fragment CourseWithProduct on CourseAdminDto {
  ...Course
  stripeProduct {
    stripeId
    description
    name
    price
  }
}
    ${CourseFragmentDoc}`;
export const EmployeeFragmentDoc = gql`
    fragment Employee on EmployeeDto {
  _id
  email
  firstName
  lastName
  pronouns
  creationDate
  isActive
  pictureUrl
  roles {
    advisor
    admin
  }
}
    `;
export const FileFragmentDoc = gql`
    fragment File on FileDto {
  _id
  userId
  employerId
  type
  key
  name
  mimeType
  contentLength
  status
  statusMessage
  uploadedAt
  processedAt
  processingResults {
    processor
    message
    result
  }
}
    `;
export const GooglePlaceResultFragmentDoc = gql`
    fragment GooglePlaceResult on AddressDto {
  line1
  line2
  city
  country
  state
  zipCode
  placeId
}
    `;
export const InvitationFragmentDoc = gql`
    fragment Invitation on InvitationDto {
  _id
  email
  data {
    key
    label
    type
    value
  }
  documents {
    key
    label
    fileId
    fileName
  }
  valid
  validationError
  invited
  invitedDate
  converted
  convertedDate
  convertedToUserId
  advisorId
  advisor
  programId
  creationDate
}
    `;
export const InvitationSummaryFragmentDoc = gql`
    fragment InvitationSummary on InvitationDto {
  _id
  email
  name
  valid
  validationError
  invited
  invitedDate
  converted
  advisor
  programId
  programName
  creationDate
}
    `;
export const MailContentFragmentDoc = gql`
    fragment MailContent on MailContentDto {
  _id
  type
  custom
  customTitle
  customDescription
  templates {
    locale
    subject
    body
  }
}
    `;
export const NotificationFragmentDoc = gql`
    fragment Notification on NotificationDto {
  _id
  title
  message
  link
  read
  createdAt
}
    `;
export const UpdateAdvisorProfileDocument = gql`
    mutation updateAdvisorProfile($input: UpdateAdvisorProfileInput!) {
  updateAdvisorProfile(input: $input) {
    ...AdvisorProfile
  }
}
    ${AdvisorProfileFragmentDoc}`;
export type UpdateAdvisorProfileMutationFn = Apollo.MutationFunction<UpdateAdvisorProfileMutation, UpdateAdvisorProfileMutationVariables>;

/**
 * __useUpdateAdvisorProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAdvisorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvisorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvisorProfileMutation, { data, loading, error }] = useUpdateAdvisorProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdvisorProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdvisorProfileMutation, UpdateAdvisorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdvisorProfileMutation, UpdateAdvisorProfileMutationVariables>(UpdateAdvisorProfileDocument, options);
      }
export type UpdateAdvisorProfileMutationHookResult = ReturnType<typeof useUpdateAdvisorProfileMutation>;
export type UpdateAdvisorProfileMutationResult = Apollo.MutationResult<UpdateAdvisorProfileMutation>;
export type UpdateAdvisorProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAdvisorProfileMutation, UpdateAdvisorProfileMutationVariables>;
export const GetAdvisorProfileDocument = gql`
    query getAdvisorProfile {
  getAdvisorProfile {
    ...AdvisorProfile
  }
}
    ${AdvisorProfileFragmentDoc}`;

/**
 * __useGetAdvisorProfileQuery__
 *
 * To run a query within a React component, call `useGetAdvisorProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdvisorProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>(GetAdvisorProfileDocument, options);
      }
export function useGetAdvisorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>(GetAdvisorProfileDocument, options);
        }
export type GetAdvisorProfileQueryHookResult = ReturnType<typeof useGetAdvisorProfileQuery>;
export type GetAdvisorProfileLazyQueryHookResult = ReturnType<typeof useGetAdvisorProfileLazyQuery>;
export type GetAdvisorProfileQueryResult = Apollo.QueryResult<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>;
export const GetAuditLogsDocument = gql`
    query getAuditLogs($input: AuditLogListInput!) {
  auditLogs(input: $input) {
    items {
      ...AuditLog
    }
    total
  }
}
    ${AuditLogFragmentDoc}`;

/**
 * __useGetAuditLogsQuery__
 *
 * To run a query within a React component, call `useGetAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuditLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
      }
export function useGetAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuditLogsQuery, GetAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuditLogsQuery, GetAuditLogsQueryVariables>(GetAuditLogsDocument, options);
        }
export type GetAuditLogsQueryHookResult = ReturnType<typeof useGetAuditLogsQuery>;
export type GetAuditLogsLazyQueryHookResult = ReturnType<typeof useGetAuditLogsLazyQuery>;
export type GetAuditLogsQueryResult = Apollo.QueryResult<GetAuditLogsQuery, GetAuditLogsQueryVariables>;
export const GetMeDocument = gql`
    query getMe {
  me {
    ...User
    unreadNotifications
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ForgotPasswordResetDocument = gql`
    mutation forgotPasswordReset($input: ForgotPasswordResetInput!) {
  forgotPasswordReset(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type ForgotPasswordResetMutationFn = Apollo.MutationFunction<ForgotPasswordResetMutation, ForgotPasswordResetMutationVariables>;

/**
 * __useForgotPasswordResetMutation__
 *
 * To run a mutation, you first call `useForgotPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordResetMutation, { data, loading, error }] = useForgotPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordResetMutation, ForgotPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordResetMutation, ForgotPasswordResetMutationVariables>(ForgotPasswordResetDocument, options);
      }
export type ForgotPasswordResetMutationHookResult = ReturnType<typeof useForgotPasswordResetMutation>;
export type ForgotPasswordResetMutationResult = Apollo.MutationResult<ForgotPasswordResetMutation>;
export type ForgotPasswordResetMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordResetMutation, ForgotPasswordResetMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateUserInput!) {
  updateMe(input: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($input: UpdateUserInput!, $id: String!) {
  updateUser(input: $input, id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const CandidateJobsDocument = gql`
    query candidateJobs($input: CandidateJobsListInput!) {
  candidateJobs(input: $input) {
    total
    items {
      ...CandidateJob
    }
  }
}
    ${CandidateJobFragmentDoc}`;

/**
 * __useCandidateJobsQuery__
 *
 * To run a query within a React component, call `useCandidateJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateJobsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateJobsQuery(baseOptions: Apollo.QueryHookOptions<CandidateJobsQuery, CandidateJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateJobsQuery, CandidateJobsQueryVariables>(CandidateJobsDocument, options);
      }
export function useCandidateJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateJobsQuery, CandidateJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateJobsQuery, CandidateJobsQueryVariables>(CandidateJobsDocument, options);
        }
export type CandidateJobsQueryHookResult = ReturnType<typeof useCandidateJobsQuery>;
export type CandidateJobsLazyQueryHookResult = ReturnType<typeof useCandidateJobsLazyQuery>;
export type CandidateJobsQueryResult = Apollo.QueryResult<CandidateJobsQuery, CandidateJobsQueryVariables>;
export const CandidateLabelsDocument = gql`
    query candidateLabels {
  candidateLabels {
    ...CandidateLabel
  }
}
    ${CandidateLabelFragmentDoc}`;

/**
 * __useCandidateLabelsQuery__
 *
 * To run a query within a React component, call `useCandidateLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateLabelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCandidateLabelsQuery(baseOptions?: Apollo.QueryHookOptions<CandidateLabelsQuery, CandidateLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateLabelsQuery, CandidateLabelsQueryVariables>(CandidateLabelsDocument, options);
      }
export function useCandidateLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateLabelsQuery, CandidateLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateLabelsQuery, CandidateLabelsQueryVariables>(CandidateLabelsDocument, options);
        }
export type CandidateLabelsQueryHookResult = ReturnType<typeof useCandidateLabelsQuery>;
export type CandidateLabelsLazyQueryHookResult = ReturnType<typeof useCandidateLabelsLazyQuery>;
export type CandidateLabelsQueryResult = Apollo.QueryResult<CandidateLabelsQuery, CandidateLabelsQueryVariables>;
export const CandidateLabelDocument = gql`
    query candidateLabel($labelId: String!) {
  candidateLabel(id: $labelId) {
    ...CandidateLabelWithCount
  }
}
    ${CandidateLabelWithCountFragmentDoc}`;

/**
 * __useCandidateLabelQuery__
 *
 * To run a query within a React component, call `useCandidateLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateLabelQuery({
 *   variables: {
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useCandidateLabelQuery(baseOptions: Apollo.QueryHookOptions<CandidateLabelQuery, CandidateLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateLabelQuery, CandidateLabelQueryVariables>(CandidateLabelDocument, options);
      }
export function useCandidateLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateLabelQuery, CandidateLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateLabelQuery, CandidateLabelQueryVariables>(CandidateLabelDocument, options);
        }
export type CandidateLabelQueryHookResult = ReturnType<typeof useCandidateLabelQuery>;
export type CandidateLabelLazyQueryHookResult = ReturnType<typeof useCandidateLabelLazyQuery>;
export type CandidateLabelQueryResult = Apollo.QueryResult<CandidateLabelQuery, CandidateLabelQueryVariables>;
export const CandidateLabelsWithCountDocument = gql`
    query candidateLabelsWithCount {
  candidateLabels {
    ...CandidateLabelWithCount
  }
}
    ${CandidateLabelWithCountFragmentDoc}`;

/**
 * __useCandidateLabelsWithCountQuery__
 *
 * To run a query within a React component, call `useCandidateLabelsWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateLabelsWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateLabelsWithCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCandidateLabelsWithCountQuery(baseOptions?: Apollo.QueryHookOptions<CandidateLabelsWithCountQuery, CandidateLabelsWithCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateLabelsWithCountQuery, CandidateLabelsWithCountQueryVariables>(CandidateLabelsWithCountDocument, options);
      }
export function useCandidateLabelsWithCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateLabelsWithCountQuery, CandidateLabelsWithCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateLabelsWithCountQuery, CandidateLabelsWithCountQueryVariables>(CandidateLabelsWithCountDocument, options);
        }
export type CandidateLabelsWithCountQueryHookResult = ReturnType<typeof useCandidateLabelsWithCountQuery>;
export type CandidateLabelsWithCountLazyQueryHookResult = ReturnType<typeof useCandidateLabelsWithCountLazyQuery>;
export type CandidateLabelsWithCountQueryResult = Apollo.QueryResult<CandidateLabelsWithCountQuery, CandidateLabelsWithCountQueryVariables>;
export const UpdateCandidateLabelsDocument = gql`
    mutation updateCandidateLabels($input: UpdateCandidateLabelsInput!) {
  updateCandidateLabels(input: $input)
}
    `;
export type UpdateCandidateLabelsMutationFn = Apollo.MutationFunction<UpdateCandidateLabelsMutation, UpdateCandidateLabelsMutationVariables>;

/**
 * __useUpdateCandidateLabelsMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateLabelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateLabelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateLabelsMutation, { data, loading, error }] = useUpdateCandidateLabelsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateLabelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateLabelsMutation, UpdateCandidateLabelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateLabelsMutation, UpdateCandidateLabelsMutationVariables>(UpdateCandidateLabelsDocument, options);
      }
export type UpdateCandidateLabelsMutationHookResult = ReturnType<typeof useUpdateCandidateLabelsMutation>;
export type UpdateCandidateLabelsMutationResult = Apollo.MutationResult<UpdateCandidateLabelsMutation>;
export type UpdateCandidateLabelsMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateLabelsMutation, UpdateCandidateLabelsMutationVariables>;
export const CreateCandidateLabelDocument = gql`
    mutation createCandidateLabel($input: CreateUpdateCandidateLabelInput!) {
  createCandidateLabel(input: $input) {
    ...CandidateLabel
  }
}
    ${CandidateLabelFragmentDoc}`;
export type CreateCandidateLabelMutationFn = Apollo.MutationFunction<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>;

/**
 * __useCreateCandidateLabelMutation__
 *
 * To run a mutation, you first call `useCreateCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateLabelMutation, { data, loading, error }] = useCreateCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateLabelMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>(CreateCandidateLabelDocument, options);
      }
export type CreateCandidateLabelMutationHookResult = ReturnType<typeof useCreateCandidateLabelMutation>;
export type CreateCandidateLabelMutationResult = Apollo.MutationResult<CreateCandidateLabelMutation>;
export type CreateCandidateLabelMutationOptions = Apollo.BaseMutationOptions<CreateCandidateLabelMutation, CreateCandidateLabelMutationVariables>;
export const UpdateCandidateLabelDocument = gql`
    mutation updateCandidateLabel($input: CreateUpdateCandidateLabelInput!, $labelId: String!) {
  updateCandidateLabel(input: $input, id: $labelId) {
    ...CandidateLabel
  }
}
    ${CandidateLabelFragmentDoc}`;
export type UpdateCandidateLabelMutationFn = Apollo.MutationFunction<UpdateCandidateLabelMutation, UpdateCandidateLabelMutationVariables>;

/**
 * __useUpdateCandidateLabelMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateLabelMutation, { data, loading, error }] = useUpdateCandidateLabelMutation({
 *   variables: {
 *      input: // value for 'input'
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useUpdateCandidateLabelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateLabelMutation, UpdateCandidateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateLabelMutation, UpdateCandidateLabelMutationVariables>(UpdateCandidateLabelDocument, options);
      }
export type UpdateCandidateLabelMutationHookResult = ReturnType<typeof useUpdateCandidateLabelMutation>;
export type UpdateCandidateLabelMutationResult = Apollo.MutationResult<UpdateCandidateLabelMutation>;
export type UpdateCandidateLabelMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateLabelMutation, UpdateCandidateLabelMutationVariables>;
export const DeleteCandidateLabelDocument = gql`
    mutation deleteCandidateLabel($labelId: String!) {
  deleteCandidateLabel(id: $labelId)
}
    `;
export type DeleteCandidateLabelMutationFn = Apollo.MutationFunction<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>;

/**
 * __useDeleteCandidateLabelMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateLabelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateLabelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateLabelMutation, { data, loading, error }] = useDeleteCandidateLabelMutation({
 *   variables: {
 *      labelId: // value for 'labelId'
 *   },
 * });
 */
export function useDeleteCandidateLabelMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>(DeleteCandidateLabelDocument, options);
      }
export type DeleteCandidateLabelMutationHookResult = ReturnType<typeof useDeleteCandidateLabelMutation>;
export type DeleteCandidateLabelMutationResult = Apollo.MutationResult<DeleteCandidateLabelMutation>;
export type DeleteCandidateLabelMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateLabelMutation, DeleteCandidateLabelMutationVariables>;
export const ListProgramsDocument = gql`
    query listPrograms($input: CandidateProgramListInput!) {
  candidatePrograms(input: $input) {
    total
    items {
      ...ProgramSummary
    }
  }
}
    ${ProgramSummaryFragmentDoc}`;

/**
 * __useListProgramsQuery__
 *
 * To run a query within a React component, call `useListProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProgramsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListProgramsQuery(baseOptions: Apollo.QueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
      }
export function useListProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProgramsQuery, ListProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProgramsQuery, ListProgramsQueryVariables>(ListProgramsDocument, options);
        }
export type ListProgramsQueryHookResult = ReturnType<typeof useListProgramsQuery>;
export type ListProgramsLazyQueryHookResult = ReturnType<typeof useListProgramsLazyQuery>;
export type ListProgramsQueryResult = Apollo.QueryResult<ListProgramsQuery, ListProgramsQueryVariables>;
export const GetProgramDocument = gql`
    query getProgram($id: String!) {
  candidateProgram(id: $id) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;

/**
 * __useGetProgramQuery__
 *
 * To run a query within a React component, call `useGetProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramQuery(baseOptions: Apollo.QueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
      }
export function useGetProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgramQuery, GetProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgramQuery, GetProgramQueryVariables>(GetProgramDocument, options);
        }
export type GetProgramQueryHookResult = ReturnType<typeof useGetProgramQuery>;
export type GetProgramLazyQueryHookResult = ReturnType<typeof useGetProgramLazyQuery>;
export type GetProgramQueryResult = Apollo.QueryResult<GetProgramQuery, GetProgramQueryVariables>;
export const GetMyProgramDocument = gql`
    query getMyProgram {
  myProgram {
    ...MyProgram
  }
}
    ${MyProgramFragmentDoc}`;

/**
 * __useGetMyProgramQuery__
 *
 * To run a query within a React component, call `useGetMyProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgramQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProgramQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProgramQuery, GetMyProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProgramQuery, GetMyProgramQueryVariables>(GetMyProgramDocument, options);
      }
export function useGetMyProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProgramQuery, GetMyProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProgramQuery, GetMyProgramQueryVariables>(GetMyProgramDocument, options);
        }
export type GetMyProgramQueryHookResult = ReturnType<typeof useGetMyProgramQuery>;
export type GetMyProgramLazyQueryHookResult = ReturnType<typeof useGetMyProgramLazyQuery>;
export type GetMyProgramQueryResult = Apollo.QueryResult<GetMyProgramQuery, GetMyProgramQueryVariables>;
export const CreateProgramDocument = gql`
    mutation createProgram($input: CreateCandidateProgramInput!) {
  createCandidateProgram(input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type CreateProgramMutationFn = Apollo.MutationFunction<CreateProgramMutation, CreateProgramMutationVariables>;

/**
 * __useCreateProgramMutation__
 *
 * To run a mutation, you first call `useCreateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramMutation, { data, loading, error }] = useCreateProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramMutation, CreateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramMutation, CreateProgramMutationVariables>(CreateProgramDocument, options);
      }
export type CreateProgramMutationHookResult = ReturnType<typeof useCreateProgramMutation>;
export type CreateProgramMutationResult = Apollo.MutationResult<CreateProgramMutation>;
export type CreateProgramMutationOptions = Apollo.BaseMutationOptions<CreateProgramMutation, CreateProgramMutationVariables>;
export const UpdateProgramDocument = gql`
    mutation updateProgram($id: String!, $input: UpdateCandidateProgramInput!) {
  updateCandidateProgram(id: $id, input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type UpdateProgramMutationFn = Apollo.MutationFunction<UpdateProgramMutation, UpdateProgramMutationVariables>;

/**
 * __useUpdateProgramMutation__
 *
 * To run a mutation, you first call `useUpdateProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramMutation, { data, loading, error }] = useUpdateProgramMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramMutation, UpdateProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramMutation, UpdateProgramMutationVariables>(UpdateProgramDocument, options);
      }
export type UpdateProgramMutationHookResult = ReturnType<typeof useUpdateProgramMutation>;
export type UpdateProgramMutationResult = Apollo.MutationResult<UpdateProgramMutation>;
export type UpdateProgramMutationOptions = Apollo.BaseMutationOptions<UpdateProgramMutation, UpdateProgramMutationVariables>;
export const CandidateProgramSuggestionsDocument = gql`
    query candidateProgramSuggestions($input: SuggestionsInput!, $isActive: Boolean) {
  candidateProgramSuggestions(input: $input, isActive: $isActive) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useCandidateProgramSuggestionsQuery__
 *
 * To run a query within a React component, call `useCandidateProgramSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateProgramSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateProgramSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useCandidateProgramSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<CandidateProgramSuggestionsQuery, CandidateProgramSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateProgramSuggestionsQuery, CandidateProgramSuggestionsQueryVariables>(CandidateProgramSuggestionsDocument, options);
      }
export function useCandidateProgramSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateProgramSuggestionsQuery, CandidateProgramSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateProgramSuggestionsQuery, CandidateProgramSuggestionsQueryVariables>(CandidateProgramSuggestionsDocument, options);
        }
export type CandidateProgramSuggestionsQueryHookResult = ReturnType<typeof useCandidateProgramSuggestionsQuery>;
export type CandidateProgramSuggestionsLazyQueryHookResult = ReturnType<typeof useCandidateProgramSuggestionsLazyQuery>;
export type CandidateProgramSuggestionsQueryResult = Apollo.QueryResult<CandidateProgramSuggestionsQuery, CandidateProgramSuggestionsQueryVariables>;
export const AssignCandidateToProgramDocument = gql`
    mutation assignCandidateToProgram($input: AssignCandidateProgramInput!) {
  assignCandidateToProgram(input: $input)
}
    `;
export type AssignCandidateToProgramMutationFn = Apollo.MutationFunction<AssignCandidateToProgramMutation, AssignCandidateToProgramMutationVariables>;

/**
 * __useAssignCandidateToProgramMutation__
 *
 * To run a mutation, you first call `useAssignCandidateToProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCandidateToProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCandidateToProgramMutation, { data, loading, error }] = useAssignCandidateToProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCandidateToProgramMutation(baseOptions?: Apollo.MutationHookOptions<AssignCandidateToProgramMutation, AssignCandidateToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCandidateToProgramMutation, AssignCandidateToProgramMutationVariables>(AssignCandidateToProgramDocument, options);
      }
export type AssignCandidateToProgramMutationHookResult = ReturnType<typeof useAssignCandidateToProgramMutation>;
export type AssignCandidateToProgramMutationResult = Apollo.MutationResult<AssignCandidateToProgramMutation>;
export type AssignCandidateToProgramMutationOptions = Apollo.BaseMutationOptions<AssignCandidateToProgramMutation, AssignCandidateToProgramMutationVariables>;
export const AddStageToProgramDocument = gql`
    mutation addStageToProgram($programId: String!, $input: AddCandidateProgramStageInput!) {
  addStageToProgram(programId: $programId, input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type AddStageToProgramMutationFn = Apollo.MutationFunction<AddStageToProgramMutation, AddStageToProgramMutationVariables>;

/**
 * __useAddStageToProgramMutation__
 *
 * To run a mutation, you first call `useAddStageToProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStageToProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStageToProgramMutation, { data, loading, error }] = useAddStageToProgramMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddStageToProgramMutation(baseOptions?: Apollo.MutationHookOptions<AddStageToProgramMutation, AddStageToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStageToProgramMutation, AddStageToProgramMutationVariables>(AddStageToProgramDocument, options);
      }
export type AddStageToProgramMutationHookResult = ReturnType<typeof useAddStageToProgramMutation>;
export type AddStageToProgramMutationResult = Apollo.MutationResult<AddStageToProgramMutation>;
export type AddStageToProgramMutationOptions = Apollo.BaseMutationOptions<AddStageToProgramMutation, AddStageToProgramMutationVariables>;
export const EditProgramStageDocument = gql`
    mutation editProgramStage($input: EditCandidateProgramStageInput!) {
  editProgramStage(input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type EditProgramStageMutationFn = Apollo.MutationFunction<EditProgramStageMutation, EditProgramStageMutationVariables>;

/**
 * __useEditProgramStageMutation__
 *
 * To run a mutation, you first call `useEditProgramStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProgramStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProgramStageMutation, { data, loading, error }] = useEditProgramStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProgramStageMutation(baseOptions?: Apollo.MutationHookOptions<EditProgramStageMutation, EditProgramStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProgramStageMutation, EditProgramStageMutationVariables>(EditProgramStageDocument, options);
      }
export type EditProgramStageMutationHookResult = ReturnType<typeof useEditProgramStageMutation>;
export type EditProgramStageMutationResult = Apollo.MutationResult<EditProgramStageMutation>;
export type EditProgramStageMutationOptions = Apollo.BaseMutationOptions<EditProgramStageMutation, EditProgramStageMutationVariables>;
export const EditProgramStageEmailsDocument = gql`
    mutation editProgramStageEmails($input: EditCandidateProgramStageEmailsInput!) {
  editProgramStageEmails(input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type EditProgramStageEmailsMutationFn = Apollo.MutationFunction<EditProgramStageEmailsMutation, EditProgramStageEmailsMutationVariables>;

/**
 * __useEditProgramStageEmailsMutation__
 *
 * To run a mutation, you first call `useEditProgramStageEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditProgramStageEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editProgramStageEmailsMutation, { data, loading, error }] = useEditProgramStageEmailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditProgramStageEmailsMutation(baseOptions?: Apollo.MutationHookOptions<EditProgramStageEmailsMutation, EditProgramStageEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditProgramStageEmailsMutation, EditProgramStageEmailsMutationVariables>(EditProgramStageEmailsDocument, options);
      }
export type EditProgramStageEmailsMutationHookResult = ReturnType<typeof useEditProgramStageEmailsMutation>;
export type EditProgramStageEmailsMutationResult = Apollo.MutationResult<EditProgramStageEmailsMutation>;
export type EditProgramStageEmailsMutationOptions = Apollo.BaseMutationOptions<EditProgramStageEmailsMutation, EditProgramStageEmailsMutationVariables>;
export const RemoveStageFromProgramDocument = gql`
    mutation removeStageFromProgram($input: RemoveCandidateProgramStageInput!) {
  removeStageFromProgram(input: $input) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type RemoveStageFromProgramMutationFn = Apollo.MutationFunction<RemoveStageFromProgramMutation, RemoveStageFromProgramMutationVariables>;

/**
 * __useRemoveStageFromProgramMutation__
 *
 * To run a mutation, you first call `useRemoveStageFromProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStageFromProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStageFromProgramMutation, { data, loading, error }] = useRemoveStageFromProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveStageFromProgramMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStageFromProgramMutation, RemoveStageFromProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStageFromProgramMutation, RemoveStageFromProgramMutationVariables>(RemoveStageFromProgramDocument, options);
      }
export type RemoveStageFromProgramMutationHookResult = ReturnType<typeof useRemoveStageFromProgramMutation>;
export type RemoveStageFromProgramMutationResult = Apollo.MutationResult<RemoveStageFromProgramMutation>;
export type RemoveStageFromProgramMutationOptions = Apollo.BaseMutationOptions<RemoveStageFromProgramMutation, RemoveStageFromProgramMutationVariables>;
export const UpdateProgramStageRequirementsDocument = gql`
    mutation updateProgramStageRequirements($programId: String!, $stageKey: String!, $requirements: [AddCandidateProgramRequirementInput!]!) {
  updateProgramStageRequirements(
    programId: $programId
    stageKey: $stageKey
    requirements: $requirements
  ) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type UpdateProgramStageRequirementsMutationFn = Apollo.MutationFunction<UpdateProgramStageRequirementsMutation, UpdateProgramStageRequirementsMutationVariables>;

/**
 * __useUpdateProgramStageRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateProgramStageRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramStageRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramStageRequirementsMutation, { data, loading, error }] = useUpdateProgramStageRequirementsMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      stageKey: // value for 'stageKey'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useUpdateProgramStageRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramStageRequirementsMutation, UpdateProgramStageRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramStageRequirementsMutation, UpdateProgramStageRequirementsMutationVariables>(UpdateProgramStageRequirementsDocument, options);
      }
export type UpdateProgramStageRequirementsMutationHookResult = ReturnType<typeof useUpdateProgramStageRequirementsMutation>;
export type UpdateProgramStageRequirementsMutationResult = Apollo.MutationResult<UpdateProgramStageRequirementsMutation>;
export type UpdateProgramStageRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateProgramStageRequirementsMutation, UpdateProgramStageRequirementsMutationVariables>;
export const UpdateProgramApplicationRequirementsDocument = gql`
    mutation updateProgramApplicationRequirements($programId: String!, $requirements: [AddCandidateProgramRequirementInput!]!) {
  updateProgramApplicationRequirements(
    programId: $programId
    requirements: $requirements
  ) {
    ...ProgramDetail
  }
}
    ${ProgramDetailFragmentDoc}`;
export type UpdateProgramApplicationRequirementsMutationFn = Apollo.MutationFunction<UpdateProgramApplicationRequirementsMutation, UpdateProgramApplicationRequirementsMutationVariables>;

/**
 * __useUpdateProgramApplicationRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateProgramApplicationRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramApplicationRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramApplicationRequirementsMutation, { data, loading, error }] = useUpdateProgramApplicationRequirementsMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      requirements: // value for 'requirements'
 *   },
 * });
 */
export function useUpdateProgramApplicationRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramApplicationRequirementsMutation, UpdateProgramApplicationRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramApplicationRequirementsMutation, UpdateProgramApplicationRequirementsMutationVariables>(UpdateProgramApplicationRequirementsDocument, options);
      }
export type UpdateProgramApplicationRequirementsMutationHookResult = ReturnType<typeof useUpdateProgramApplicationRequirementsMutation>;
export type UpdateProgramApplicationRequirementsMutationResult = Apollo.MutationResult<UpdateProgramApplicationRequirementsMutation>;
export type UpdateProgramApplicationRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateProgramApplicationRequirementsMutation, UpdateProgramApplicationRequirementsMutationVariables>;
export const GetCandidateProgramProgressDocument = gql`
    query getCandidateProgramProgress($candidateId: String!) {
  candidateProgramProgress(candidateId: $candidateId) {
    ...ProgramProgress
  }
}
    ${ProgramProgressFragmentDoc}`;

/**
 * __useGetCandidateProgramProgressQuery__
 *
 * To run a query within a React component, call `useGetCandidateProgramProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProgramProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProgramProgressQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCandidateProgramProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateProgramProgressQuery, GetCandidateProgramProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateProgramProgressQuery, GetCandidateProgramProgressQueryVariables>(GetCandidateProgramProgressDocument, options);
      }
export function useGetCandidateProgramProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateProgramProgressQuery, GetCandidateProgramProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateProgramProgressQuery, GetCandidateProgramProgressQueryVariables>(GetCandidateProgramProgressDocument, options);
        }
export type GetCandidateProgramProgressQueryHookResult = ReturnType<typeof useGetCandidateProgramProgressQuery>;
export type GetCandidateProgramProgressLazyQueryHookResult = ReturnType<typeof useGetCandidateProgramProgressLazyQuery>;
export type GetCandidateProgramProgressQueryResult = Apollo.QueryResult<GetCandidateProgramProgressQuery, GetCandidateProgramProgressQueryVariables>;
export const GetMyProgramProgressDocument = gql`
    query getMyProgramProgress {
  myProgramProgress {
    ...ProgramProgress
  }
}
    ${ProgramProgressFragmentDoc}`;

/**
 * __useGetMyProgramProgressQuery__
 *
 * To run a query within a React component, call `useGetMyProgramProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProgramProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProgramProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProgramProgressQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProgramProgressQuery, GetMyProgramProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProgramProgressQuery, GetMyProgramProgressQueryVariables>(GetMyProgramProgressDocument, options);
      }
export function useGetMyProgramProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProgramProgressQuery, GetMyProgramProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProgramProgressQuery, GetMyProgramProgressQueryVariables>(GetMyProgramProgressDocument, options);
        }
export type GetMyProgramProgressQueryHookResult = ReturnType<typeof useGetMyProgramProgressQuery>;
export type GetMyProgramProgressLazyQueryHookResult = ReturnType<typeof useGetMyProgramProgressLazyQuery>;
export type GetMyProgramProgressQueryResult = Apollo.QueryResult<GetMyProgramProgressQuery, GetMyProgramProgressQueryVariables>;
export const UpdateProgramStageRequirementCompletionDocument = gql`
    mutation updateProgramStageRequirementCompletion($input: CompleteCandidateProgramStageRequirementInput!) {
  updateProgramStageRequirementCompletion(input: $input)
}
    `;
export type UpdateProgramStageRequirementCompletionMutationFn = Apollo.MutationFunction<UpdateProgramStageRequirementCompletionMutation, UpdateProgramStageRequirementCompletionMutationVariables>;

/**
 * __useUpdateProgramStageRequirementCompletionMutation__
 *
 * To run a mutation, you first call `useUpdateProgramStageRequirementCompletionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramStageRequirementCompletionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramStageRequirementCompletionMutation, { data, loading, error }] = useUpdateProgramStageRequirementCompletionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramStageRequirementCompletionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramStageRequirementCompletionMutation, UpdateProgramStageRequirementCompletionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramStageRequirementCompletionMutation, UpdateProgramStageRequirementCompletionMutationVariables>(UpdateProgramStageRequirementCompletionDocument, options);
      }
export type UpdateProgramStageRequirementCompletionMutationHookResult = ReturnType<typeof useUpdateProgramStageRequirementCompletionMutation>;
export type UpdateProgramStageRequirementCompletionMutationResult = Apollo.MutationResult<UpdateProgramStageRequirementCompletionMutation>;
export type UpdateProgramStageRequirementCompletionMutationOptions = Apollo.BaseMutationOptions<UpdateProgramStageRequirementCompletionMutation, UpdateProgramStageRequirementCompletionMutationVariables>;
export const MoveCandidateToNextProgramStageDocument = gql`
    mutation moveCandidateToNextProgramStage($candidateId: String!) {
  moveCandidateToNextProgramStage(candidateId: $candidateId)
}
    `;
export type MoveCandidateToNextProgramStageMutationFn = Apollo.MutationFunction<MoveCandidateToNextProgramStageMutation, MoveCandidateToNextProgramStageMutationVariables>;

/**
 * __useMoveCandidateToNextProgramStageMutation__
 *
 * To run a mutation, you first call `useMoveCandidateToNextProgramStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCandidateToNextProgramStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCandidateToNextProgramStageMutation, { data, loading, error }] = useMoveCandidateToNextProgramStageMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useMoveCandidateToNextProgramStageMutation(baseOptions?: Apollo.MutationHookOptions<MoveCandidateToNextProgramStageMutation, MoveCandidateToNextProgramStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCandidateToNextProgramStageMutation, MoveCandidateToNextProgramStageMutationVariables>(MoveCandidateToNextProgramStageDocument, options);
      }
export type MoveCandidateToNextProgramStageMutationHookResult = ReturnType<typeof useMoveCandidateToNextProgramStageMutation>;
export type MoveCandidateToNextProgramStageMutationResult = Apollo.MutationResult<MoveCandidateToNextProgramStageMutation>;
export type MoveCandidateToNextProgramStageMutationOptions = Apollo.BaseMutationOptions<MoveCandidateToNextProgramStageMutation, MoveCandidateToNextProgramStageMutationVariables>;
export const AcceptCandidateAgreementDocument = gql`
    mutation acceptCandidateAgreement {
  acceptCandidateAgreement
}
    `;
export type AcceptCandidateAgreementMutationFn = Apollo.MutationFunction<AcceptCandidateAgreementMutation, AcceptCandidateAgreementMutationVariables>;

/**
 * __useAcceptCandidateAgreementMutation__
 *
 * To run a mutation, you first call `useAcceptCandidateAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCandidateAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCandidateAgreementMutation, { data, loading, error }] = useAcceptCandidateAgreementMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptCandidateAgreementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCandidateAgreementMutation, AcceptCandidateAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCandidateAgreementMutation, AcceptCandidateAgreementMutationVariables>(AcceptCandidateAgreementDocument, options);
      }
export type AcceptCandidateAgreementMutationHookResult = ReturnType<typeof useAcceptCandidateAgreementMutation>;
export type AcceptCandidateAgreementMutationResult = Apollo.MutationResult<AcceptCandidateAgreementMutation>;
export type AcceptCandidateAgreementMutationOptions = Apollo.BaseMutationOptions<AcceptCandidateAgreementMutation, AcceptCandidateAgreementMutationVariables>;
export const CandidateSignupDocument = gql`
    mutation candidateSignup($input: CandidateSignupInput!) {
  candidateSignup(input: $input) {
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type CandidateSignupMutationFn = Apollo.MutationFunction<CandidateSignupMutation, CandidateSignupMutationVariables>;

/**
 * __useCandidateSignupMutation__
 *
 * To run a mutation, you first call `useCandidateSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCandidateSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [candidateSignupMutation, { data, loading, error }] = useCandidateSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateSignupMutation(baseOptions?: Apollo.MutationHookOptions<CandidateSignupMutation, CandidateSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CandidateSignupMutation, CandidateSignupMutationVariables>(CandidateSignupDocument, options);
      }
export type CandidateSignupMutationHookResult = ReturnType<typeof useCandidateSignupMutation>;
export type CandidateSignupMutationResult = Apollo.MutationResult<CandidateSignupMutation>;
export type CandidateSignupMutationOptions = Apollo.BaseMutationOptions<CandidateSignupMutation, CandidateSignupMutationVariables>;
export const UpdateCandidateProfileDocument = gql`
    mutation updateCandidateProfile($input: UpdateCandidateProfileInput!, $id: String) {
  updateCandidateProfile(input: $input, id: $id) {
    ...CandidateProfile
  }
}
    ${CandidateProfileFragmentDoc}`;
export type UpdateCandidateProfileMutationFn = Apollo.MutationFunction<UpdateCandidateProfileMutation, UpdateCandidateProfileMutationVariables>;

/**
 * __useUpdateCandidateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateProfileMutation, { data, loading, error }] = useUpdateCandidateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCandidateProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateProfileMutation, UpdateCandidateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateProfileMutation, UpdateCandidateProfileMutationVariables>(UpdateCandidateProfileDocument, options);
      }
export type UpdateCandidateProfileMutationHookResult = ReturnType<typeof useUpdateCandidateProfileMutation>;
export type UpdateCandidateProfileMutationResult = Apollo.MutationResult<UpdateCandidateProfileMutation>;
export type UpdateCandidateProfileMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateProfileMutation, UpdateCandidateProfileMutationVariables>;
export const GetCandidateProfileDocument = gql`
    query getCandidateProfile {
  getCandidateProfile {
    ...CandidateProfile
  }
}
    ${CandidateProfileFragmentDoc}`;

/**
 * __useGetCandidateProfileQuery__
 *
 * To run a query within a React component, call `useGetCandidateProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCandidateProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>(GetCandidateProfileDocument, options);
      }
export function useGetCandidateProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>(GetCandidateProfileDocument, options);
        }
export type GetCandidateProfileQueryHookResult = ReturnType<typeof useGetCandidateProfileQuery>;
export type GetCandidateProfileLazyQueryHookResult = ReturnType<typeof useGetCandidateProfileLazyQuery>;
export type GetCandidateProfileQueryResult = Apollo.QueryResult<GetCandidateProfileQuery, GetCandidateProfileQueryVariables>;
export const UpdateCandidateEnrolmentApplicationDocument = gql`
    mutation updateCandidateEnrolmentApplication($input: UpdateCandidateEnrolmentApplicationInput!) {
  updateCandidateEnrolmentApplication(input: $input) {
    ...CandidateEnrolmentApplication
  }
}
    ${CandidateEnrolmentApplicationFragmentDoc}`;
export type UpdateCandidateEnrolmentApplicationMutationFn = Apollo.MutationFunction<UpdateCandidateEnrolmentApplicationMutation, UpdateCandidateEnrolmentApplicationMutationVariables>;

/**
 * __useUpdateCandidateEnrolmentApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateEnrolmentApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateEnrolmentApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateEnrolmentApplicationMutation, { data, loading, error }] = useUpdateCandidateEnrolmentApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateEnrolmentApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateEnrolmentApplicationMutation, UpdateCandidateEnrolmentApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateEnrolmentApplicationMutation, UpdateCandidateEnrolmentApplicationMutationVariables>(UpdateCandidateEnrolmentApplicationDocument, options);
      }
export type UpdateCandidateEnrolmentApplicationMutationHookResult = ReturnType<typeof useUpdateCandidateEnrolmentApplicationMutation>;
export type UpdateCandidateEnrolmentApplicationMutationResult = Apollo.MutationResult<UpdateCandidateEnrolmentApplicationMutation>;
export type UpdateCandidateEnrolmentApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateEnrolmentApplicationMutation, UpdateCandidateEnrolmentApplicationMutationVariables>;
export const GetCandidateEnrolmentApplicationDocument = gql`
    query getCandidateEnrolmentApplication {
  getCandidateEnrolmentApplication {
    ...CandidateEnrolmentApplication
  }
}
    ${CandidateEnrolmentApplicationFragmentDoc}`;

/**
 * __useGetCandidateEnrolmentApplicationQuery__
 *
 * To run a query within a React component, call `useGetCandidateEnrolmentApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateEnrolmentApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateEnrolmentApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCandidateEnrolmentApplicationQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateEnrolmentApplicationQuery, GetCandidateEnrolmentApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateEnrolmentApplicationQuery, GetCandidateEnrolmentApplicationQueryVariables>(GetCandidateEnrolmentApplicationDocument, options);
      }
export function useGetCandidateEnrolmentApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateEnrolmentApplicationQuery, GetCandidateEnrolmentApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateEnrolmentApplicationQuery, GetCandidateEnrolmentApplicationQueryVariables>(GetCandidateEnrolmentApplicationDocument, options);
        }
export type GetCandidateEnrolmentApplicationQueryHookResult = ReturnType<typeof useGetCandidateEnrolmentApplicationQuery>;
export type GetCandidateEnrolmentApplicationLazyQueryHookResult = ReturnType<typeof useGetCandidateEnrolmentApplicationLazyQuery>;
export type GetCandidateEnrolmentApplicationQueryResult = Apollo.QueryResult<GetCandidateEnrolmentApplicationQuery, GetCandidateEnrolmentApplicationQueryVariables>;
export const ListCandidatesDocument = gql`
    query listCandidates($input: CandidateListInput!) {
  candidates(input: $input) {
    total
    items {
      ...CandidateSummary
    }
  }
}
    ${CandidateSummaryFragmentDoc}`;

/**
 * __useListCandidatesQuery__
 *
 * To run a query within a React component, call `useListCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCandidatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCandidatesQuery(baseOptions: Apollo.QueryHookOptions<ListCandidatesQuery, ListCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCandidatesQuery, ListCandidatesQueryVariables>(ListCandidatesDocument, options);
      }
export function useListCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCandidatesQuery, ListCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCandidatesQuery, ListCandidatesQueryVariables>(ListCandidatesDocument, options);
        }
export type ListCandidatesQueryHookResult = ReturnType<typeof useListCandidatesQuery>;
export type ListCandidatesLazyQueryHookResult = ReturnType<typeof useListCandidatesLazyQuery>;
export type ListCandidatesQueryResult = Apollo.QueryResult<ListCandidatesQuery, ListCandidatesQueryVariables>;
export const GetCandidateDocument = gql`
    query getCandidate($id: String!) {
  candidate(id: $id) {
    ...CandidateDetailed
  }
}
    ${CandidateDetailedFragmentDoc}`;

/**
 * __useGetCandidateQuery__
 *
 * To run a query within a React component, call `useGetCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
      }
export function useGetCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
        }
export type GetCandidateQueryHookResult = ReturnType<typeof useGetCandidateQuery>;
export type GetCandidateLazyQueryHookResult = ReturnType<typeof useGetCandidateLazyQuery>;
export type GetCandidateQueryResult = Apollo.QueryResult<GetCandidateQuery, GetCandidateQueryVariables>;
export const SubmitCandidateEnrolmentApplicationDocument = gql`
    mutation submitCandidateEnrolmentApplication {
  submitCandidateEnrolmentApplication
}
    `;
export type SubmitCandidateEnrolmentApplicationMutationFn = Apollo.MutationFunction<SubmitCandidateEnrolmentApplicationMutation, SubmitCandidateEnrolmentApplicationMutationVariables>;

/**
 * __useSubmitCandidateEnrolmentApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitCandidateEnrolmentApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCandidateEnrolmentApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCandidateEnrolmentApplicationMutation, { data, loading, error }] = useSubmitCandidateEnrolmentApplicationMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitCandidateEnrolmentApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCandidateEnrolmentApplicationMutation, SubmitCandidateEnrolmentApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCandidateEnrolmentApplicationMutation, SubmitCandidateEnrolmentApplicationMutationVariables>(SubmitCandidateEnrolmentApplicationDocument, options);
      }
export type SubmitCandidateEnrolmentApplicationMutationHookResult = ReturnType<typeof useSubmitCandidateEnrolmentApplicationMutation>;
export type SubmitCandidateEnrolmentApplicationMutationResult = Apollo.MutationResult<SubmitCandidateEnrolmentApplicationMutation>;
export type SubmitCandidateEnrolmentApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitCandidateEnrolmentApplicationMutation, SubmitCandidateEnrolmentApplicationMutationVariables>;
export const AcceptCandidateEnrolmentApplicationDocument = gql`
    mutation acceptCandidateEnrolmentApplication($id: String!) {
  acceptCandidateEnrolmentApplication(id: $id)
}
    `;
export type AcceptCandidateEnrolmentApplicationMutationFn = Apollo.MutationFunction<AcceptCandidateEnrolmentApplicationMutation, AcceptCandidateEnrolmentApplicationMutationVariables>;

/**
 * __useAcceptCandidateEnrolmentApplicationMutation__
 *
 * To run a mutation, you first call `useAcceptCandidateEnrolmentApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCandidateEnrolmentApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCandidateEnrolmentApplicationMutation, { data, loading, error }] = useAcceptCandidateEnrolmentApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAcceptCandidateEnrolmentApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCandidateEnrolmentApplicationMutation, AcceptCandidateEnrolmentApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCandidateEnrolmentApplicationMutation, AcceptCandidateEnrolmentApplicationMutationVariables>(AcceptCandidateEnrolmentApplicationDocument, options);
      }
export type AcceptCandidateEnrolmentApplicationMutationHookResult = ReturnType<typeof useAcceptCandidateEnrolmentApplicationMutation>;
export type AcceptCandidateEnrolmentApplicationMutationResult = Apollo.MutationResult<AcceptCandidateEnrolmentApplicationMutation>;
export type AcceptCandidateEnrolmentApplicationMutationOptions = Apollo.BaseMutationOptions<AcceptCandidateEnrolmentApplicationMutation, AcceptCandidateEnrolmentApplicationMutationVariables>;
export const WaitlistCandidateEnrolmentApplicationDocument = gql`
    mutation waitlistCandidateEnrolmentApplication($id: String!) {
  waitlistCandidateEnrolmentApplication(id: $id)
}
    `;
export type WaitlistCandidateEnrolmentApplicationMutationFn = Apollo.MutationFunction<WaitlistCandidateEnrolmentApplicationMutation, WaitlistCandidateEnrolmentApplicationMutationVariables>;

/**
 * __useWaitlistCandidateEnrolmentApplicationMutation__
 *
 * To run a mutation, you first call `useWaitlistCandidateEnrolmentApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistCandidateEnrolmentApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistCandidateEnrolmentApplicationMutation, { data, loading, error }] = useWaitlistCandidateEnrolmentApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaitlistCandidateEnrolmentApplicationMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistCandidateEnrolmentApplicationMutation, WaitlistCandidateEnrolmentApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistCandidateEnrolmentApplicationMutation, WaitlistCandidateEnrolmentApplicationMutationVariables>(WaitlistCandidateEnrolmentApplicationDocument, options);
      }
export type WaitlistCandidateEnrolmentApplicationMutationHookResult = ReturnType<typeof useWaitlistCandidateEnrolmentApplicationMutation>;
export type WaitlistCandidateEnrolmentApplicationMutationResult = Apollo.MutationResult<WaitlistCandidateEnrolmentApplicationMutation>;
export type WaitlistCandidateEnrolmentApplicationMutationOptions = Apollo.BaseMutationOptions<WaitlistCandidateEnrolmentApplicationMutation, WaitlistCandidateEnrolmentApplicationMutationVariables>;
export const GetCandidateCountsDocument = gql`
    query getCandidateCounts {
  candidateCounts {
    prospect
    enrolled
    waitlist
    admitted
  }
}
    `;

/**
 * __useGetCandidateCountsQuery__
 *
 * To run a query within a React component, call `useGetCandidateCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCandidateCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateCountsQuery, GetCandidateCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateCountsQuery, GetCandidateCountsQueryVariables>(GetCandidateCountsDocument, options);
      }
export function useGetCandidateCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateCountsQuery, GetCandidateCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateCountsQuery, GetCandidateCountsQueryVariables>(GetCandidateCountsDocument, options);
        }
export type GetCandidateCountsQueryHookResult = ReturnType<typeof useGetCandidateCountsQuery>;
export type GetCandidateCountsLazyQueryHookResult = ReturnType<typeof useGetCandidateCountsLazyQuery>;
export type GetCandidateCountsQueryResult = Apollo.QueryResult<GetCandidateCountsQuery, GetCandidateCountsQueryVariables>;
export const VerifyCandidateDocument = gql`
    mutation verifyCandidate($token: String!) {
  verifyCandidate(token: $token) {
    token
    user {
      ...User
    }
  }
}
    ${UserFragmentDoc}`;
export type VerifyCandidateMutationFn = Apollo.MutationFunction<VerifyCandidateMutation, VerifyCandidateMutationVariables>;

/**
 * __useVerifyCandidateMutation__
 *
 * To run a mutation, you first call `useVerifyCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyCandidateMutation, { data, loading, error }] = useVerifyCandidateMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyCandidateMutation(baseOptions?: Apollo.MutationHookOptions<VerifyCandidateMutation, VerifyCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyCandidateMutation, VerifyCandidateMutationVariables>(VerifyCandidateDocument, options);
      }
export type VerifyCandidateMutationHookResult = ReturnType<typeof useVerifyCandidateMutation>;
export type VerifyCandidateMutationResult = Apollo.MutationResult<VerifyCandidateMutation>;
export type VerifyCandidateMutationOptions = Apollo.BaseMutationOptions<VerifyCandidateMutation, VerifyCandidateMutationVariables>;
export const ScheduleCandidateEnrolmentInterviewDocument = gql`
    mutation scheduleCandidateEnrolmentInterview($input: ScheduleCandidateEnrolmentInterviewInput!) {
  scheduleCandidateEnrolmentInterview(input: $input)
}
    `;
export type ScheduleCandidateEnrolmentInterviewMutationFn = Apollo.MutationFunction<ScheduleCandidateEnrolmentInterviewMutation, ScheduleCandidateEnrolmentInterviewMutationVariables>;

/**
 * __useScheduleCandidateEnrolmentInterviewMutation__
 *
 * To run a mutation, you first call `useScheduleCandidateEnrolmentInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCandidateEnrolmentInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCandidateEnrolmentInterviewMutation, { data, loading, error }] = useScheduleCandidateEnrolmentInterviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleCandidateEnrolmentInterviewMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCandidateEnrolmentInterviewMutation, ScheduleCandidateEnrolmentInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCandidateEnrolmentInterviewMutation, ScheduleCandidateEnrolmentInterviewMutationVariables>(ScheduleCandidateEnrolmentInterviewDocument, options);
      }
export type ScheduleCandidateEnrolmentInterviewMutationHookResult = ReturnType<typeof useScheduleCandidateEnrolmentInterviewMutation>;
export type ScheduleCandidateEnrolmentInterviewMutationResult = Apollo.MutationResult<ScheduleCandidateEnrolmentInterviewMutation>;
export type ScheduleCandidateEnrolmentInterviewMutationOptions = Apollo.BaseMutationOptions<ScheduleCandidateEnrolmentInterviewMutation, ScheduleCandidateEnrolmentInterviewMutationVariables>;
export const EnrolDocument = gql`
    mutation enrol {
  enrol
}
    `;
export type EnrolMutationFn = Apollo.MutationFunction<EnrolMutation, EnrolMutationVariables>;

/**
 * __useEnrolMutation__
 *
 * To run a mutation, you first call `useEnrolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrolMutation, { data, loading, error }] = useEnrolMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnrolMutation(baseOptions?: Apollo.MutationHookOptions<EnrolMutation, EnrolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrolMutation, EnrolMutationVariables>(EnrolDocument, options);
      }
export type EnrolMutationHookResult = ReturnType<typeof useEnrolMutation>;
export type EnrolMutationResult = Apollo.MutationResult<EnrolMutation>;
export type EnrolMutationOptions = Apollo.BaseMutationOptions<EnrolMutation, EnrolMutationVariables>;
export const GetMyInvoicesDocument = gql`
    query getMyInvoices {
  getMyInvoices {
    ...MyInvoice
  }
}
    ${MyInvoiceFragmentDoc}`;

/**
 * __useGetMyInvoicesQuery__
 *
 * To run a query within a React component, call `useGetMyInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyInvoicesQuery, GetMyInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyInvoicesQuery, GetMyInvoicesQueryVariables>(GetMyInvoicesDocument, options);
      }
export function useGetMyInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyInvoicesQuery, GetMyInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyInvoicesQuery, GetMyInvoicesQueryVariables>(GetMyInvoicesDocument, options);
        }
export type GetMyInvoicesQueryHookResult = ReturnType<typeof useGetMyInvoicesQuery>;
export type GetMyInvoicesLazyQueryHookResult = ReturnType<typeof useGetMyInvoicesLazyQuery>;
export type GetMyInvoicesQueryResult = Apollo.QueryResult<GetMyInvoicesQuery, GetMyInvoicesQueryVariables>;
export const GetCandidateInvoicesDocument = gql`
    query getCandidateInvoices($candidateId: String!) {
  getCandidateInvoices(candidateId: $candidateId) {
    ...AdminInvoice
  }
}
    ${AdminInvoiceFragmentDoc}`;

/**
 * __useGetCandidateInvoicesQuery__
 *
 * To run a query within a React component, call `useGetCandidateInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateInvoicesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCandidateInvoicesQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateInvoicesQuery, GetCandidateInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateInvoicesQuery, GetCandidateInvoicesQueryVariables>(GetCandidateInvoicesDocument, options);
      }
export function useGetCandidateInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateInvoicesQuery, GetCandidateInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateInvoicesQuery, GetCandidateInvoicesQueryVariables>(GetCandidateInvoicesDocument, options);
        }
export type GetCandidateInvoicesQueryHookResult = ReturnType<typeof useGetCandidateInvoicesQuery>;
export type GetCandidateInvoicesLazyQueryHookResult = ReturnType<typeof useGetCandidateInvoicesLazyQuery>;
export type GetCandidateInvoicesQueryResult = Apollo.QueryResult<GetCandidateInvoicesQuery, GetCandidateInvoicesQueryVariables>;
export const GetCouponsDocument = gql`
    query getCoupons {
  getCoupons {
    ...Coupon
  }
}
    ${CouponFragmentDoc}`;

/**
 * __useGetCouponsQuery__
 *
 * To run a query within a React component, call `useGetCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCouponsQuery(baseOptions?: Apollo.QueryHookOptions<GetCouponsQuery, GetCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponsQuery, GetCouponsQueryVariables>(GetCouponsDocument, options);
      }
export function useGetCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponsQuery, GetCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponsQuery, GetCouponsQueryVariables>(GetCouponsDocument, options);
        }
export type GetCouponsQueryHookResult = ReturnType<typeof useGetCouponsQuery>;
export type GetCouponsLazyQueryHookResult = ReturnType<typeof useGetCouponsLazyQuery>;
export type GetCouponsQueryResult = Apollo.QueryResult<GetCouponsQuery, GetCouponsQueryVariables>;
export const HasOutstandingInvoiceDocument = gql`
    query hasOutstandingInvoice {
  hasOutstandingInvoice
}
    `;

/**
 * __useHasOutstandingInvoiceQuery__
 *
 * To run a query within a React component, call `useHasOutstandingInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasOutstandingInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasOutstandingInvoiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasOutstandingInvoiceQuery(baseOptions?: Apollo.QueryHookOptions<HasOutstandingInvoiceQuery, HasOutstandingInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasOutstandingInvoiceQuery, HasOutstandingInvoiceQueryVariables>(HasOutstandingInvoiceDocument, options);
      }
export function useHasOutstandingInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasOutstandingInvoiceQuery, HasOutstandingInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasOutstandingInvoiceQuery, HasOutstandingInvoiceQueryVariables>(HasOutstandingInvoiceDocument, options);
        }
export type HasOutstandingInvoiceQueryHookResult = ReturnType<typeof useHasOutstandingInvoiceQuery>;
export type HasOutstandingInvoiceLazyQueryHookResult = ReturnType<typeof useHasOutstandingInvoiceLazyQuery>;
export type HasOutstandingInvoiceQueryResult = Apollo.QueryResult<HasOutstandingInvoiceQuery, HasOutstandingInvoiceQueryVariables>;
export const GetCandidateCoursesDocument = gql`
    query getCandidateCourses($candidateId: String!) {
  getCandidateCourses(candidateId: $candidateId) {
    ...CandidateCourse
  }
}
    ${CandidateCourseFragmentDoc}`;

/**
 * __useGetCandidateCoursesQuery__
 *
 * To run a query within a React component, call `useGetCandidateCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateCoursesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCandidateCoursesQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateCoursesQuery, GetCandidateCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateCoursesQuery, GetCandidateCoursesQueryVariables>(GetCandidateCoursesDocument, options);
      }
export function useGetCandidateCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateCoursesQuery, GetCandidateCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateCoursesQuery, GetCandidateCoursesQueryVariables>(GetCandidateCoursesDocument, options);
        }
export type GetCandidateCoursesQueryHookResult = ReturnType<typeof useGetCandidateCoursesQuery>;
export type GetCandidateCoursesLazyQueryHookResult = ReturnType<typeof useGetCandidateCoursesLazyQuery>;
export type GetCandidateCoursesQueryResult = Apollo.QueryResult<GetCandidateCoursesQuery, GetCandidateCoursesQueryVariables>;
export const GetCandidateCoursesWithProductDocument = gql`
    query getCandidateCoursesWithProduct($candidateId: String!) {
  getCandidateCourses(candidateId: $candidateId) {
    ...CandidateCourseWithProduct
  }
}
    ${CandidateCourseWithProductFragmentDoc}`;

/**
 * __useGetCandidateCoursesWithProductQuery__
 *
 * To run a query within a React component, call `useGetCandidateCoursesWithProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateCoursesWithProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateCoursesWithProductQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCandidateCoursesWithProductQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateCoursesWithProductQuery, GetCandidateCoursesWithProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateCoursesWithProductQuery, GetCandidateCoursesWithProductQueryVariables>(GetCandidateCoursesWithProductDocument, options);
      }
export function useGetCandidateCoursesWithProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateCoursesWithProductQuery, GetCandidateCoursesWithProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateCoursesWithProductQuery, GetCandidateCoursesWithProductQueryVariables>(GetCandidateCoursesWithProductDocument, options);
        }
export type GetCandidateCoursesWithProductQueryHookResult = ReturnType<typeof useGetCandidateCoursesWithProductQuery>;
export type GetCandidateCoursesWithProductLazyQueryHookResult = ReturnType<typeof useGetCandidateCoursesWithProductLazyQuery>;
export type GetCandidateCoursesWithProductQueryResult = Apollo.QueryResult<GetCandidateCoursesWithProductQuery, GetCandidateCoursesWithProductQueryVariables>;
export const GetMyCoursesDocument = gql`
    query getMyCourses {
  getMyCourses {
    ...CandidateCourse
  }
}
    ${CandidateCourseFragmentDoc}`;

/**
 * __useGetMyCoursesQuery__
 *
 * To run a query within a React component, call `useGetMyCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCoursesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCoursesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
      }
export function useGetMyCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCoursesQuery, GetMyCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCoursesQuery, GetMyCoursesQueryVariables>(GetMyCoursesDocument, options);
        }
export type GetMyCoursesQueryHookResult = ReturnType<typeof useGetMyCoursesQuery>;
export type GetMyCoursesLazyQueryHookResult = ReturnType<typeof useGetMyCoursesLazyQuery>;
export type GetMyCoursesQueryResult = Apollo.QueryResult<GetMyCoursesQuery, GetMyCoursesQueryVariables>;
export const GetCandidateDocumentsDocument = gql`
    query getCandidateDocuments($candidateId: String!, $input: CandidateDocumentListFilterInput!) {
  getCandidateDocuments(candidateId: $candidateId, input: $input) {
    items {
      ...CandidateDocument
    }
    total
  }
}
    ${CandidateDocumentFragmentDoc}`;

/**
 * __useGetCandidateDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCandidateDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateDocumentsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCandidateDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateDocumentsQuery, GetCandidateDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateDocumentsQuery, GetCandidateDocumentsQueryVariables>(GetCandidateDocumentsDocument, options);
      }
export function useGetCandidateDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateDocumentsQuery, GetCandidateDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateDocumentsQuery, GetCandidateDocumentsQueryVariables>(GetCandidateDocumentsDocument, options);
        }
export type GetCandidateDocumentsQueryHookResult = ReturnType<typeof useGetCandidateDocumentsQuery>;
export type GetCandidateDocumentsLazyQueryHookResult = ReturnType<typeof useGetCandidateDocumentsLazyQuery>;
export type GetCandidateDocumentsQueryResult = Apollo.QueryResult<GetCandidateDocumentsQuery, GetCandidateDocumentsQueryVariables>;
export const GetMyDocumentsDocument = gql`
    query getMyDocuments {
  getMyDocuments {
    items {
      ...CandidateDocument
    }
    total
  }
}
    ${CandidateDocumentFragmentDoc}`;

/**
 * __useGetMyDocumentsQuery__
 *
 * To run a query within a React component, call `useGetMyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>(GetMyDocumentsDocument, options);
      }
export function useGetMyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>(GetMyDocumentsDocument, options);
        }
export type GetMyDocumentsQueryHookResult = ReturnType<typeof useGetMyDocumentsQuery>;
export type GetMyDocumentsLazyQueryHookResult = ReturnType<typeof useGetMyDocumentsLazyQuery>;
export type GetMyDocumentsQueryResult = Apollo.QueryResult<GetMyDocumentsQuery, GetMyDocumentsQueryVariables>;
export const DeleteCandidateDocumentDocument = gql`
    mutation deleteCandidateDocument($id: String!) {
  deleteCandidateDocument(id: $id)
}
    `;
export type DeleteCandidateDocumentMutationFn = Apollo.MutationFunction<DeleteCandidateDocumentMutation, DeleteCandidateDocumentMutationVariables>;

/**
 * __useDeleteCandidateDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateDocumentMutation, { data, loading, error }] = useDeleteCandidateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCandidateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateDocumentMutation, DeleteCandidateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateDocumentMutation, DeleteCandidateDocumentMutationVariables>(DeleteCandidateDocumentDocument, options);
      }
export type DeleteCandidateDocumentMutationHookResult = ReturnType<typeof useDeleteCandidateDocumentMutation>;
export type DeleteCandidateDocumentMutationResult = Apollo.MutationResult<DeleteCandidateDocumentMutation>;
export type DeleteCandidateDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateDocumentMutation, DeleteCandidateDocumentMutationVariables>;
export const UpdateCandidateDocumentMetadataDocument = gql`
    mutation updateCandidateDocumentMetadata($input: UpdateCandidateDocumentMetadataInput!) {
  updateCandidateDocumentMetadata(input: $input) {
    ...CandidateDocument
  }
}
    ${CandidateDocumentFragmentDoc}`;
export type UpdateCandidateDocumentMetadataMutationFn = Apollo.MutationFunction<UpdateCandidateDocumentMetadataMutation, UpdateCandidateDocumentMetadataMutationVariables>;

/**
 * __useUpdateCandidateDocumentMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateDocumentMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateDocumentMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateDocumentMetadataMutation, { data, loading, error }] = useUpdateCandidateDocumentMetadataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateDocumentMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateDocumentMetadataMutation, UpdateCandidateDocumentMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateDocumentMetadataMutation, UpdateCandidateDocumentMetadataMutationVariables>(UpdateCandidateDocumentMetadataDocument, options);
      }
export type UpdateCandidateDocumentMetadataMutationHookResult = ReturnType<typeof useUpdateCandidateDocumentMetadataMutation>;
export type UpdateCandidateDocumentMetadataMutationResult = Apollo.MutationResult<UpdateCandidateDocumentMetadataMutation>;
export type UpdateCandidateDocumentMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateDocumentMetadataMutation, UpdateCandidateDocumentMetadataMutationVariables>;
export const GetMyResumesDocument = gql`
    query getMyResumes {
  getMyResumes {
    ...CandidateResume
  }
}
    ${CandidateResumeFragmentDoc}`;

/**
 * __useGetMyResumesQuery__
 *
 * To run a query within a React component, call `useGetMyResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyResumesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyResumesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyResumesQuery, GetMyResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyResumesQuery, GetMyResumesQueryVariables>(GetMyResumesDocument, options);
      }
export function useGetMyResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyResumesQuery, GetMyResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyResumesQuery, GetMyResumesQueryVariables>(GetMyResumesDocument, options);
        }
export type GetMyResumesQueryHookResult = ReturnType<typeof useGetMyResumesQuery>;
export type GetMyResumesLazyQueryHookResult = ReturnType<typeof useGetMyResumesLazyQuery>;
export type GetMyResumesQueryResult = Apollo.QueryResult<GetMyResumesQuery, GetMyResumesQueryVariables>;
export const GetCandidateResumesDocument = gql`
    query getCandidateResumes($id: String!) {
  getCandidateResumes(id: $id) {
    ...CandidateResume
  }
}
    ${CandidateResumeFragmentDoc}`;

/**
 * __useGetCandidateResumesQuery__
 *
 * To run a query within a React component, call `useGetCandidateResumesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateResumesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateResumesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCandidateResumesQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateResumesQuery, GetCandidateResumesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateResumesQuery, GetCandidateResumesQueryVariables>(GetCandidateResumesDocument, options);
      }
export function useGetCandidateResumesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateResumesQuery, GetCandidateResumesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateResumesQuery, GetCandidateResumesQueryVariables>(GetCandidateResumesDocument, options);
        }
export type GetCandidateResumesQueryHookResult = ReturnType<typeof useGetCandidateResumesQuery>;
export type GetCandidateResumesLazyQueryHookResult = ReturnType<typeof useGetCandidateResumesLazyQuery>;
export type GetCandidateResumesQueryResult = Apollo.QueryResult<GetCandidateResumesQuery, GetCandidateResumesQueryVariables>;
export const DeleteResumeDocument = gql`
    mutation deleteResume($resumeId: String!) {
  deleteResume(resumeId: $resumeId)
}
    `;
export type DeleteResumeMutationFn = Apollo.MutationFunction<DeleteResumeMutation, DeleteResumeMutationVariables>;

/**
 * __useDeleteResumeMutation__
 *
 * To run a mutation, you first call `useDeleteResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteResumeMutation, { data, loading, error }] = useDeleteResumeMutation({
 *   variables: {
 *      resumeId: // value for 'resumeId'
 *   },
 * });
 */
export function useDeleteResumeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteResumeMutation, DeleteResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteResumeMutation, DeleteResumeMutationVariables>(DeleteResumeDocument, options);
      }
export type DeleteResumeMutationHookResult = ReturnType<typeof useDeleteResumeMutation>;
export type DeleteResumeMutationResult = Apollo.MutationResult<DeleteResumeMutation>;
export type DeleteResumeMutationOptions = Apollo.BaseMutationOptions<DeleteResumeMutation, DeleteResumeMutationVariables>;
export const BookmarkCandidateDocument = gql`
    mutation bookmarkCandidate($id: String!, $bookmarked: Boolean!) {
  bookmarkCandidate(id: $id, bookmarked: $bookmarked)
}
    `;
export type BookmarkCandidateMutationFn = Apollo.MutationFunction<BookmarkCandidateMutation, BookmarkCandidateMutationVariables>;

/**
 * __useBookmarkCandidateMutation__
 *
 * To run a mutation, you first call `useBookmarkCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookmarkCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookmarkCandidateMutation, { data, loading, error }] = useBookmarkCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      bookmarked: // value for 'bookmarked'
 *   },
 * });
 */
export function useBookmarkCandidateMutation(baseOptions?: Apollo.MutationHookOptions<BookmarkCandidateMutation, BookmarkCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookmarkCandidateMutation, BookmarkCandidateMutationVariables>(BookmarkCandidateDocument, options);
      }
export type BookmarkCandidateMutationHookResult = ReturnType<typeof useBookmarkCandidateMutation>;
export type BookmarkCandidateMutationResult = Apollo.MutationResult<BookmarkCandidateMutation>;
export type BookmarkCandidateMutationOptions = Apollo.BaseMutationOptions<BookmarkCandidateMutation, BookmarkCandidateMutationVariables>;
export const UniversitySuggestionsDocument = gql`
    query universitySuggestions($input: SuggestionsInput!) {
  universitySuggestions(input: $input) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useUniversitySuggestionsQuery__
 *
 * To run a query within a React component, call `useUniversitySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUniversitySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUniversitySuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUniversitySuggestionsQuery(baseOptions: Apollo.QueryHookOptions<UniversitySuggestionsQuery, UniversitySuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UniversitySuggestionsQuery, UniversitySuggestionsQueryVariables>(UniversitySuggestionsDocument, options);
      }
export function useUniversitySuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UniversitySuggestionsQuery, UniversitySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UniversitySuggestionsQuery, UniversitySuggestionsQueryVariables>(UniversitySuggestionsDocument, options);
        }
export type UniversitySuggestionsQueryHookResult = ReturnType<typeof useUniversitySuggestionsQuery>;
export type UniversitySuggestionsLazyQueryHookResult = ReturnType<typeof useUniversitySuggestionsLazyQuery>;
export type UniversitySuggestionsQueryResult = Apollo.QueryResult<UniversitySuggestionsQuery, UniversitySuggestionsQueryVariables>;
export const CandidateDocumentLabelSuggestionsDocument = gql`
    query candidateDocumentLabelSuggestions($input: SuggestionsInput!) {
  candidateDocumentLabelSuggestions(input: $input) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useCandidateDocumentLabelSuggestionsQuery__
 *
 * To run a query within a React component, call `useCandidateDocumentLabelSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateDocumentLabelSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateDocumentLabelSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateDocumentLabelSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<CandidateDocumentLabelSuggestionsQuery, CandidateDocumentLabelSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateDocumentLabelSuggestionsQuery, CandidateDocumentLabelSuggestionsQueryVariables>(CandidateDocumentLabelSuggestionsDocument, options);
      }
export function useCandidateDocumentLabelSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateDocumentLabelSuggestionsQuery, CandidateDocumentLabelSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateDocumentLabelSuggestionsQuery, CandidateDocumentLabelSuggestionsQueryVariables>(CandidateDocumentLabelSuggestionsDocument, options);
        }
export type CandidateDocumentLabelSuggestionsQueryHookResult = ReturnType<typeof useCandidateDocumentLabelSuggestionsQuery>;
export type CandidateDocumentLabelSuggestionsLazyQueryHookResult = ReturnType<typeof useCandidateDocumentLabelSuggestionsLazyQuery>;
export type CandidateDocumentLabelSuggestionsQueryResult = Apollo.QueryResult<CandidateDocumentLabelSuggestionsQuery, CandidateDocumentLabelSuggestionsQueryVariables>;
export const AssignAdvisorToCandidateDocument = gql`
    mutation assignAdvisorToCandidate($candidateId: String!, $advisorId: String!) {
  assignAdvisorToCandidate(
    input: {candidateId: $candidateId, advisorId: $advisorId}
  )
}
    `;
export type AssignAdvisorToCandidateMutationFn = Apollo.MutationFunction<AssignAdvisorToCandidateMutation, AssignAdvisorToCandidateMutationVariables>;

/**
 * __useAssignAdvisorToCandidateMutation__
 *
 * To run a mutation, you first call `useAssignAdvisorToCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAdvisorToCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAdvisorToCandidateMutation, { data, loading, error }] = useAssignAdvisorToCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      advisorId: // value for 'advisorId'
 *   },
 * });
 */
export function useAssignAdvisorToCandidateMutation(baseOptions?: Apollo.MutationHookOptions<AssignAdvisorToCandidateMutation, AssignAdvisorToCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAdvisorToCandidateMutation, AssignAdvisorToCandidateMutationVariables>(AssignAdvisorToCandidateDocument, options);
      }
export type AssignAdvisorToCandidateMutationHookResult = ReturnType<typeof useAssignAdvisorToCandidateMutation>;
export type AssignAdvisorToCandidateMutationResult = Apollo.MutationResult<AssignAdvisorToCandidateMutation>;
export type AssignAdvisorToCandidateMutationOptions = Apollo.BaseMutationOptions<AssignAdvisorToCandidateMutation, AssignAdvisorToCandidateMutationVariables>;
export const RemoveAdvisorFromCandidateDocument = gql`
    mutation removeAdvisorFromCandidate($candidateId: String!, $advisorId: String!) {
  removeAdvisorFromCandidate(
    input: {candidateId: $candidateId, advisorId: $advisorId}
  )
}
    `;
export type RemoveAdvisorFromCandidateMutationFn = Apollo.MutationFunction<RemoveAdvisorFromCandidateMutation, RemoveAdvisorFromCandidateMutationVariables>;

/**
 * __useRemoveAdvisorFromCandidateMutation__
 *
 * To run a mutation, you first call `useRemoveAdvisorFromCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdvisorFromCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdvisorFromCandidateMutation, { data, loading, error }] = useRemoveAdvisorFromCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      advisorId: // value for 'advisorId'
 *   },
 * });
 */
export function useRemoveAdvisorFromCandidateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdvisorFromCandidateMutation, RemoveAdvisorFromCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdvisorFromCandidateMutation, RemoveAdvisorFromCandidateMutationVariables>(RemoveAdvisorFromCandidateDocument, options);
      }
export type RemoveAdvisorFromCandidateMutationHookResult = ReturnType<typeof useRemoveAdvisorFromCandidateMutation>;
export type RemoveAdvisorFromCandidateMutationResult = Apollo.MutationResult<RemoveAdvisorFromCandidateMutation>;
export type RemoveAdvisorFromCandidateMutationOptions = Apollo.BaseMutationOptions<RemoveAdvisorFromCandidateMutation, RemoveAdvisorFromCandidateMutationVariables>;
export const AssignAdvisorToCandidatesDocument = gql`
    mutation assignAdvisorToCandidates($input: AssignAdvisorToCandidatesInput!) {
  assignAdvisorToCandidates(input: $input)
}
    `;
export type AssignAdvisorToCandidatesMutationFn = Apollo.MutationFunction<AssignAdvisorToCandidatesMutation, AssignAdvisorToCandidatesMutationVariables>;

/**
 * __useAssignAdvisorToCandidatesMutation__
 *
 * To run a mutation, you first call `useAssignAdvisorToCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAdvisorToCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAdvisorToCandidatesMutation, { data, loading, error }] = useAssignAdvisorToCandidatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignAdvisorToCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<AssignAdvisorToCandidatesMutation, AssignAdvisorToCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAdvisorToCandidatesMutation, AssignAdvisorToCandidatesMutationVariables>(AssignAdvisorToCandidatesDocument, options);
      }
export type AssignAdvisorToCandidatesMutationHookResult = ReturnType<typeof useAssignAdvisorToCandidatesMutation>;
export type AssignAdvisorToCandidatesMutationResult = Apollo.MutationResult<AssignAdvisorToCandidatesMutation>;
export type AssignAdvisorToCandidatesMutationOptions = Apollo.BaseMutationOptions<AssignAdvisorToCandidatesMutation, AssignAdvisorToCandidatesMutationVariables>;
export const CreateNoteDocument = gql`
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    ...Note
  }
}
    ${NoteFragmentDoc}`;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($noteId: String!) {
  deleteNote(noteId: $noteId)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const GetCandidateNoteMentionsDocument = gql`
    query getCandidateNoteMentions($candidateId: String!) {
  getCandidateNoteMentions(candidateId: $candidateId) {
    ...NoteMention
  }
}
    ${NoteMentionFragmentDoc}`;

/**
 * __useGetCandidateNoteMentionsQuery__
 *
 * To run a query within a React component, call `useGetCandidateNoteMentionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateNoteMentionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateNoteMentionsQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useGetCandidateNoteMentionsQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateNoteMentionsQuery, GetCandidateNoteMentionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateNoteMentionsQuery, GetCandidateNoteMentionsQueryVariables>(GetCandidateNoteMentionsDocument, options);
      }
export function useGetCandidateNoteMentionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateNoteMentionsQuery, GetCandidateNoteMentionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateNoteMentionsQuery, GetCandidateNoteMentionsQueryVariables>(GetCandidateNoteMentionsDocument, options);
        }
export type GetCandidateNoteMentionsQueryHookResult = ReturnType<typeof useGetCandidateNoteMentionsQuery>;
export type GetCandidateNoteMentionsLazyQueryHookResult = ReturnType<typeof useGetCandidateNoteMentionsLazyQuery>;
export type GetCandidateNoteMentionsQueryResult = Apollo.QueryResult<GetCandidateNoteMentionsQuery, GetCandidateNoteMentionsQueryVariables>;
export const CreateInvoiceForCoursesDocument = gql`
    mutation createInvoiceForCourses($input: CreateInvoiceForCoursesInput!) {
  createInvoiceForCourses(input: $input) {
    _id
    status
  }
}
    `;
export type CreateInvoiceForCoursesMutationFn = Apollo.MutationFunction<CreateInvoiceForCoursesMutation, CreateInvoiceForCoursesMutationVariables>;

/**
 * __useCreateInvoiceForCoursesMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceForCoursesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceForCoursesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceForCoursesMutation, { data, loading, error }] = useCreateInvoiceForCoursesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvoiceForCoursesMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceForCoursesMutation, CreateInvoiceForCoursesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceForCoursesMutation, CreateInvoiceForCoursesMutationVariables>(CreateInvoiceForCoursesDocument, options);
      }
export type CreateInvoiceForCoursesMutationHookResult = ReturnType<typeof useCreateInvoiceForCoursesMutation>;
export type CreateInvoiceForCoursesMutationResult = Apollo.MutationResult<CreateInvoiceForCoursesMutation>;
export type CreateInvoiceForCoursesMutationOptions = Apollo.BaseMutationOptions<CreateInvoiceForCoursesMutation, CreateInvoiceForCoursesMutationVariables>;
export const VoidInvoiceDocument = gql`
    mutation voidInvoice($invoiceId: String!) {
  voidInvoice(invoiceId: $invoiceId)
}
    `;
export type VoidInvoiceMutationFn = Apollo.MutationFunction<VoidInvoiceMutation, VoidInvoiceMutationVariables>;

/**
 * __useVoidInvoiceMutation__
 *
 * To run a mutation, you first call `useVoidInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidInvoiceMutation, { data, loading, error }] = useVoidInvoiceMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useVoidInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<VoidInvoiceMutation, VoidInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidInvoiceMutation, VoidInvoiceMutationVariables>(VoidInvoiceDocument, options);
      }
export type VoidInvoiceMutationHookResult = ReturnType<typeof useVoidInvoiceMutation>;
export type VoidInvoiceMutationResult = Apollo.MutationResult<VoidInvoiceMutation>;
export type VoidInvoiceMutationOptions = Apollo.BaseMutationOptions<VoidInvoiceMutation, VoidInvoiceMutationVariables>;
export const MarkInvoiceAsPaidDocument = gql`
    mutation markInvoiceAsPaid($invoiceId: String!) {
  markInvoiceAsPaid(invoiceId: $invoiceId)
}
    `;
export type MarkInvoiceAsPaidMutationFn = Apollo.MutationFunction<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>;

/**
 * __useMarkInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidMutation, { data, loading, error }] = useMarkInvoiceAsPaidMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>(MarkInvoiceAsPaidDocument, options);
      }
export type MarkInvoiceAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationResult = Apollo.MutationResult<MarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationOptions = Apollo.BaseMutationOptions<MarkInvoiceAsPaidMutation, MarkInvoiceAsPaidMutationVariables>;
export const DeleteCandidateDocument = gql`
    mutation deleteCandidate($candidateId: String!) {
  deleteCandidate(candidateId: $candidateId)
}
    `;
export type DeleteCandidateMutationFn = Apollo.MutationFunction<DeleteCandidateMutation, DeleteCandidateMutationVariables>;

/**
 * __useDeleteCandidateMutation__
 *
 * To run a mutation, you first call `useDeleteCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCandidateMutation, { data, loading, error }] = useDeleteCandidateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useDeleteCandidateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCandidateMutation, DeleteCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCandidateMutation, DeleteCandidateMutationVariables>(DeleteCandidateDocument, options);
      }
export type DeleteCandidateMutationHookResult = ReturnType<typeof useDeleteCandidateMutation>;
export type DeleteCandidateMutationResult = Apollo.MutationResult<DeleteCandidateMutation>;
export type DeleteCandidateMutationOptions = Apollo.BaseMutationOptions<DeleteCandidateMutation, DeleteCandidateMutationVariables>;
export const CandidateCohortSuggestionsDocument = gql`
    query candidateCohortSuggestions($input: SuggestionsInput!) {
  candidateCohortSuggestions(input: $input) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useCandidateCohortSuggestionsQuery__
 *
 * To run a query within a React component, call `useCandidateCohortSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateCohortSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateCohortSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCandidateCohortSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<CandidateCohortSuggestionsQuery, CandidateCohortSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateCohortSuggestionsQuery, CandidateCohortSuggestionsQueryVariables>(CandidateCohortSuggestionsDocument, options);
      }
export function useCandidateCohortSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateCohortSuggestionsQuery, CandidateCohortSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateCohortSuggestionsQuery, CandidateCohortSuggestionsQueryVariables>(CandidateCohortSuggestionsDocument, options);
        }
export type CandidateCohortSuggestionsQueryHookResult = ReturnType<typeof useCandidateCohortSuggestionsQuery>;
export type CandidateCohortSuggestionsLazyQueryHookResult = ReturnType<typeof useCandidateCohortSuggestionsLazyQuery>;
export type CandidateCohortSuggestionsQueryResult = Apollo.QueryResult<CandidateCohortSuggestionsQuery, CandidateCohortSuggestionsQueryVariables>;
export const CreateCandidateCohortDocument = gql`
    mutation createCandidateCohort($input: CreateCandidateCohortInput!) {
  createCandidateCohort(input: $input) {
    ...CandidateCohort
  }
}
    ${CandidateCohortFragmentDoc}`;
export type CreateCandidateCohortMutationFn = Apollo.MutationFunction<CreateCandidateCohortMutation, CreateCandidateCohortMutationVariables>;

/**
 * __useCreateCandidateCohortMutation__
 *
 * To run a mutation, you first call `useCreateCandidateCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCandidateCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCandidateCohortMutation, { data, loading, error }] = useCreateCandidateCohortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCandidateCohortMutation(baseOptions?: Apollo.MutationHookOptions<CreateCandidateCohortMutation, CreateCandidateCohortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCandidateCohortMutation, CreateCandidateCohortMutationVariables>(CreateCandidateCohortDocument, options);
      }
export type CreateCandidateCohortMutationHookResult = ReturnType<typeof useCreateCandidateCohortMutation>;
export type CreateCandidateCohortMutationResult = Apollo.MutationResult<CreateCandidateCohortMutation>;
export type CreateCandidateCohortMutationOptions = Apollo.BaseMutationOptions<CreateCandidateCohortMutation, CreateCandidateCohortMutationVariables>;
export const AssignCandidateToCohortDocument = gql`
    mutation assignCandidateToCohort($input: AssignCandidateCohortInput!) {
  assignCandidateToCohort(input: $input)
}
    `;
export type AssignCandidateToCohortMutationFn = Apollo.MutationFunction<AssignCandidateToCohortMutation, AssignCandidateToCohortMutationVariables>;

/**
 * __useAssignCandidateToCohortMutation__
 *
 * To run a mutation, you first call `useAssignCandidateToCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCandidateToCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCandidateToCohortMutation, { data, loading, error }] = useAssignCandidateToCohortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignCandidateToCohortMutation(baseOptions?: Apollo.MutationHookOptions<AssignCandidateToCohortMutation, AssignCandidateToCohortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCandidateToCohortMutation, AssignCandidateToCohortMutationVariables>(AssignCandidateToCohortDocument, options);
      }
export type AssignCandidateToCohortMutationHookResult = ReturnType<typeof useAssignCandidateToCohortMutation>;
export type AssignCandidateToCohortMutationResult = Apollo.MutationResult<AssignCandidateToCohortMutation>;
export type AssignCandidateToCohortMutationOptions = Apollo.BaseMutationOptions<AssignCandidateToCohortMutation, AssignCandidateToCohortMutationVariables>;
export const ListCohortsDocument = gql`
    query listCohorts($input: CandidateCohortListInput!) {
  candidateCohorts(input: $input) {
    total
    items {
      ...CandidateCohort
    }
  }
}
    ${CandidateCohortFragmentDoc}`;

/**
 * __useListCohortsQuery__
 *
 * To run a query within a React component, call `useListCohortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCohortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCohortsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCohortsQuery(baseOptions: Apollo.QueryHookOptions<ListCohortsQuery, ListCohortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCohortsQuery, ListCohortsQueryVariables>(ListCohortsDocument, options);
      }
export function useListCohortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCohortsQuery, ListCohortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCohortsQuery, ListCohortsQueryVariables>(ListCohortsDocument, options);
        }
export type ListCohortsQueryHookResult = ReturnType<typeof useListCohortsQuery>;
export type ListCohortsLazyQueryHookResult = ReturnType<typeof useListCohortsLazyQuery>;
export type ListCohortsQueryResult = Apollo.QueryResult<ListCohortsQuery, ListCohortsQueryVariables>;
export const GetCohortDocument = gql`
    query getCohort($id: String!) {
  candidateCohort(id: $id) {
    ...CandidateCohort
  }
}
    ${CandidateCohortFragmentDoc}`;

/**
 * __useGetCohortQuery__
 *
 * To run a query within a React component, call `useGetCohortQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCohortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCohortQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCohortQuery(baseOptions: Apollo.QueryHookOptions<GetCohortQuery, GetCohortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCohortQuery, GetCohortQueryVariables>(GetCohortDocument, options);
      }
export function useGetCohortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCohortQuery, GetCohortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCohortQuery, GetCohortQueryVariables>(GetCohortDocument, options);
        }
export type GetCohortQueryHookResult = ReturnType<typeof useGetCohortQuery>;
export type GetCohortLazyQueryHookResult = ReturnType<typeof useGetCohortLazyQuery>;
export type GetCohortQueryResult = Apollo.QueryResult<GetCohortQuery, GetCohortQueryVariables>;
export const CreateCohortDocument = gql`
    mutation createCohort($input: CreateCandidateCohortInput!) {
  createCandidateCohort(input: $input) {
    ...CandidateCohort
  }
}
    ${CandidateCohortFragmentDoc}`;
export type CreateCohortMutationFn = Apollo.MutationFunction<CreateCohortMutation, CreateCohortMutationVariables>;

/**
 * __useCreateCohortMutation__
 *
 * To run a mutation, you first call `useCreateCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCohortMutation, { data, loading, error }] = useCreateCohortMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCohortMutation(baseOptions?: Apollo.MutationHookOptions<CreateCohortMutation, CreateCohortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCohortMutation, CreateCohortMutationVariables>(CreateCohortDocument, options);
      }
export type CreateCohortMutationHookResult = ReturnType<typeof useCreateCohortMutation>;
export type CreateCohortMutationResult = Apollo.MutationResult<CreateCohortMutation>;
export type CreateCohortMutationOptions = Apollo.BaseMutationOptions<CreateCohortMutation, CreateCohortMutationVariables>;
export const UpdateCohortDocument = gql`
    mutation updateCohort($id: String!, $input: UpdateCandidateCohortInput!) {
  updateCandidateCohort(id: $id, input: $input) {
    ...CandidateCohort
  }
}
    ${CandidateCohortFragmentDoc}`;
export type UpdateCohortMutationFn = Apollo.MutationFunction<UpdateCohortMutation, UpdateCohortMutationVariables>;

/**
 * __useUpdateCohortMutation__
 *
 * To run a mutation, you first call `useUpdateCohortMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCohortMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCohortMutation, { data, loading, error }] = useUpdateCohortMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCohortMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCohortMutation, UpdateCohortMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCohortMutation, UpdateCohortMutationVariables>(UpdateCohortDocument, options);
      }
export type UpdateCohortMutationHookResult = ReturnType<typeof useUpdateCohortMutation>;
export type UpdateCohortMutationResult = Apollo.MutationResult<UpdateCohortMutation>;
export type UpdateCohortMutationOptions = Apollo.BaseMutationOptions<UpdateCohortMutation, UpdateCohortMutationVariables>;
export const GetCandidateMessagesDocument = gql`
    query getCandidateMessages($candidateId: String!, $afterTimestamp: String) {
  getCandidateMessages(candidateId: $candidateId, afterTimestamp: $afterTimestamp) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;

/**
 * __useGetCandidateMessagesQuery__
 *
 * To run a query within a React component, call `useGetCandidateMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateMessagesQuery({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *      afterTimestamp: // value for 'afterTimestamp'
 *   },
 * });
 */
export function useGetCandidateMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetCandidateMessagesQuery, GetCandidateMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateMessagesQuery, GetCandidateMessagesQueryVariables>(GetCandidateMessagesDocument, options);
      }
export function useGetCandidateMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateMessagesQuery, GetCandidateMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateMessagesQuery, GetCandidateMessagesQueryVariables>(GetCandidateMessagesDocument, options);
        }
export type GetCandidateMessagesQueryHookResult = ReturnType<typeof useGetCandidateMessagesQuery>;
export type GetCandidateMessagesLazyQueryHookResult = ReturnType<typeof useGetCandidateMessagesLazyQuery>;
export type GetCandidateMessagesQueryResult = Apollo.QueryResult<GetCandidateMessagesQuery, GetCandidateMessagesQueryVariables>;
export const SendCandidateMessageDocument = gql`
    mutation sendCandidateMessage($input: SendMessageInput!) {
  sendCandidateMessage(input: $input) {
    ...Message
  }
}
    ${MessageFragmentDoc}`;
export type SendCandidateMessageMutationFn = Apollo.MutationFunction<SendCandidateMessageMutation, SendCandidateMessageMutationVariables>;

/**
 * __useSendCandidateMessageMutation__
 *
 * To run a mutation, you first call `useSendCandidateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCandidateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCandidateMessageMutation, { data, loading, error }] = useSendCandidateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCandidateMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendCandidateMessageMutation, SendCandidateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCandidateMessageMutation, SendCandidateMessageMutationVariables>(SendCandidateMessageDocument, options);
      }
export type SendCandidateMessageMutationHookResult = ReturnType<typeof useSendCandidateMessageMutation>;
export type SendCandidateMessageMutationResult = Apollo.MutationResult<SendCandidateMessageMutation>;
export type SendCandidateMessageMutationOptions = Apollo.BaseMutationOptions<SendCandidateMessageMutation, SendCandidateMessageMutationVariables>;
export const SendCandidateEmailDocument = gql`
    mutation sendCandidateEmail($input: SendEmailInput!) {
  sendCandidateEmail(input: $input)
}
    `;
export type SendCandidateEmailMutationFn = Apollo.MutationFunction<SendCandidateEmailMutation, SendCandidateEmailMutationVariables>;

/**
 * __useSendCandidateEmailMutation__
 *
 * To run a mutation, you first call `useSendCandidateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCandidateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCandidateEmailMutation, { data, loading, error }] = useSendCandidateEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCandidateEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCandidateEmailMutation, SendCandidateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCandidateEmailMutation, SendCandidateEmailMutationVariables>(SendCandidateEmailDocument, options);
      }
export type SendCandidateEmailMutationHookResult = ReturnType<typeof useSendCandidateEmailMutation>;
export type SendCandidateEmailMutationResult = Apollo.MutationResult<SendCandidateEmailMutation>;
export type SendCandidateEmailMutationOptions = Apollo.BaseMutationOptions<SendCandidateEmailMutation, SendCandidateEmailMutationVariables>;
export const ConvertToUserDocumentDocument = gql`
    mutation convertToUserDocument($messageId: String!, $fileId: String!) {
  convertToUserDocument(messageId: $messageId, fileId: $fileId)
}
    `;
export type ConvertToUserDocumentMutationFn = Apollo.MutationFunction<ConvertToUserDocumentMutation, ConvertToUserDocumentMutationVariables>;

/**
 * __useConvertToUserDocumentMutation__
 *
 * To run a mutation, you first call `useConvertToUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertToUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertToUserDocumentMutation, { data, loading, error }] = useConvertToUserDocumentMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useConvertToUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ConvertToUserDocumentMutation, ConvertToUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConvertToUserDocumentMutation, ConvertToUserDocumentMutationVariables>(ConvertToUserDocumentDocument, options);
      }
export type ConvertToUserDocumentMutationHookResult = ReturnType<typeof useConvertToUserDocumentMutation>;
export type ConvertToUserDocumentMutationResult = Apollo.MutationResult<ConvertToUserDocumentMutation>;
export type ConvertToUserDocumentMutationOptions = Apollo.BaseMutationOptions<ConvertToUserDocumentMutation, ConvertToUserDocumentMutationVariables>;
export const ListCoursesDocument = gql`
    query listCourses($input: CourseListInput!) {
  courses(input: $input) {
    total
    items {
      ...CourseWithProduct
    }
  }
}
    ${CourseWithProductFragmentDoc}`;

/**
 * __useListCoursesQuery__
 *
 * To run a query within a React component, call `useListCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCoursesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListCoursesQuery(baseOptions: Apollo.QueryHookOptions<ListCoursesQuery, ListCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCoursesQuery, ListCoursesQueryVariables>(ListCoursesDocument, options);
      }
export function useListCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCoursesQuery, ListCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCoursesQuery, ListCoursesQueryVariables>(ListCoursesDocument, options);
        }
export type ListCoursesQueryHookResult = ReturnType<typeof useListCoursesQuery>;
export type ListCoursesLazyQueryHookResult = ReturnType<typeof useListCoursesLazyQuery>;
export type ListCoursesQueryResult = Apollo.QueryResult<ListCoursesQuery, ListCoursesQueryVariables>;
export const GetCourseDocument = gql`
    query getCourse($id: String!) {
  course(id: $id) {
    ...Course
  }
}
    ${CourseFragmentDoc}`;

/**
 * __useGetCourseQuery__
 *
 * To run a query within a React component, call `useGetCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCourseQuery(baseOptions: Apollo.QueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
      }
export function useGetCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseQuery, GetCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseQuery, GetCourseQueryVariables>(GetCourseDocument, options);
        }
export type GetCourseQueryHookResult = ReturnType<typeof useGetCourseQuery>;
export type GetCourseLazyQueryHookResult = ReturnType<typeof useGetCourseLazyQuery>;
export type GetCourseQueryResult = Apollo.QueryResult<GetCourseQuery, GetCourseQueryVariables>;
export const CreateCourseDocument = gql`
    mutation createCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    ...Course
  }
}
    ${CourseFragmentDoc}`;
export type CreateCourseMutationFn = Apollo.MutationFunction<CreateCourseMutation, CreateCourseMutationVariables>;

/**
 * __useCreateCourseMutation__
 *
 * To run a mutation, you first call `useCreateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCourseMutation, { data, loading, error }] = useCreateCourseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCourseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCourseMutation, CreateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCourseMutation, CreateCourseMutationVariables>(CreateCourseDocument, options);
      }
export type CreateCourseMutationHookResult = ReturnType<typeof useCreateCourseMutation>;
export type CreateCourseMutationResult = Apollo.MutationResult<CreateCourseMutation>;
export type CreateCourseMutationOptions = Apollo.BaseMutationOptions<CreateCourseMutation, CreateCourseMutationVariables>;
export const UpdateCourseDocument = gql`
    mutation updateCourse($id: String!, $input: UpdateCourseInput!) {
  updateCourse(id: $id, input: $input) {
    ...Course
  }
}
    ${CourseFragmentDoc}`;
export type UpdateCourseMutationFn = Apollo.MutationFunction<UpdateCourseMutation, UpdateCourseMutationVariables>;

/**
 * __useUpdateCourseMutation__
 *
 * To run a mutation, you first call `useUpdateCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCourseMutation, { data, loading, error }] = useUpdateCourseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCourseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCourseMutation, UpdateCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCourseMutation, UpdateCourseMutationVariables>(UpdateCourseDocument, options);
      }
export type UpdateCourseMutationHookResult = ReturnType<typeof useUpdateCourseMutation>;
export type UpdateCourseMutationResult = Apollo.MutationResult<UpdateCourseMutation>;
export type UpdateCourseMutationOptions = Apollo.BaseMutationOptions<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const CourseSuggestionsDocument = gql`
    query courseSuggestions($input: SuggestionsInput!, $filter: CourseListFilterInput) {
  courseSuggestions(input: $input, filter: $filter) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useCourseSuggestionsQuery__
 *
 * To run a query within a React component, call `useCourseSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCourseSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<CourseSuggestionsQuery, CourseSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseSuggestionsQuery, CourseSuggestionsQueryVariables>(CourseSuggestionsDocument, options);
      }
export function useCourseSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseSuggestionsQuery, CourseSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseSuggestionsQuery, CourseSuggestionsQueryVariables>(CourseSuggestionsDocument, options);
        }
export type CourseSuggestionsQueryHookResult = ReturnType<typeof useCourseSuggestionsQuery>;
export type CourseSuggestionsLazyQueryHookResult = ReturnType<typeof useCourseSuggestionsLazyQuery>;
export type CourseSuggestionsQueryResult = Apollo.QueryResult<CourseSuggestionsQuery, CourseSuggestionsQueryVariables>;
export const AssignCandidateToCourseDocument = gql`
    mutation assignCandidateToCourse($courseId: String!, $candidateId: String!) {
  assignCandidateToCourse(courseId: $courseId, candidateId: $candidateId)
}
    `;
export type AssignCandidateToCourseMutationFn = Apollo.MutationFunction<AssignCandidateToCourseMutation, AssignCandidateToCourseMutationVariables>;

/**
 * __useAssignCandidateToCourseMutation__
 *
 * To run a mutation, you first call `useAssignCandidateToCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignCandidateToCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignCandidateToCourseMutation, { data, loading, error }] = useAssignCandidateToCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useAssignCandidateToCourseMutation(baseOptions?: Apollo.MutationHookOptions<AssignCandidateToCourseMutation, AssignCandidateToCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignCandidateToCourseMutation, AssignCandidateToCourseMutationVariables>(AssignCandidateToCourseDocument, options);
      }
export type AssignCandidateToCourseMutationHookResult = ReturnType<typeof useAssignCandidateToCourseMutation>;
export type AssignCandidateToCourseMutationResult = Apollo.MutationResult<AssignCandidateToCourseMutation>;
export type AssignCandidateToCourseMutationOptions = Apollo.BaseMutationOptions<AssignCandidateToCourseMutation, AssignCandidateToCourseMutationVariables>;
export const RemoveCandidateFromCourseDocument = gql`
    mutation removeCandidateFromCourse($courseId: String!, $candidateId: String!) {
  removeCandidateFromCourse(courseId: $courseId, candidateId: $candidateId)
}
    `;
export type RemoveCandidateFromCourseMutationFn = Apollo.MutationFunction<RemoveCandidateFromCourseMutation, RemoveCandidateFromCourseMutationVariables>;

/**
 * __useRemoveCandidateFromCourseMutation__
 *
 * To run a mutation, you first call `useRemoveCandidateFromCourseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCandidateFromCourseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCandidateFromCourseMutation, { data, loading, error }] = useRemoveCandidateFromCourseMutation({
 *   variables: {
 *      courseId: // value for 'courseId'
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useRemoveCandidateFromCourseMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCandidateFromCourseMutation, RemoveCandidateFromCourseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCandidateFromCourseMutation, RemoveCandidateFromCourseMutationVariables>(RemoveCandidateFromCourseDocument, options);
      }
export type RemoveCandidateFromCourseMutationHookResult = ReturnType<typeof useRemoveCandidateFromCourseMutation>;
export type RemoveCandidateFromCourseMutationResult = Apollo.MutationResult<RemoveCandidateFromCourseMutation>;
export type RemoveCandidateFromCourseMutationOptions = Apollo.BaseMutationOptions<RemoveCandidateFromCourseMutation, RemoveCandidateFromCourseMutationVariables>;
export const UpdateCandidateCourseProgressDocument = gql`
    mutation updateCandidateCourseProgress($input: UpdateCandidateCourseProgressInput!) {
  updateCandidateCourseProgress(input: $input)
}
    `;
export type UpdateCandidateCourseProgressMutationFn = Apollo.MutationFunction<UpdateCandidateCourseProgressMutation, UpdateCandidateCourseProgressMutationVariables>;

/**
 * __useUpdateCandidateCourseProgressMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateCourseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateCourseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateCourseProgressMutation, { data, loading, error }] = useUpdateCandidateCourseProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCandidateCourseProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateCourseProgressMutation, UpdateCandidateCourseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateCourseProgressMutation, UpdateCandidateCourseProgressMutationVariables>(UpdateCandidateCourseProgressDocument, options);
      }
export type UpdateCandidateCourseProgressMutationHookResult = ReturnType<typeof useUpdateCandidateCourseProgressMutation>;
export type UpdateCandidateCourseProgressMutationResult = Apollo.MutationResult<UpdateCandidateCourseProgressMutation>;
export type UpdateCandidateCourseProgressMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateCourseProgressMutation, UpdateCandidateCourseProgressMutationVariables>;
export const ListEmployeesDocument = gql`
    query listEmployees($input: EmployeeListInput!) {
  employees(input: $input) {
    total
    items {
      ...Employee
    }
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useListEmployeesQuery__
 *
 * To run a query within a React component, call `useListEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListEmployeesQuery(baseOptions: Apollo.QueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
      }
export function useListEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEmployeesQuery, ListEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEmployeesQuery, ListEmployeesQueryVariables>(ListEmployeesDocument, options);
        }
export type ListEmployeesQueryHookResult = ReturnType<typeof useListEmployeesQuery>;
export type ListEmployeesLazyQueryHookResult = ReturnType<typeof useListEmployeesLazyQuery>;
export type ListEmployeesQueryResult = Apollo.QueryResult<ListEmployeesQuery, ListEmployeesQueryVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($id: String!) {
  employee(id: $id) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($id: String!, $input: UpdateEmployeeInput!) {
  updateEmployee(id: $id, input: $input) {
    ...Employee
  }
}
    ${EmployeeFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const DisableEmployeeDocument = gql`
    mutation disableEmployee($id: String!, $disabled: Boolean!) {
  disableEmployee(id: $id, disabled: $disabled)
}
    `;
export type DisableEmployeeMutationFn = Apollo.MutationFunction<DisableEmployeeMutation, DisableEmployeeMutationVariables>;

/**
 * __useDisableEmployeeMutation__
 *
 * To run a mutation, you first call `useDisableEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableEmployeeMutation, { data, loading, error }] = useDisableEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      disabled: // value for 'disabled'
 *   },
 * });
 */
export function useDisableEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DisableEmployeeMutation, DisableEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableEmployeeMutation, DisableEmployeeMutationVariables>(DisableEmployeeDocument, options);
      }
export type DisableEmployeeMutationHookResult = ReturnType<typeof useDisableEmployeeMutation>;
export type DisableEmployeeMutationResult = Apollo.MutationResult<DisableEmployeeMutation>;
export type DisableEmployeeMutationOptions = Apollo.BaseMutationOptions<DisableEmployeeMutation, DisableEmployeeMutationVariables>;
export const ResetEmployeePasswordDocument = gql`
    mutation resetEmployeePassword($id: String!) {
  resetEmployeePassword(id: $id)
}
    `;
export type ResetEmployeePasswordMutationFn = Apollo.MutationFunction<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>;

/**
 * __useResetEmployeePasswordMutation__
 *
 * To run a mutation, you first call `useResetEmployeePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetEmployeePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetEmployeePasswordMutation, { data, loading, error }] = useResetEmployeePasswordMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResetEmployeePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>(ResetEmployeePasswordDocument, options);
      }
export type ResetEmployeePasswordMutationHookResult = ReturnType<typeof useResetEmployeePasswordMutation>;
export type ResetEmployeePasswordMutationResult = Apollo.MutationResult<ResetEmployeePasswordMutation>;
export type ResetEmployeePasswordMutationOptions = Apollo.BaseMutationOptions<ResetEmployeePasswordMutation, ResetEmployeePasswordMutationVariables>;
export const AdvisorSuggestionsDocument = gql`
    query advisorSuggestions($input: SuggestionsInput!) {
  advisorSuggestions(input: $input) {
    options {
      _id
      label
    }
    total
  }
}
    `;

/**
 * __useAdvisorSuggestionsQuery__
 *
 * To run a query within a React component, call `useAdvisorSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorSuggestionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdvisorSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<AdvisorSuggestionsQuery, AdvisorSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorSuggestionsQuery, AdvisorSuggestionsQueryVariables>(AdvisorSuggestionsDocument, options);
      }
export function useAdvisorSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorSuggestionsQuery, AdvisorSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorSuggestionsQuery, AdvisorSuggestionsQueryVariables>(AdvisorSuggestionsDocument, options);
        }
export type AdvisorSuggestionsQueryHookResult = ReturnType<typeof useAdvisorSuggestionsQuery>;
export type AdvisorSuggestionsLazyQueryHookResult = ReturnType<typeof useAdvisorSuggestionsLazyQuery>;
export type AdvisorSuggestionsQueryResult = Apollo.QueryResult<AdvisorSuggestionsQuery, AdvisorSuggestionsQueryVariables>;
export const GetFileDocument = gql`
    query getFile($id: String!) {
  getFile(id: $id) {
    ...File
  }
}
    ${FileFragmentDoc}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
      }
export function useGetFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery, GetFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery, GetFileQueryVariables>(GetFileDocument, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQueryHookResult = ReturnType<typeof useGetFileLazyQuery>;
export type GetFileQueryResult = Apollo.QueryResult<GetFileQuery, GetFileQueryVariables>;
export const GooglePlaceSuggestionsDocument = gql`
    query googlePlaceSuggestions($search: String!) {
  searchLocations(query: $search) {
    ...GooglePlaceResult
  }
}
    ${GooglePlaceResultFragmentDoc}`;

/**
 * __useGooglePlaceSuggestionsQuery__
 *
 * To run a query within a React component, call `useGooglePlaceSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGooglePlaceSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGooglePlaceSuggestionsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGooglePlaceSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GooglePlaceSuggestionsQuery, GooglePlaceSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GooglePlaceSuggestionsQuery, GooglePlaceSuggestionsQueryVariables>(GooglePlaceSuggestionsDocument, options);
      }
export function useGooglePlaceSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GooglePlaceSuggestionsQuery, GooglePlaceSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GooglePlaceSuggestionsQuery, GooglePlaceSuggestionsQueryVariables>(GooglePlaceSuggestionsDocument, options);
        }
export type GooglePlaceSuggestionsQueryHookResult = ReturnType<typeof useGooglePlaceSuggestionsQuery>;
export type GooglePlaceSuggestionsLazyQueryHookResult = ReturnType<typeof useGooglePlaceSuggestionsLazyQuery>;
export type GooglePlaceSuggestionsQueryResult = Apollo.QueryResult<GooglePlaceSuggestionsQuery, GooglePlaceSuggestionsQueryVariables>;
export const GetInvitationDocument = gql`
    query getInvitation($input: GetInvitationInput!) {
  invitation(input: $input) {
    ...Invitation
    program {
      ...ProgramDetail
    }
  }
}
    ${InvitationFragmentDoc}
${ProgramDetailFragmentDoc}`;

/**
 * __useGetInvitationQuery__
 *
 * To run a query within a React component, call `useGetInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationQuery, GetInvitationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationQuery, GetInvitationQueryVariables>(GetInvitationDocument, options);
      }
export function useGetInvitationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationQuery, GetInvitationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationQuery, GetInvitationQueryVariables>(GetInvitationDocument, options);
        }
export type GetInvitationQueryHookResult = ReturnType<typeof useGetInvitationQuery>;
export type GetInvitationLazyQueryHookResult = ReturnType<typeof useGetInvitationLazyQuery>;
export type GetInvitationQueryResult = Apollo.QueryResult<GetInvitationQuery, GetInvitationQueryVariables>;
export const ListInvitationsDocument = gql`
    query listInvitations($input: InvitationListInput!) {
  invitations(input: $input) {
    total
    items {
      ...InvitationSummary
    }
  }
}
    ${InvitationSummaryFragmentDoc}`;

/**
 * __useListInvitationsQuery__
 *
 * To run a query within a React component, call `useListInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListInvitationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListInvitationsQuery(baseOptions: Apollo.QueryHookOptions<ListInvitationsQuery, ListInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(ListInvitationsDocument, options);
      }
export function useListInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListInvitationsQuery, ListInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListInvitationsQuery, ListInvitationsQueryVariables>(ListInvitationsDocument, options);
        }
export type ListInvitationsQueryHookResult = ReturnType<typeof useListInvitationsQuery>;
export type ListInvitationsLazyQueryHookResult = ReturnType<typeof useListInvitationsLazyQuery>;
export type ListInvitationsQueryResult = Apollo.QueryResult<ListInvitationsQuery, ListInvitationsQueryVariables>;
export const CreateInvitationDocument = gql`
    mutation createInvitation($input: CreateInvitationInput!) {
  createInvitation(input: $input) {
    ...Invitation
  }
}
    ${InvitationFragmentDoc}`;
export type CreateInvitationMutationFn = Apollo.MutationFunction<CreateInvitationMutation, CreateInvitationMutationVariables>;

/**
 * __useCreateInvitationMutation__
 *
 * To run a mutation, you first call `useCreateInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationMutation, { data, loading, error }] = useCreateInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInvitationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvitationMutation, CreateInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvitationMutation, CreateInvitationMutationVariables>(CreateInvitationDocument, options);
      }
export type CreateInvitationMutationHookResult = ReturnType<typeof useCreateInvitationMutation>;
export type CreateInvitationMutationResult = Apollo.MutationResult<CreateInvitationMutation>;
export type CreateInvitationMutationOptions = Apollo.BaseMutationOptions<CreateInvitationMutation, CreateInvitationMutationVariables>;
export const EditInvitationDocument = gql`
    mutation editInvitation($id: String!, $input: EditInvitationInput!) {
  editInvitation(id: $id, input: $input) {
    ...Invitation
  }
}
    ${InvitationFragmentDoc}`;
export type EditInvitationMutationFn = Apollo.MutationFunction<EditInvitationMutation, EditInvitationMutationVariables>;

/**
 * __useEditInvitationMutation__
 *
 * To run a mutation, you first call `useEditInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editInvitationMutation, { data, loading, error }] = useEditInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditInvitationMutation(baseOptions?: Apollo.MutationHookOptions<EditInvitationMutation, EditInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditInvitationMutation, EditInvitationMutationVariables>(EditInvitationDocument, options);
      }
export type EditInvitationMutationHookResult = ReturnType<typeof useEditInvitationMutation>;
export type EditInvitationMutationResult = Apollo.MutationResult<EditInvitationMutation>;
export type EditInvitationMutationOptions = Apollo.BaseMutationOptions<EditInvitationMutation, EditInvitationMutationVariables>;
export const RemoveInvitationDocument = gql`
    mutation removeInvitation($id: String!) {
  removeInvitation(id: $id)
}
    `;
export type RemoveInvitationMutationFn = Apollo.MutationFunction<RemoveInvitationMutation, RemoveInvitationMutationVariables>;

/**
 * __useRemoveInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitationMutation, { data, loading, error }] = useRemoveInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitationMutation, RemoveInvitationMutationVariables>(RemoveInvitationDocument, options);
      }
export type RemoveInvitationMutationHookResult = ReturnType<typeof useRemoveInvitationMutation>;
export type RemoveInvitationMutationResult = Apollo.MutationResult<RemoveInvitationMutation>;
export type RemoveInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveInvitationMutation, RemoveInvitationMutationVariables>;
export const PreviewInvitationEmailDocument = gql`
    query previewInvitationEmail($input: SendInvitationEmailInput!) {
  previewInvitationEmail(input: $input) {
    totalAlreadyInvited
    totalToSend
  }
}
    `;

/**
 * __usePreviewInvitationEmailQuery__
 *
 * To run a query within a React component, call `usePreviewInvitationEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewInvitationEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewInvitationEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewInvitationEmailQuery(baseOptions: Apollo.QueryHookOptions<PreviewInvitationEmailQuery, PreviewInvitationEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewInvitationEmailQuery, PreviewInvitationEmailQueryVariables>(PreviewInvitationEmailDocument, options);
      }
export function usePreviewInvitationEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewInvitationEmailQuery, PreviewInvitationEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewInvitationEmailQuery, PreviewInvitationEmailQueryVariables>(PreviewInvitationEmailDocument, options);
        }
export type PreviewInvitationEmailQueryHookResult = ReturnType<typeof usePreviewInvitationEmailQuery>;
export type PreviewInvitationEmailLazyQueryHookResult = ReturnType<typeof usePreviewInvitationEmailLazyQuery>;
export type PreviewInvitationEmailQueryResult = Apollo.QueryResult<PreviewInvitationEmailQuery, PreviewInvitationEmailQueryVariables>;
export const SendInvitationEmailDocument = gql`
    mutation sendInvitationEmail($input: SendInvitationEmailInput!) {
  sendInvitationEmail(input: $input)
}
    `;
export type SendInvitationEmailMutationFn = Apollo.MutationFunction<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>;

/**
 * __useSendInvitationEmailMutation__
 *
 * To run a mutation, you first call `useSendInvitationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationEmailMutation, { data, loading, error }] = useSendInvitationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvitationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>(SendInvitationEmailDocument, options);
      }
export type SendInvitationEmailMutationHookResult = ReturnType<typeof useSendInvitationEmailMutation>;
export type SendInvitationEmailMutationResult = Apollo.MutationResult<SendInvitationEmailMutation>;
export type SendInvitationEmailMutationOptions = Apollo.BaseMutationOptions<SendInvitationEmailMutation, SendInvitationEmailMutationVariables>;
export const ProcessInvitationCsvDocument = gql`
    mutation processInvitationCsv($input: ProcessInvitationCsvInput!) {
  processInvitationCsv(input: $input) {
    taskId
  }
}
    `;
export type ProcessInvitationCsvMutationFn = Apollo.MutationFunction<ProcessInvitationCsvMutation, ProcessInvitationCsvMutationVariables>;

/**
 * __useProcessInvitationCsvMutation__
 *
 * To run a mutation, you first call `useProcessInvitationCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessInvitationCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processInvitationCsvMutation, { data, loading, error }] = useProcessInvitationCsvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessInvitationCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessInvitationCsvMutation, ProcessInvitationCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessInvitationCsvMutation, ProcessInvitationCsvMutationVariables>(ProcessInvitationCsvDocument, options);
      }
export type ProcessInvitationCsvMutationHookResult = ReturnType<typeof useProcessInvitationCsvMutation>;
export type ProcessInvitationCsvMutationResult = Apollo.MutationResult<ProcessInvitationCsvMutation>;
export type ProcessInvitationCsvMutationOptions = Apollo.BaseMutationOptions<ProcessInvitationCsvMutation, ProcessInvitationCsvMutationVariables>;
export const ListMailContentsDocument = gql`
    query listMailContents($input: MailContentListInput!) {
  mailContents(input: $input) {
    items {
      ...MailContent
    }
    total
  }
}
    ${MailContentFragmentDoc}`;

/**
 * __useListMailContentsQuery__
 *
 * To run a query within a React component, call `useListMailContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMailContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMailContentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListMailContentsQuery(baseOptions: Apollo.QueryHookOptions<ListMailContentsQuery, ListMailContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMailContentsQuery, ListMailContentsQueryVariables>(ListMailContentsDocument, options);
      }
export function useListMailContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMailContentsQuery, ListMailContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMailContentsQuery, ListMailContentsQueryVariables>(ListMailContentsDocument, options);
        }
export type ListMailContentsQueryHookResult = ReturnType<typeof useListMailContentsQuery>;
export type ListMailContentsLazyQueryHookResult = ReturnType<typeof useListMailContentsLazyQuery>;
export type ListMailContentsQueryResult = Apollo.QueryResult<ListMailContentsQuery, ListMailContentsQueryVariables>;
export const ListCustomMailContentsDocument = gql`
    query listCustomMailContents {
  mailContents(
    input: {paging: {offset: 0, limit: 100}, sort: {field: CustomTitle, direction: "ASC"}, filter: {custom: true}}
  ) {
    items {
      ...MailContent
    }
    total
  }
}
    ${MailContentFragmentDoc}`;

/**
 * __useListCustomMailContentsQuery__
 *
 * To run a query within a React component, call `useListCustomMailContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCustomMailContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCustomMailContentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCustomMailContentsQuery(baseOptions?: Apollo.QueryHookOptions<ListCustomMailContentsQuery, ListCustomMailContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomMailContentsQuery, ListCustomMailContentsQueryVariables>(ListCustomMailContentsDocument, options);
      }
export function useListCustomMailContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomMailContentsQuery, ListCustomMailContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomMailContentsQuery, ListCustomMailContentsQueryVariables>(ListCustomMailContentsDocument, options);
        }
export type ListCustomMailContentsQueryHookResult = ReturnType<typeof useListCustomMailContentsQuery>;
export type ListCustomMailContentsLazyQueryHookResult = ReturnType<typeof useListCustomMailContentsLazyQuery>;
export type ListCustomMailContentsQueryResult = Apollo.QueryResult<ListCustomMailContentsQuery, ListCustomMailContentsQueryVariables>;
export const GetMailContentDocument = gql`
    query getMailContent($type: String!) {
  mailContent(type: $type) {
    ...MailContent
  }
}
    ${MailContentFragmentDoc}`;

/**
 * __useGetMailContentQuery__
 *
 * To run a query within a React component, call `useGetMailContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailContentQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetMailContentQuery(baseOptions: Apollo.QueryHookOptions<GetMailContentQuery, GetMailContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailContentQuery, GetMailContentQueryVariables>(GetMailContentDocument, options);
      }
export function useGetMailContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailContentQuery, GetMailContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailContentQuery, GetMailContentQueryVariables>(GetMailContentDocument, options);
        }
export type GetMailContentQueryHookResult = ReturnType<typeof useGetMailContentQuery>;
export type GetMailContentLazyQueryHookResult = ReturnType<typeof useGetMailContentLazyQuery>;
export type GetMailContentQueryResult = Apollo.QueryResult<GetMailContentQuery, GetMailContentQueryVariables>;
export const UpdateMailContentDocument = gql`
    mutation updateMailContent($input: UpdateMailContentInput!) {
  updateMailContent(input: $input) {
    ...MailContent
  }
}
    ${MailContentFragmentDoc}`;
export type UpdateMailContentMutationFn = Apollo.MutationFunction<UpdateMailContentMutation, UpdateMailContentMutationVariables>;

/**
 * __useUpdateMailContentMutation__
 *
 * To run a mutation, you first call `useUpdateMailContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMailContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMailContentMutation, { data, loading, error }] = useUpdateMailContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMailContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMailContentMutation, UpdateMailContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMailContentMutation, UpdateMailContentMutationVariables>(UpdateMailContentDocument, options);
      }
export type UpdateMailContentMutationHookResult = ReturnType<typeof useUpdateMailContentMutation>;
export type UpdateMailContentMutationResult = Apollo.MutationResult<UpdateMailContentMutation>;
export type UpdateMailContentMutationOptions = Apollo.BaseMutationOptions<UpdateMailContentMutation, UpdateMailContentMutationVariables>;
export const DeleteMailContentDocument = gql`
    mutation deleteMailContent($type: String!) {
  deleteMailContent(type: $type)
}
    `;
export type DeleteMailContentMutationFn = Apollo.MutationFunction<DeleteMailContentMutation, DeleteMailContentMutationVariables>;

/**
 * __useDeleteMailContentMutation__
 *
 * To run a mutation, you first call `useDeleteMailContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailContentMutation, { data, loading, error }] = useDeleteMailContentMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useDeleteMailContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailContentMutation, DeleteMailContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailContentMutation, DeleteMailContentMutationVariables>(DeleteMailContentDocument, options);
      }
export type DeleteMailContentMutationHookResult = ReturnType<typeof useDeleteMailContentMutation>;
export type DeleteMailContentMutationResult = Apollo.MutationResult<DeleteMailContentMutation>;
export type DeleteMailContentMutationOptions = Apollo.BaseMutationOptions<DeleteMailContentMutation, DeleteMailContentMutationVariables>;
export const CreateMailContentDocument = gql`
    mutation createMailContent($input: CreateCustomMailContentInput!) {
  createMailContent(input: $input) {
    ...MailContent
  }
}
    ${MailContentFragmentDoc}`;
export type CreateMailContentMutationFn = Apollo.MutationFunction<CreateMailContentMutation, CreateMailContentMutationVariables>;

/**
 * __useCreateMailContentMutation__
 *
 * To run a mutation, you first call `useCreateMailContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailContentMutation, { data, loading, error }] = useCreateMailContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMailContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailContentMutation, CreateMailContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailContentMutation, CreateMailContentMutationVariables>(CreateMailContentDocument, options);
      }
export type CreateMailContentMutationHookResult = ReturnType<typeof useCreateMailContentMutation>;
export type CreateMailContentMutationResult = Apollo.MutationResult<CreateMailContentMutation>;
export type CreateMailContentMutationOptions = Apollo.BaseMutationOptions<CreateMailContentMutation, CreateMailContentMutationVariables>;
export const BuildCustomTemplateForUserDocument = gql`
    mutation buildCustomTemplateForUser($input: BuildCustomTemplateForUserInput!) {
  buildCustomTemplateForUser(input: $input) {
    locale
    subject
    body
  }
}
    `;
export type BuildCustomTemplateForUserMutationFn = Apollo.MutationFunction<BuildCustomTemplateForUserMutation, BuildCustomTemplateForUserMutationVariables>;

/**
 * __useBuildCustomTemplateForUserMutation__
 *
 * To run a mutation, you first call `useBuildCustomTemplateForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildCustomTemplateForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildCustomTemplateForUserMutation, { data, loading, error }] = useBuildCustomTemplateForUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildCustomTemplateForUserMutation(baseOptions?: Apollo.MutationHookOptions<BuildCustomTemplateForUserMutation, BuildCustomTemplateForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildCustomTemplateForUserMutation, BuildCustomTemplateForUserMutationVariables>(BuildCustomTemplateForUserDocument, options);
      }
export type BuildCustomTemplateForUserMutationHookResult = ReturnType<typeof useBuildCustomTemplateForUserMutation>;
export type BuildCustomTemplateForUserMutationResult = Apollo.MutationResult<BuildCustomTemplateForUserMutation>;
export type BuildCustomTemplateForUserMutationOptions = Apollo.BaseMutationOptions<BuildCustomTemplateForUserMutation, BuildCustomTemplateForUserMutationVariables>;
export const BuildMailContentPreviewDocument = gql`
    mutation buildMailContentPreview($input: BuildMailContentPreviewInput!) {
  buildMailContentPreview(input: $input)
}
    `;
export type BuildMailContentPreviewMutationFn = Apollo.MutationFunction<BuildMailContentPreviewMutation, BuildMailContentPreviewMutationVariables>;

/**
 * __useBuildMailContentPreviewMutation__
 *
 * To run a mutation, you first call `useBuildMailContentPreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildMailContentPreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildMailContentPreviewMutation, { data, loading, error }] = useBuildMailContentPreviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildMailContentPreviewMutation(baseOptions?: Apollo.MutationHookOptions<BuildMailContentPreviewMutation, BuildMailContentPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildMailContentPreviewMutation, BuildMailContentPreviewMutationVariables>(BuildMailContentPreviewDocument, options);
      }
export type BuildMailContentPreviewMutationHookResult = ReturnType<typeof useBuildMailContentPreviewMutation>;
export type BuildMailContentPreviewMutationResult = Apollo.MutationResult<BuildMailContentPreviewMutation>;
export type BuildMailContentPreviewMutationOptions = Apollo.BaseMutationOptions<BuildMailContentPreviewMutation, BuildMailContentPreviewMutationVariables>;
export const MailContentDynamicDataDocument = gql`
    query mailContentDynamicData($emailType: String!) {
  mailContentDynamicData(emailType: $emailType) {
    key
    label
    ejs
    type
  }
}
    `;

/**
 * __useMailContentDynamicDataQuery__
 *
 * To run a query within a React component, call `useMailContentDynamicDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailContentDynamicDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailContentDynamicDataQuery({
 *   variables: {
 *      emailType: // value for 'emailType'
 *   },
 * });
 */
export function useMailContentDynamicDataQuery(baseOptions: Apollo.QueryHookOptions<MailContentDynamicDataQuery, MailContentDynamicDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailContentDynamicDataQuery, MailContentDynamicDataQueryVariables>(MailContentDynamicDataDocument, options);
      }
export function useMailContentDynamicDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailContentDynamicDataQuery, MailContentDynamicDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailContentDynamicDataQuery, MailContentDynamicDataQueryVariables>(MailContentDynamicDataDocument, options);
        }
export type MailContentDynamicDataQueryHookResult = ReturnType<typeof useMailContentDynamicDataQuery>;
export type MailContentDynamicDataLazyQueryHookResult = ReturnType<typeof useMailContentDynamicDataLazyQuery>;
export type MailContentDynamicDataQueryResult = Apollo.QueryResult<MailContentDynamicDataQuery, MailContentDynamicDataQueryVariables>;
export const GetEmailPreferencesDocument = gql`
    query getEmailPreferences {
  getEmailPreferences {
    preferences {
      key
      enabled
    }
  }
}
    `;

/**
 * __useGetEmailPreferencesQuery__
 *
 * To run a query within a React component, call `useGetEmailPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>(GetEmailPreferencesDocument, options);
      }
export function useGetEmailPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>(GetEmailPreferencesDocument, options);
        }
export type GetEmailPreferencesQueryHookResult = ReturnType<typeof useGetEmailPreferencesQuery>;
export type GetEmailPreferencesLazyQueryHookResult = ReturnType<typeof useGetEmailPreferencesLazyQuery>;
export type GetEmailPreferencesQueryResult = Apollo.QueryResult<GetEmailPreferencesQuery, GetEmailPreferencesQueryVariables>;
export const UpdateEmailPreferenceDocument = gql`
    mutation updateEmailPreference($input: UpdateEmailPreferenceInput!) {
  updateEmailPreference(input: $input) {
    preferences {
      key
      enabled
    }
  }
}
    `;
export type UpdateEmailPreferenceMutationFn = Apollo.MutationFunction<UpdateEmailPreferenceMutation, UpdateEmailPreferenceMutationVariables>;

/**
 * __useUpdateEmailPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateEmailPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailPreferenceMutation, { data, loading, error }] = useUpdateEmailPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailPreferenceMutation, UpdateEmailPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailPreferenceMutation, UpdateEmailPreferenceMutationVariables>(UpdateEmailPreferenceDocument, options);
      }
export type UpdateEmailPreferenceMutationHookResult = ReturnType<typeof useUpdateEmailPreferenceMutation>;
export type UpdateEmailPreferenceMutationResult = Apollo.MutationResult<UpdateEmailPreferenceMutation>;
export type UpdateEmailPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateEmailPreferenceMutation, UpdateEmailPreferenceMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications {
    ...Notification
  }
}
    ${NotificationFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNotificationCountDocument = gql`
    query getNotificationCount {
  unreadNotificationsCount
}
    `;

/**
 * __useGetNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationCountQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationCountQuery, GetNotificationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>(GetNotificationCountDocument, options);
      }
export function useGetNotificationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationCountQuery, GetNotificationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>(GetNotificationCountDocument, options);
        }
export type GetNotificationCountQueryHookResult = ReturnType<typeof useGetNotificationCountQuery>;
export type GetNotificationCountLazyQueryHookResult = ReturnType<typeof useGetNotificationCountLazyQuery>;
export type GetNotificationCountQueryResult = Apollo.QueryResult<GetNotificationCountQuery, GetNotificationCountQueryVariables>;
export const MarkAllNotificationsAsReadDocument = gql`
    mutation markAllNotificationsAsRead {
  markAllNotificationsAsRead
}
    `;
export type MarkAllNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;

/**
 * __useMarkAllNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllNotificationsAsReadMutation, { data, loading, error }] = useMarkAllNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument, options);
      }
export type MarkAllNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationResult = Apollo.MutationResult<MarkAllNotificationsAsReadMutation>;
export type MarkAllNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const ListProductsDocument = gql`
    query listProducts($search: String!) {
  listProducts(search: $search) {
    items {
      stripeId
      name
      description
      price
    }
    total
  }
}
    `;

/**
 * __useListProductsQuery__
 *
 * To run a query within a React component, call `useListProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useListProductsQuery(baseOptions: Apollo.QueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
      }
export function useListProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProductsQuery, ListProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProductsQuery, ListProductsQueryVariables>(ListProductsDocument, options);
        }
export type ListProductsQueryHookResult = ReturnType<typeof useListProductsQuery>;
export type ListProductsLazyQueryHookResult = ReturnType<typeof useListProductsLazyQuery>;
export type ListProductsQueryResult = Apollo.QueryResult<ListProductsQuery, ListProductsQueryVariables>;
export const GetSavedQueriesDocument = gql`
    query getSavedQueries($key: SavedQueryKey!) {
  getSavedQueries(key: $key) {
    label
    shared
    querystring
    createdByUserId
  }
}
    `;

/**
 * __useGetSavedQueriesQuery__
 *
 * To run a query within a React component, call `useGetSavedQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedQueriesQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSavedQueriesQuery(baseOptions: Apollo.QueryHookOptions<GetSavedQueriesQuery, GetSavedQueriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedQueriesQuery, GetSavedQueriesQueryVariables>(GetSavedQueriesDocument, options);
      }
export function useGetSavedQueriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedQueriesQuery, GetSavedQueriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedQueriesQuery, GetSavedQueriesQueryVariables>(GetSavedQueriesDocument, options);
        }
export type GetSavedQueriesQueryHookResult = ReturnType<typeof useGetSavedQueriesQuery>;
export type GetSavedQueriesLazyQueryHookResult = ReturnType<typeof useGetSavedQueriesLazyQuery>;
export type GetSavedQueriesQueryResult = Apollo.QueryResult<GetSavedQueriesQuery, GetSavedQueriesQueryVariables>;
export const UpsertSavedQueryDocument = gql`
    mutation upsertSavedQuery($input: SavedQueryInput!) {
  upsertSavedQuery(input: $input) {
    label
    shared
    querystring
  }
}
    `;
export type UpsertSavedQueryMutationFn = Apollo.MutationFunction<UpsertSavedQueryMutation, UpsertSavedQueryMutationVariables>;

/**
 * __useUpsertSavedQueryMutation__
 *
 * To run a mutation, you first call `useUpsertSavedQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSavedQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSavedQueryMutation, { data, loading, error }] = useUpsertSavedQueryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSavedQueryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSavedQueryMutation, UpsertSavedQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSavedQueryMutation, UpsertSavedQueryMutationVariables>(UpsertSavedQueryDocument, options);
      }
export type UpsertSavedQueryMutationHookResult = ReturnType<typeof useUpsertSavedQueryMutation>;
export type UpsertSavedQueryMutationResult = Apollo.MutationResult<UpsertSavedQueryMutation>;
export type UpsertSavedQueryMutationOptions = Apollo.BaseMutationOptions<UpsertSavedQueryMutation, UpsertSavedQueryMutationVariables>;
export const DeleteSavedQueryDocument = gql`
    mutation deleteSavedQuery($key: SavedQueryKey!, $label: String!) {
  deleteSavedQuery(key: $key, label: $label)
}
    `;
export type DeleteSavedQueryMutationFn = Apollo.MutationFunction<DeleteSavedQueryMutation, DeleteSavedQueryMutationVariables>;

/**
 * __useDeleteSavedQueryMutation__
 *
 * To run a mutation, you first call `useDeleteSavedQueryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedQueryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedQueryMutation, { data, loading, error }] = useDeleteSavedQueryMutation({
 *   variables: {
 *      key: // value for 'key'
 *      label: // value for 'label'
 *   },
 * });
 */
export function useDeleteSavedQueryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedQueryMutation, DeleteSavedQueryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedQueryMutation, DeleteSavedQueryMutationVariables>(DeleteSavedQueryDocument, options);
      }
export type DeleteSavedQueryMutationHookResult = ReturnType<typeof useDeleteSavedQueryMutation>;
export type DeleteSavedQueryMutationResult = Apollo.MutationResult<DeleteSavedQueryMutation>;
export type DeleteSavedQueryMutationOptions = Apollo.BaseMutationOptions<DeleteSavedQueryMutation, DeleteSavedQueryMutationVariables>;